{
  "% к прошлой неделе": "% respecto a la semana pasada",
  ". STEOS ID и финансовые квитанции сохраняются.": ". El STEOS ID y los comprobantes financieros se conservan.",
  ". Готовые голоса доступны в разделе «Озвучка» → «Мои».": ". Las voces listas están disponibles en la sección «Voz en off» → «Mías».",
  ". Он не меняет голос озвучки чата.": ". No cambia la voz de lectura del chat.",
  ". После подтверждения обновите профиль.": ". Después de confirmar, actualiza el perfil.",
  ". Проверьте папку «Спам».": ". Revisa la carpeta «Spam».",
  "Circle каждый месяц по подписке": "Circle por suscripción mensual",
  "Circle по подписке на этот месяц потрачены": "Los Circle del plan de este mes se agotaron",
  "STEOS ID · {0}": "STEOS ID · {0}",
  "STEOS ID · Не подключён": "STEOS ID · No conectado",
  "Telegram ID скопирован.": "ID de Telegram copiado.",
  "{0} {1} C сгорят {2}": "{0} {1} C caducarán el {2}",
  "{0} из {1}": "{0} de {1}",
  "{0} фото хватит для сходства": "{0} fotos son suficientes para lograr el parecido",
  "{0}: {1} работ": "{0}: {1} trabajos",
  "{0}: пока недоступно": "{0}: aún no disponible",
  "· Вы и варианты": "· Tú y las variantes",
  "· Новое": "· Nuevo",
  "· занято": "· ocupado",
  "· отменена": "· cancelada",
  "». Обучение начнётся после отдельного нажатия «Повторить обработку» в карточке.": "». El entrenamiento comenzará después de pulsar «Reprocesar» por separado en la tarjeta.",
  "Автовоспроизведение примеров": "Reproducción automática de ejemplos",
  "Аккаунт": "Cuenta",
  "Аккаунт подключён": "Cuenta conectada",
  "Архив недоступен или срок ссылки истёк. Можно запросить новую выгрузку.": "El archivo de exportación no está disponible o el enlace ha caducado. Puedes solicitar una nueva exportación.",
  "Бабушка": "Abuela",
  "Баланс и вывод доступны в STEOS ID.": "El saldo y los retiros están disponibles en STEOS ID.",
  "Баланс и награды": "Saldo y recompensas",
  "Без имени": "Sin nombre",
  "Бесплатный план": "Plan gratuito",
  "Ближайшие": "Próximos",
  "Близкие": "Seres queridos",
  "Близкий исчезнет из профиля. Его фото больше не будут доступны для новых работ.": "Esta persona desaparecerá del perfil. Sus fotos ya no estarán disponibles para nuevos trabajos.",
  "Близкий удалён.": "Persona cercana eliminada.",
  "Близких пока нет.": "Todavía no hay personas cercanas.",
  "Брат": "Hermano",
  "В Steos с": "En Steos desde",
  "В избранное": "Añadir a favoritos",
  "Валюта": "Moneda",
  "Вариант будет удалён. Исходные фото и STEOS ID сохранятся.": "La variante se eliminará. Las fotos originales y el STEOS ID se conservarán.",
  "Вариантов: {0}": "Variantes: {0}",
  "Варианты": "Variantes",
  "Ваш собственный голос": "Tu propia voz",
  "Введите УДАЛИТЬ": "Escribe УДАЛИТЬ",
  "Введите пароль": "Introduce la contraseña",
  "Введите почту": "Introduce el correo electrónico",
  "Вернуться ко входу": "Volver al inicio de sesión",
  "Версия": "Versión",
  "Версия согласия изменилась. Обновите страницу и подтвердите актуальный текст.": "La versión del consentimiento ha cambiado. Actualiza la página y confirma el texto vigente.",
  "Версия согласия изменилась. Обновите страницу.": "La versión del consentimiento ha cambiado. Actualiza la página.",
  "Версия:": "Versión:",
  "Взрослый": "Adulto",
  "Включаем микрофон…": "Activando el micrófono…",
  "Включено": "Activado",
  "Возраст": "Edad",
  "Войти": "Iniciar sesión",
  "Восстановить пароль": "Restablecer contraseña",
  "Все Circle на балансе без срока": "Tus Circle no caducan",
  "Вы": "Tú",
  "Вы и близкие": "Tú y las personas cercanas",
  "Вы и варианты": "Tú y tus looks",
  "Выберите голос": "Seleccionar voz",
  "Выберите инструмент и заполните его форму. Готовая работа сохранится в истории.": "Selecciona una herramienta y completa su formulario. El trabajo terminado se guardará en el historial.",
  "Выбран": "Seleccionado",
  "Выбрать голос": "Elegir voz",
  "Выбрать голос по умолчанию": "Elegir voz predeterminada",
  "Выбрать из работ": "Elegir de los trabajos",
  "Выгрузить мои данные": "Exportar mis datos",
  "Выгрузка:": "Exportación:",
  "Выключено": "Desactivado",
  "Голос": "Voz",
  "Голос готов. Он доступен на вкладке «Мои» в озвучке.": "La voz está lista. Está disponible en la pestaña «Mías» de voz en off.",
  "Голос и клон": "Voz y clon",
  "Голос изменился. Данные обновлены — проверьте их перед сохранением.": "La voz ha cambiado. Los datos se han actualizado; revísalos antes de guardar.",
  "Голос изменился. Проверьте обновлённые данные перед повторной обработкой.": "La voz ha cambiado. Revisa los datos actualizados antes de volver a procesar.",
  "Голос исчезнет из вашего списка. Это действие нельзя отменить.": "La voz desaparecerá de tu lista. Esta acción no se puede deshacer.",
  "Голос по умолчанию для создания:": "Voz predeterminada para crear:",
  "Голос принят в обработку. Здесь появится его статус.": "La voz se ha enviado a procesamiento. Aquí aparecerá su estado.",
  "Голос уже удалён или недоступен.": "La voz ya se ha eliminado o no está disponible.",
  "Голос:": "Voz:",
  "Голоса не найдены. Откройте каталог или измените поиск.": "No se encontraron voces. Abre el catálogo o modifica la búsqueda.",
  "Горизонтальное": "Horizontal",
  "Готов": "Listo",
  "Готовим образцы": "Preparando muestras",
  "Готово": "Hecho",
  "Готовые работы": "Trabajos listos",
  "Далее": "Siguiente",
  "Данные Telegram обновлены.": "Datos de Telegram actualizados.",
  "Данные баланса временно недоступны": "Los datos del saldo no están disponibles temporalmente",
  "Данные переносятся в подтверждённый аккаунт. Старые сессии закрыты; квитанция позволяет продолжить проверку после перезагрузки.": "Los datos se están transfiriendo a la cuenta confirmada. Las sesiones antiguas se han cerrado; el comprobante permite continuar la verificación después de recargar.",
  "Дедушка": "Abuelo",
  "До 5 фото: лицо крупно, при хорошем свете": "Hasta 5 fotos: rostro en primer plano y buena iluminación",
  "До пяти фото. Они будут использоваться как ваш образ.": "Hasta cinco fotos. Se utilizarán como tu imagen.",
  "Добавить близкого": "Añadir persona cercana",
  "Добавить фото": "Añadir foto",
  "Добавьте ещё": "Añade más",
  "Добавьте от 2 секунд до 1,5 минуты вашей речи. Говорите естественно, без музыки и других голосов.": "Añade entre 2 segundos y 1,5 minutos de tu voz. Habla con naturalidad, sin música ni otras voces.",
  "Дочь": "Hija",
  "Друг": "Amigo",
  "Если аккаунт существует, ссылка для нового пароля отправлена на": "Si la cuenta existe, se ha enviado un enlace para crear una nueva contraseña a",
  "Ещё варианты": "Más variantes",
  "Ещё операции": "Más operaciones",
  "Ещё работы": "Más trabajos",
  "Жена": "Esposa",
  "ЗАМЕНА ОБРАЗЦОВ": "SUSTITUCIÓN DE MUESTRAS",
  "Забыли пароль?": "¿Olvidaste la contraseña?",
  "Загружаем аккаунт…": "Cargando cuenta…",
  "Загружаем варианты…": "Cargando variantes…",
  "Загружаем ваши голоса…": "Cargando tus voces…",
  "Загружаем голоса…": "Cargando voces…",
  "Загружаем настройки…": "Cargando ajustes…",
  "Загружаем обновления…": "Cargando actualizaciones…",
  "Загружаем операции…": "Cargando operaciones…",
  "Загружаем пример…": "Cargando ejemplo…",
  "Загружаем работы…": "Cargando trabajos…",
  "Загружаем фото…": "Cargando fotos…",
  "Загрузить аудиофайлы": "Subir archivos de audio",
  "Загрузить выбранные фото": "Subir fotos seleccionadas",
  "Загрузка ещё не подтверждена. Нажмите «Продолжить отправку»: сначала проверим прежнюю загрузку.": "La carga aún no se ha confirmado. Pulsa «Continuar envío»: primero comprobaremos la carga anterior.",
  "Загрузка не подтверждена. Продолжение сначала проверит прежние загрузки.": "La carga no se ha confirmado. Al continuar, primero se comprobarán las cargas anteriores.",
  "Загрузка отклонена. Нажмите «Продолжить отправку», чтобы получить новую ссылку и загрузить образец.": "La carga ha sido rechazada. Pulsa «Continuar envío» para obtener un nuevo enlace y subir la muestra.",
  "Закрыть": "Cerrar",
  "Закрыть мастер": "Cerrar asistente",
  "Заменить образцы": "Sustituir muestras",
  "Записать с микрофона": "Grabar con el micrófono",
  "Запись": "Grabación",
  "Запись здесь недоступна. Откройте приложение по HTTPS или загрузите аудиофайл.": "La grabación no está disponible aquí. Abre la aplicación mediante HTTPS o sube un archivo de audio.",
  "Запись прервалась. Попробуйте ещё раз или загрузите файл.": "La grabación se interrumpió. Inténtalo de nuevo o sube un archivo.",
  "Запись-{0}.{1}": "Grabación-{0}.{1}",
  "Запишите образец, дождитесь обучения и озвучивайте текст своим голосом.": "Graba una muestra, espera a que termine el entrenamiento y lee textos con tu propia voz.",
  "Запишите речь или загрузите аудиофайлы": "Graba tu voz o sube archivos de audio",
  "Запишите свой голос один раз — используйте его в озвучке.": "Graba tu voz una vez y úsala para la lectura en voz alta.",
  "Запрос сохранён. Продолжение проверит прежний запрос и не создаст второй голос.": "La solicitud se ha guardado. Al continuar, se comprobará la solicitud anterior y no se creará una segunda voz.",
  "Запустить обработку": "Iniciar procesamiento",
  "Здесь появятся ваши работы": "Tus trabajos aparecerán aquí",
  "Из них": "De ellos",
  "Из них {0} C можно вывести": "De ellos, puedes retirar {0} C",
  "Избранное": "Favoritos",
  "Избранные работы": "Trabajos favoritos",
  "Изменение не подтверждено. Проверьте актуальную карточку перед повтором.": "El cambio no se ha confirmado. Revisa la tarjeta actual antes de volver a intentarlo.",
  "Изменить": "Editar",
  "Изменить близкого": "Editar persona cercana",
  "Изменить вариант": "Editar variante",
  "Изменить голос": "Cambiar voz",
  "Изменить мои фото": "Cambiar mis fotos",
  "Имя близкого": "Nombre de la persona cercana",
  "Имя голоса": "Nombre de la voz",
  "Имя пользователя не задано": "No se ha establecido el nombre de usuario",
  "Использовать как себя": "Usar como yo",
  "Используем сохранённые образцы голоса «": "Usando las muestras de voz guardadas de «",
  "Используйте свои фото и фото близких в инструментах студии.": "Usa tus fotos y las de tus personas cercanas en las herramientas del estudio.",
  "История очищена: {0} работ, {1} заказов.": "Historial borrado: {0} trabajos, {1} pedidos.",
  "КЛОН ГОЛОСА": "CLON DE VOZ",
  "Каждый образец должен содержать хотя бы одну секунду речи.": "Cada muestra debe contener al menos un segundo de voz.",
  "Как в системе": "Como en el sistema",
  "Как пользоваться": "Cómo usarlo",
  "Как снимать": "Cómo hacer fotos",
  "Каталог голосов": "Catálogo de voces",
  "Квадрат": "Cuadrado",
  "Кем приходится": "Parentesco",
  "Ко входу": "Ir al inicio de sesión",
  "Количество вариантов пока недоступно": "La cantidad de variantes aún no está disponible",
  "Конфиденциальность": "Privacidad",
  "Копирование недоступно. ID показан в карточке аккаунта.": "No se puede copiar. El ID aparece en la tarjeta de la cuenta.",
  "Кружок с героем": "Videomensaje con personaje",
  "Лимит {0} голосов выбран": "Se ha alcanzado el límite de {0} voces",
  "Лимит голосов выбран. Удалите ненужный голос, чтобы добавить новый.": "Se ha alcanzado el límite de voces. Elimina una voz que no necesites para añadir otra.",
  "Лимит:": "Límite:",
  "Мама": "Mamá",
  "Можно добавить до {0} образцов.": "Puedes añadir hasta {0} muestras.",
  "Можно закрыть приложение. Статус обновится после обработки.": "Puedes cerrar la aplicación. El estado se actualizará después del procesamiento.",
  "Мои варианты": "Mis variantes",
  "Мои голоса": "Mis voces",
  "Мои данные": "Mis datos",
  "Мои фото": "Mis fotos",
  "Моё": "Mío",
  "Моё фото": "Mi foto",
  "Муж": "Esposo",
  "НОВЫЙ ГОЛОС": "VOZ NUEVA",
  "Награды": "Recompensas",
  "Награды и задания": "Recompensas y tareas",
  "Назад": "Atrás",
  "Название варианта": "Nombre de la variante",
  "Назначить голос": "Asignar voz",
  "Настройки": "Ajustes",
  "Настройки уже изменились. Показана актуальная версия.": "Los ajustes ya han cambiado. Se muestra la versión actual.",
  "Начните с 2 секунд речи в тихом месте.": "Empieza con 2 segundos de voz en un lugar tranquilo.",
  "Не больше 5 фото JPEG или PNG, до 10 МБ каждое.": "Hasta 5 fotos JPEG o PNG, de hasta 10 MB cada una.",
  "Не задано": "No especificado",
  "Не короче 8 знаков": "Al menos 8 caracteres",
  "Не удалось включить микрофон. Разрешите доступ или загрузите файл.": "No se pudo activar el micrófono. Permite el acceso o sube un archivo.",
  "Не удалось войти. Откройте приложение из Telegram заново.": "No se pudo iniciar sesión. Vuelve a abrir la aplicación desde Telegram.",
  "Не удалось воспроизвести пример. Откройте карточку заново и попробуйте ещё раз.": "No se pudo reproducir el ejemplo. Vuelve a abrir la tarjeta e inténtalo de nuevo.",
  "Не удалось загрузить варианты.": "No se pudieron cargar las variantes.",
  "Не удалось загрузить голоса. Измените поиск или вкладку, чтобы повторить.": "No se pudieron cargar las voces. Cambia la búsqueda o la pestaña para volver a intentarlo.",
  "Не удалось загрузить настройки. Попробуйте обновить.": "No se pudieron cargar los ajustes. Intenta actualizar.",
  "Не удалось загрузить работы.": "No se pudieron cargar los trabajos.",
  "Не удалось загрузить следующую страницу.": "No se pudo cargar la página siguiente.",
  "Не удалось загрузить следующую страницу. Попробуйте ещё раз.": "No se pudo cargar la página siguiente. Inténtalo de nuevo.",
  "Не удалось обновить данные из Telegram. Попробуйте позже.": "No se pudieron actualizar los datos de Telegram. Inténtalo más tarde.",
  "Не удалось подтвердить изменение избранного. Обновите профиль.": "No se pudo confirmar el cambio de favoritos. Actualiza el perfil.",
  "Не удалось подтвердить операцию. Проверьте состояние аккаунта перед повтором.": "No se pudo confirmar la operación. Comprueba el estado de la cuenta antes de volver a intentarlo.",
  "Не удалось подтвердить сохранение. Обновите настройки перед повтором.": "No se pudo confirmar el guardado. Actualiza los ajustes antes de volver a intentarlo.",
  "Не удалось подтвердить удаление близкого. Обновите профиль.": "No se pudo confirmar la eliminación de la persona cercana. Actualiza el perfil.",
  "Не удалось получить ответ. Попробуйте ещё раз — запрос продолжится с прежним ключом.": "No se pudo obtener una respuesta. Inténtalo de nuevo: la solicitud continuará con la misma clave.",
  "Не удалось проверить выгрузку. Обновите страницу: продолжим прежнюю операцию.": "No se pudo verificar la exportación. Actualiza la página: continuaremos la operación anterior.",
  "Не удалось прочитать запись.": "No se pudo leer la grabación.",
  "Не удалось создать голос. Откройте карточку, чтобы проверить статус или повторить обработку.": "No se pudo crear la voz. Abre la tarjeta para comprobar el estado o volver a procesarla.",
  "Не удалось создать голос. Проверьте данные и образцы.": "No se pudo crear la voz. Comprueba los datos y las muestras.",
  "Не удалось сохранить просмотр. Можно закрыть и вернуться позже.": "No se pudo guardar la visualización. Puedes cerrar y volver más tarde.",
  "Неверная почта или пароль": "Correo electrónico o contraseña incorrectos",
  "Нет работ": "No hay trabajos",
  "Новая выгрузка": "Nueva exportación",
  "Новости": "Noticias",
  "Новый вариант": "Nueva variante",
  "Новый голос": "Nueva voz",
  "Новых публикаций пока нет.": "Todavía no hay publicaciones nuevas.",
  "Нужно от 2 секунд до 1,5 минуты речи в сумме.": "Se necesitan entre 2 segundos y 1,5 minutos de voz en total.",
  "О приложении": "Acerca de la aplicación",
  "Обновить": "Actualizar",
  "Обновить варианты": "Actualizar variantes",
  "Обновить из Telegram": "Actualizar desde Telegram",
  "Обновить настройки": "Actualizar ajustes",
  "Обновить профиль": "Actualizar perfil",
  "Обновить работы": "Actualizar trabajos",
  "Обновления": "Actualizaciones",
  "Обновляем вход…": "Actualizando inicio de sesión…",
  "Обрабатывается": "En procesamiento",
  "Образ готов": "Imagen lista",
  "Образ ещё не собран": "La imagen aún no se ha creado",
  "Образец {0}": "Muestra {0}",
  "Образец голоса": "Muestra de voz",
  "Образец ещё не проверен. Подождите и продолжите отправку.": "La muestra aún no se ha verificado. Espera y continúa el envío.",
  "Образец не прошёл проверку. Выберите другую запись.": "La muestra no ha superado la verificación. Selecciona otra grabación.",
  "Образцы готовы к повторной обработке.": "Las muestras están listas para volver a procesarse.",
  "Образцы для «": "Muestras para «",
  "Образцы обновлены. Нажмите «Повторить обработку», чтобы обучить голос заново.": "Las muestras se han actualizado. Pulsa «Reprocesar» para entrenar la voz de nuevo.",
  "Обучаем голос": "Entrenando la voz",
  "Общая длительность образцов не должна превышать 1,5 минуты.": "La duración total de las muestras no debe superar los 1,5 minutos.",
  "Объединение STEOS ID": "Fusión de STEOS ID",
  "Объединяем аккаунты": "Fusionando cuentas",
  "Объём образцов": "Duración de las muestras",
  "Один аккаунт для бота и сайта STEOS": "Una cuenta para el bot y el sitio web de STEOS",
  "Озвучить текст голосом «": "Leer el texto con la voz «",
  "Операции": "Operaciones",
  "Операции в токенах STEOS ID": "Operaciones en tokens de STEOS ID",
  "Операции временно недоступны.": "Las operaciones no están disponibles temporalmente.",
  "Операций пока нет.": "Todavía no hay operaciones.",
  "Операция не подтверждена. Повтор использует прежний ключ.": "La operación no se ha confirmado. Al repetirla se utilizará la misma clave.",
  "Описание": "Descripción",
  "Описание и согласие": "Descripción y consentimiento",
  "Остановить запись ·": "Detener la grabación ·",
  "Остаток Circle недоступен": "El saldo de Circle no está disponible",
  "Отклик": "Respuesta háptica",
  "Откройте ссылку из письма и задайте новый пароль на id.steos.io. Потом войдите здесь.": "Abre el enlace del correo electrónico y establece una nueva contraseña en id.steos.io. Después, inicia sesión aquí.",
  "Откройте ссылку подтверждения для": "Abre el enlace de confirmación para",
  "Открыть id.steos.io": "Abrir id.steos.io",
  "Открыть историю": "Abrir historial",
  "Отмена": "Cancelar",
  "Отметьте согласие с условиями": "Acepta las condiciones",
  "Отправить ссылку": "Enviar enlace",
  "Отправляем…": "Enviando…",
  "Оформить подписку": "Suscribirse",
  "Оформление": "Apariencia",
  "Очистить историю": "Borrar historial",
  "Очистить историю?": "¿Borrar el historial?",
  "Очистка не подтверждена. Повтор проверит прежнюю операцию.": "El borrado no se ha confirmado. Al repetirlo, se comprobará la operación anterior.",
  "Очищаем…": "Borrando…",
  "Ошибка": "Error",
  "Папа": "Papá",
  "Пароль": "Contraseña",
  "Переименовать вариант": "Cambiar nombre de la variante",
  "Перенос ещё не подтверждён. Квитанция сохранена; проверка продолжится.": "La transferencia aún no se ha confirmado. El comprobante se ha guardado; la verificación continuará.",
  "Перенос завершён, обновляем вход…": "Transferencia completada; actualizando inicio de sesión…",
  "Переносим данные в существующий STEOS ID. После переноса приложение обновит сессию. Не запускайте повторное объединение.": "Transfiriendo datos a un STEOS ID existente. Después de la transferencia, la aplicación actualizará la sesión. No vuelvas a iniciar la fusión.",
  "Письмо отправлено": "Correo enviado",
  "Питомец": "Mascota",
  "Повторить загрузку": "Reintentar la carga",
  "Повторить обработку": "Reprocesar",
  "Подготовить ZIP для скачивания": "Preparar ZIP para descargar",
  "Поддержка": "Soporte",
  "Подключение STEOS ID сейчас недоступно. Попробуйте позже или откройте сайт STEOS ID.": "La conexión de STEOS ID no está disponible en este momento. Inténtalo más tarde o abre el sitio web de STEOS ID.",
  "Подключён": "Conectado",
  "Подключён:": "Conectado:",
  "Подруга": "Amiga",
  "Подтвердите почту": "Confirma tu correo electrónico",
  "Подтвердите согласие перед отправкой образцов.": "Confirma el consentimiento antes de enviar las muestras.",
  "Подтвердить очистку истории": "Confirmar borrado del historial",
  "Подтвердить удаление": "Confirmar eliminación",
  "Подтвердить удаление аккаунта": "Confirmar eliminación de la cuenta",
  "Подтвердить удаление близкого": "Confirmar eliminación de la persona cercana",
  "Подтвердить удаление варианта": "Confirmar eliminación de la variante",
  "Поиск голоса": "Buscar voz",
  "Поиск по имени": "Buscar por nombre",
  "Пока нет своих голосов": "Todavía no tienes voces propias",
  "Показать ещё": "Mostrar más",
  "Показать ещё голоса": "Mostrar más voces",
  "Показать пароль": "Mostrar contraseña",
  "Пополнить": "Añadir saldo",
  "Попробовать": "Probar",
  "Портрет": "Retrato",
  "Пост": "Publicación",
  "Потрачено Circle:": "Circle gastados:",
  "Почта": "Correo electrónico",
  "Почта уже занята": "El correo electrónico ya está en uso",
  "Почта уже занята, войдите с ней": "El correo electrónico ya está en uso; inicia sesión con él",
  "Привет! Это запись для моего голоса. Я говорю спокойно и в обычном темпе, как в разговоре с другом. Расскажу, как прошёл мой день, что меня порадовало и какие планы у меня на завтра. Продолжайте говорить своими словами не меньше тридцати секунд.": "¡Hola! Esta es una grabación para crear mi voz. Hablo con calma y a un ritmo normal, como cuando converso con un amigo. Voy a contar cómo ha sido mi día, qué cosas me han alegrado y qué planes tengo para mañana. Sigue hablando con tus propias palabras durante al menos treinta segundos.",
  "Приглашайте друзей": "Invita a tus amigos",
  "Пример голоса {0}": "Ejemplo de voz {0}",
  "Принимаю": "Acepto",
  "Присылать готовые работы в чат": "Enviar los trabajos terminados al chat",
  "Проверен": "Verificado",
  "Проверить выгрузку": "Verificar exportación",
  "Проверить подтверждение": "Verificar confirmación",
  "Проверка голоса не пройдена. Запишите образец без музыки и других людей.": "La voz no ha superado la verificación. Graba una muestra sin música ni otras personas.",
  "Проверка образцов не пройдена. Попробуйте чистую запись одного голоса.": "Las muestras no han superado la verificación. Intenta hacer una grabación limpia con una sola voz.",
  "Проверьте адрес": "Comprueba la dirección",
  "Проверяем запись": "Comprobando la grabación",
  "Проверяем образец {0} из {1}…": "Comprobando la muestra {0} de {1}…",
  "Проверяем состояние переноса…": "Comprobando el estado de la transferencia…",
  "Проверяем…": "Comprobando…",
  "Проверяйте остаток в профиле и получайте доступные награды.": "Consulta el saldo en tu perfil y recibe las recompensas disponibles.",
  "Продолжим проверку прежнего запроса, без повторного запуска.": "Continuaremos comprobando la solicitud anterior, sin iniciarla de nuevo.",
  "Продолжим сохранённый запрос с теми же данными.": "Continuaremos la solicitud guardada con los mismos datos.",
  "Продолжить отправку": "Continuar envío",
  "Продолжить проверку": "Continuar verificación",
  "Продолжить создание голоса": "Continuar creación de voz",
  "Продолжить сохранение": "Continuar guardado",
  "Прослушать {0}": "Escuchar {0}",
  "Профиль": "Perfil",
  "Профиль «Вы» пока недоступен.": "El perfil «Tú» aún no está disponible.",
  "Профиль уже изменился. Закройте форму и откройте актуальную версию.": "El perfil ya ha cambiado. Cierra el formulario y abre la versión actual.",
  "Работ в этом списке пока нет.": "Todavía no hay trabajos en esta lista.",
  "Работа №": "Trabajo n.º",
  "Работы и параметры заказов исчезнут из истории. Голоса, варианты «Вы» и близкие останутся. Финансовые квитанции сохраняются. Вернуть историю нельзя.": "Los trabajos y los parámetros de los pedidos desaparecerán del historial. Las voces, las variantes «Tú» y las personas cercanas se conservarán. Los comprobantes financieros se conservarán. No se puede recuperar el historial.",
  "Работы по неделям": "Trabajos por semana",
  "Раздел профиля": "Sección del perfil",
  "Разделы профиля": "Secciones del perfil",
  "Размер каждого образца должен быть от 1 байта до 20 МБ.": "El tamaño de cada muestra debe ser de entre 1 byte y 20 MB.",
  "Ребёнок": "Niño",
  "Результат обработки уточняется. Повторный запуск пока недоступен.": "El resultado del procesamiento aún se está determinando. Por ahora no se puede volver a iniciar.",
  "Русский": "Русский",
  "С": "Desde",
  "Сбросить голос по умолчанию": "Restablecer voz predeterminada",
  "Светлая": "Claro",
  "Свой аватар": "Avatar propio",
  "Сгорят {0}, если не потратить": "Caducan el {0} si no los gastas",
  "Сделать кружок": "Crear videomensaje",
  "Серия:": "Serie:",
  "Сестра": "Hermana",
  "Скачать ZIP": "Descargar ZIP",
  "Скопировать Telegram ID": "Copiar ID de Telegram",
  "Скорость речи": "Velocidad del habla",
  "Скрыть пароль": "Ocultar contraseña",
  "Слишком много запросов. Подождите немного и попробуйте ещё раз.": "Demasiadas solicitudes. Espera un poco e inténtalo de nuevo.",
  "Слишком много попыток. Попробуйте позже.": "Demasiados intentos. Inténtalo más tarde.",
  "Снимайте лицо без фильтров и тёмных очков, при ровном освещении. Добавьте разные ракурсы. В кадре должен быть один человек.": "Fotografía el rostro sin filtros ni gafas oscuras, con una iluminación uniforme. Añade distintos ángulos. Debe aparecer una sola persona en el encuadre.",
  "Снять голос": "Grabar voz",
  "Снять фото": "Hacer foto",
  "Согласие изменилось до начала обучения. Обновите страницу и подтвердите актуальную версию перед повторной обработкой.": "El consentimiento ha cambiado antes de comenzar el entrenamiento. Actualiza la página y confirma la versión vigente antes de volver a procesar.",
  "Создавайте говорящие кружки с выбранным персонажем или своим образом.": "Crea vídeos circulares con el personaje seleccionado o con tu propia imagen.",
  "Создание": "Creación",
  "Создание голосов временно недоступно. Образцы сохранены в этом окне.": "La creación de voces no está disponible temporalmente. Las muestras se han guardado en esta ventana.",
  "Создание новых голосов пока недоступно. Уже созданные голоса доступны ниже.": "La creación de voces nuevas no está disponible por ahora. Las voces ya creadas aparecen abajo.",
  "Создано:": "Creado:",
  "Создан {0}": "Creado el {0}",
  "Создать аккаунт": "Crear cuenta",
  "Создать голос": "Crear voz",
  "Создаём голос…": "Creando voz…",
  "Сохранение настроек создания сейчас выключено.": "El guardado de los ajustes de creación está desactivado en este momento.",
  "Сохранение не подтверждено. Закройте форму и проверьте актуальный профиль.": "El guardado no se ha confirmado. Cierra el formulario y comprueba el perfil actual.",
  "Сохранение не подтверждено. Повтор создания использует прежний запрос.": "El guardado no se ha confirmado. Al repetir la creación se utilizará la solicitud anterior.",
  "Сохранение недоступно.": "El guardado no está disponible.",
  "Сохранено": "Guardado",
  "Сохранить": "Guardar",
  "Сохранить близкого": "Guardar persona cercana",
  "Сохранить вариант": "Guardar variante",
  "Сохранить голос по умолчанию": "Guardar voz predeterminada",
  "Сохранить мои фото": "Guardar mis fotos",
  "Сохранить образцы": "Guardar muestras",
  "Сохраняем образцы…": "Guardando muestras…",
  "Сохраняем…": "Guardando…",
  "Сохранённые варианты себя доступны в профиле и инструментах создания.": "Las variantes guardadas de ti están disponibles en el perfil y en las herramientas de creación.",
  "Сохранённых вариантов пока нет.": "Todavía no hay variantes guardadas.",
  "Сроки партий Circle временно недоступны": "Las fechas de vencimiento de los lotes de Circle no están disponibles temporalmente",
  "Старший": "Mayor",
  "Статистика": "Estadísticas",
  "Статистика по неделям временно недоступна.": "Las estadísticas semanales no están disponibles temporalmente.",
  "Статус удаления временно недоступен. Квитанция сохранена в этой вкладке.": "El estado de eliminación no está disponible temporalmente. El comprobante se ha guardado en esta pestaña.",
  "Сторис": "Historias",
  "Сын": "Hijo",
  "Тариф": "Plan",
  "Текст для чтения": "Texto para leer",
  "Тема": "Tema",
  "Тема сохраняется на этом устройстве.": "El tema se guarda en este dispositivo.",
  "Тёмная": "Oscuro",
  "У меня есть право использовать эти фотографии и согласие изображённых людей.": "Tengo derecho a utilizar estas fotografías y cuento con el consentimiento de las personas que aparecen en ellas.",
  "УДАЛИТЬ": "УДАЛИТЬ",
  "Убираем шум": "Eliminando ruido",
  "Убрать": "Quitar",
  "Убрать {0}": "Quitar {0}",
  "Убрать из избранного": "Quitar de favoritos",
  "Убрать фоновый шум": "Eliminar ruido de fondo",
  "Убрать фото": "Quitar foto",
  "Уведомления": "Notificaciones",
  "Уведомления недоступны.": "Las notificaciones no están disponibles.",
  "Уведомления пока недоступны.": "Las notificaciones aún no están disponibles.",
  "Удаление аккаунта Mini App": "Eliminación de la cuenta de Mini App",
  "Удаление:": "Eliminación:",
  "Удалить": "Eliminar",
  "Удалить «": "Eliminar «",
  "Удалить «{0}»?": "¿Eliminar «{0}»?",
  "Удалить аккаунт Mini App": "Eliminar cuenta de Mini App",
  "Удалить близкого": "Eliminar persona cercana",
  "Удалить вариант": "Eliminar variante",
  "Удалить голос": "Eliminar voz",
  "Удаляем…": "Eliminando…",
  "Удаляется": "Eliminándose",
  "Українська": "Українська",
  "Условия использования": "Condiciones de uso",
  "Файл": "Archivo",
  "Формат": "Formato",
  "Фото Telegram": "Foto de Telegram",
  "Фото {0}": "Foto {0}",
  "Фото и имя берутся из вашего профиля в Telegram. Если вы их сменили, обновите данные здесь.": "La foto y el nombre se obtienen de tu perfil de Telegram. Si los has cambiado, actualiza los datos aquí.",
  "Фото и фотосессия": "Foto y sesión de fotos",
  "Фото перед загрузкой": "Foto antes de subirla",
  "Фото профиля": "Foto de perfil",
  "Фото профиля Telegram": "Foto de perfil de Telegram",
  "Фото, голоса, близкие и данные Mini App будут удалены во всех сервисах. STEOS ID и финансовые квитанции останутся. Отменить удаление нельзя.": "Las fotos, las voces, las personas cercanas y los datos de Mini App se eliminarán de todos los servicios. STEOS ID y los comprobantes financieros se conservarán. La eliminación no se puede deshacer.",
  "Фото:": "Foto:",
  "Часть профиля временно недоступна. Попробуйте обновить.": "Una parte del perfil no está disponible temporalmente. Intenta actualizar.",
  "Читаем аудиофайлы…": "Leyendo archivos de audio…",
  "Что нового": "Novedades",
  "Что нового пока не опубликовано или временно недоступно.": "Las novedades aún no se han publicado o no están disponibles temporalmente.",
  "Что нового пока не опубликовано.": "Las novedades aún no se han publicado.",
  "Шаблоны": "Plantillas",
  "Шаблоны и рилс": "Plantillas y reels",
  "Эта неделя": "Esta semana",
  "Этот голос используется:": "Esta voz se utiliza:",
  "Этот запуск пока нельзя повторить. Обновите статус голоса.": "Este proceso no se puede repetir por ahora. Actualiza el estado de la voz.",
  "Этот формат не поддерживается. Выберите MP3, WAV, M4A, OGG или WebM.": "Este formato no es compatible. Selecciona MP3, WAV, M4A, OGG o WebM.",
  "Язык аккаунта": "Idioma de la cuenta",
  "готова": "lista",
  "готова частично": "parcialmente lista",
  "дата недоступна": "fecha no disponible",
  "для переозвучки": "para volver a doblar",
  "до {0}, потом {1}": "hasta {0}, después {1}",
  "другой тариф": "otro plan",
  "закончится {0}": "finalizará el {0}",
  "и": "y",
  "из": "de",
  "из 1:30 · минимум 0:02": "de 1:30 · mínimo 0:02",
  "лимит уточняется": "límite por determinar",
  "не задан": "no especificado",
  "не назначен": "no asignado",
  "новых": "nuevos",
  "образец": "muestra",
  "образца": "muestra",
  "образцов": "muestras",
  "оплачено до {0}": "pagado hasta {0}",
  "подарок до {0}": "regalo hasta {0}",
  "пока недоступно": "aún no disponible",
  "политику конфиденциальности STEOS": "política de privacidad de STEOS",
  "продлится {0}": "se renueva el {0}",
  "речи.": "de voz.",
  "токенов": "tokens",
  "условия": "condiciones",
  "уточняется": "por determinar",
  "Қазақша": "Қазақша",
  "← Профиль": "← Perfil",
  "▶ Прослушать": "▶ Escuchar",
  "Озвучка": "Locución",
  "Клон": "Clon",
  "Студия": "Estudio",
  "Баланс": "Saldo",
  "История": "Historial",
  "Ещё": "Más",
  "Клонирование голоса": "Clonación de voz",
  "Партнёрство": "Colaboración",
  "Добавить в чат": "Añadir al chat",
  "Разделы": "Secciones",
  "Главное меню": "Menú principal",
  "Выберите": "Seleccionar",
  "После объединения сохранены все фото. Оставьте до пяти, чтобы изменить образ.": "Se conservaron todas las fotos tras la fusión. Deja hasta cinco para cambiar tu imagen.",
  "Абзацы": "Párrafos",
  "Альбом": "Álbum",
  "Аудио": "Audio",
  "Без изменения": "Sin cambios",
  "Бесплатно по текущему тестовому dev-тарифу.": "Gratis según la tarifa de prueba dev actual.",
  "Бесплатно по тестовому dev-тарифу": "Gratis según la tarifa de prueba dev",
  "В избранном пока пусто": "Aún no hay favoritos",
  "В очереди": "En cola",
  "Вариант {0}": "Opción {0}",
  "Введите текст до 1000 символов": "Introduce texto de hasta 1000 caracteres",
  "Вернули": "Reembolsado",
  "Вернуть запись в историю не получится. Файл в чате останется.": "No se podrá devolver el trabajo al historial. El archivo permanecerá en el chat.",
  "Видео": "Vídeo",
  "Виды работ": "Tipos de trabajo",
  "Все": "Todo",
  "Вчера": "Ayer",
  "Выбранный вариант": "Opción seleccionada",
  "Выбранный вариант недоступен. Вернитесь в профиль и обновите список.": "La opción seleccionada no está disponible. Vuelve al perfil y actualiza la lista.",
  "Выполняется": "En proceso",
  "Высота голоса": "Altura de la voz",
  "Говорящее видео": "Vídeo con voz",
  "Голоса": "Voces",
  "Дата неизвестна": "Fecha desconocida",
  "Длительность": "Duración",
  "Для этого действия пока нет доступного опубликованного инструмента.": "Todavía no hay ninguna herramienta publicada disponible para esta acción.",
  "Дополнительное поле": "Campo adicional",
  "Заголовок": "Título",
  "Загружаем историю…": "Cargando historial…",
  "Загружаем работу…": "Cargando trabajo…",
  "Загружаем результат…": "Cargando resultado…",
  "Загружаем…": "Cargando…",
  "Загружено": "Cargado",
  "Загрузка не подтверждена. Продолжите проверку этого файла.": "La carga no está confirmada. Continúa verificando este archivo.",
  "Заказ": "Pedido",
  "Заказ не подтверждён. Продолжение проверит прежний запрос с тем же ключом.": "El pedido no está confirmado. Continuar comprobará la solicitud anterior con la misma clave.",
  "Заменить файл": "Reemplazar archivo",
  "Избранное: {0}": "Favoritos: {0}",
  "Инструмент обновляется. Обновите форму позже.": "La herramienta se está actualizando. Actualiza el formulario más tarde.",
  "Искать в {0} работах": "Buscar en {0} trabajos",
  "Искать в истории": "Buscar en el historial",
  "Использовать фото выбранного варианта": "Usar la foto de la opción seleccionada",
  "Используется выбранный голос.": "Se está usando la voz seleccionada.",
  "Исход генерации уточняется. Новая работа автоматически не запускается.": "Se está determinando el resultado de la generación. No se iniciará automáticamente un nuevo trabajo.",
  "К инструментам": "A las herramientas",
  "Кавер": "Cover",
  "Карусель": "Carrusel",
  "Ключевые слова": "Palabras clave",
  "Коллаж": "Collage",
  "Кратко": "Breve",
  "Кружки": "Videomensajes",
  "Кружок": "Videomensaje",
  "Кто в кадре": "Quién aparece en el fotograma",
  "Название": "Nombre",
  "Не получилось": "No funcionó",
  "Не удалось выполнить": "No se pudo realizar",
  "Не удалось выполнить действие с этой работой. Обновите её и попробуйте снова.": "No se pudo realizar la acción con este trabajo. Actualízalo y vuelve a intentarlo.",
  "Не удалось завершить создание. Попробуйте изменить настройки.": "No se pudo completar la creación. Intenta cambiar la configuración.",
  "Не удалось загрузить историю. Попробуйте ещё раз.": "No se pudo cargar el historial. Inténtalo de nuevo.",
  "Не удалось загрузить студию.": "No se pudo cargar el estudio.",
  "Не удалось загрузить фото варианта. Обновите профиль.": "No se pudo cargar la foto de la opción. Actualiza el perfil.",
  "Не удалось обработать запись": "No se pudo procesar la grabación",
  "Не удалось озвучить текст": "No se pudo dar voz al texto",
  "Не удалось открыть инструмент. Попробуйте обновить.": "No se pudo abrir la herramienta. Intenta actualizar.",
  "Не удалось открыть результат. Попробуйте снова.": "No se pudo abrir el resultado. Inténtalo de nuevo.",
  "Не удалось отправить результат. Повторите отправку.": "No se pudo enviar el resultado. Repite el envío.",
  "Не удалось связаться с сервисом. Попробуйте ещё раз.": "No se pudo conectar con el servicio. Inténtalo de nuevo.",
  "Не удалось скопировать. Выделите текст вручную.": "No se pudo copiar. Selecciona el texto manualmente.",
  "Не удалось сохранить отправку. Разрешите хранилище вкладки и попробуйте ещё раз.": "No se pudo guardar el envío. Permite el almacenamiento de la pestaña e inténtalo de nuevo.",
  "Некоторые файлы повтора больше недоступны. Загрузите их заново.": "Algunos archivos de la repetición ya no están disponibles. Vuelve a cargarlos.",
  "Ничего не нашли": "No se encontraron resultados",
  "Нужно разных фото": "Se necesitan fotos diferentes",
  "Обрабатываем запись": "Procesando la grabación",
  "Озвучиваем текст": "Dando voz al texto",
  "Озвучить": "Dar voz",
  "Озвучка готова": "Voz lista",
  "Озвучка проекта": "Voz del proyecto",
  "Оплата": "Pago",
  "Оплачено донатом": "Pagado mediante donación",
  "Определить автоматически": "Detectar automáticamente",
  "Основа": "Base",
  "Открыть результат": "Abrir resultado",
  "Отменено": "Cancelado",
  "Отправить в чат": "Enviar al chat",
  "Отправка не принята. Проверьте сообщение об ошибке.": "Envío no aceptado. Comprueba el mensaje de error.",
  "Отправка принята. Бот доставит результат в чат.": "Envío aceptado. El bot entregará el resultado en el chat.",
  "Отправлено": "Enviado",
  "Переозвучить запись": "Volver a dar voz a la grabación",
  "Переозвучка": "Nueva voz",
  "Персонаж": "Personaje",
  "Площадка": "Plataforma",
  "Повтори движения": "Repite los movimientos",
  "Повторить": "Repetir",
  "Подпись": "Pie de foto",
  "Подтверждаю право использовать загружаемые материалы": "Confirmo que tengo derecho a usar los materiales que subo",
  "Подтверждаю право использовать эти фото и согласие изображённых людей на создание варианта": "Confirmo que tengo derecho a usar estas fotos y que las personas representadas han dado su consentimiento para crear la opción",
  "Поиск в истории": "Buscar en el historial",
  "Показатели истории": "Métricas del historial",
  "Показатели истории временно недоступны": "Las métricas del historial no están disponibles temporalmente",
  "Показать все работы": "Mostrar todos los trabajos",
  "Показать текст": "Mostrar texto",
  "Порядок": "Orden",
  "Почистить запись": "Limpiar grabación",
  "Прежний голос недоступен. Выберите другой голос.": "La voz anterior no está disponible. Elige otra voz.",
  "Преимущества": "Ventajas",
  "Проверьте заполненные поля. Заказ не создан.": "Comprueba los campos rellenados. No se ha creado el pedido.",
  "Проверяем итог операции": "Comprobando el resultado de la operación",
  "Проверяем отправку…": "Comprobando el envío…",
  "Проверяем результат": "Comprobando el resultado",
  "Проверяем списание токенов": "Comprobando el descuento de tokens",
  "Продолжить проверку озвучки": "Continuar comprobando la voz",
  "Работ пока нет": "Aún no hay trabajos",
  "Работ: {0}": "Trabajos: {0}",
  "Работа": "Trabajo",
  "Работа больше не найдена. Обновите историю.": "Ya no se encuentra el trabajo. Actualiza el historial.",
  "Работа из истории": "Trabajo del historial",
  "Работа не прошла проверку.": "El trabajo no pasó la comprobación.",
  "Работа обновилась. Загрузите её ещё раз.": "El trabajo se actualizó. Vuelve a cargarlo.",
  "Распознавание": "Reconocimiento",
  "Распознанный текст": "Texto reconocido",
  "Распознать речь": "Reconocer voz",
  "Расшифровка": "Transcripción",
  "Режим озвучки": "Modo de voz",
  "Результат": "Resultado",
  "Результат больше недоступен": "El resultado ya no está disponible",
  "Результат операции уточняется. Повторный запуск отключён.": "Se está determinando el resultado de la operación. El inicio repetido está desactivado.",
  "Результат отправки пока неизвестен. Повторите проверку.": "Aún se desconoce el resultado del envío. Vuelve a comprobarlo.",
  "Результат отправки пока неизвестен. Повторите с тем же ключом.": "Aún se desconoce el resultado del envío. Repite con la misma clave.",
  "Результат переозвучки": "Resultado de la nueva voz",
  "Результат работы": "Resultado del trabajo",
  "Реплики": "Intervenciones",
  "Речевая запись": "Grabación de voz",
  "Рилс": "Reel",
  "Сегодня": "Hoy",
  "Сейчас создаётся": "Creándose ahora",
  "Сервис сейчас недоступен.": "El servicio no está disponible ahora.",
  "Сессия истекла. Откройте приложение заново.": "La sesión ha caducado. Vuelve a abrir la aplicación.",
  "Синтез": "Síntesis",
  "Скачать": "Descargar",
  "Скачать все файлы": "Descargar todos los archivos",
  "Скачать набор": "Descargar conjunto",
  "Скопировано": "Copiado",
  "Скопировать": "Copiar",
  "Слайды": "Diapositivas",
  "Слишком много запросов. Подождите немного.": "Demasiadas solicitudes. Espera un momento.",
  "Слушать результат": "Escuchar resultado",
  "Смена голоса": "Cambio de voz",
  "Сначала новые": "Primero los nuevos",
  "Сначала старые": "Primero los antiguos",
  "Создать": "Crear",
  "Создаётся": "Creándose",
  "Списано": "Descontado",
  "Статус пока не подтверждён. Проверяем прежний заказ.": "El estado aún no está confirmado. Comprobamos el pedido anterior.",
  "Статус текущих заказов временно недоступен": "El estado de los pedidos actuales no está disponible temporalmente",
  "Стиль": "Estilo",
  "Стоимость": "Coste",
  "Сцена": "Escena",
  "Съёмка": "Sesión",
  "Текст": "Texto",
  "Текст для озвучки": "Texto para la voz",
  "Текст песни": "Letra de canción",
  "Текст поста": "Texto de la publicación",
  "Товар": "Producto",
  "Удалить из истории": "Eliminar del historial",
  "Удалить из истории?": "¿Eliminar del historial?",
  "Уточняем результат": "Precisando el resultado",
  "Уточняем состояние сохранённого заказа…": "Precisando el estado del pedido guardado…",
  "Файл в чате останется": "El archivo permanecerá en el chat",
  "Файлов: {0}": "Archivos: {0}",
  "Форма недоступна.": "Formulario no disponible.",
  "Формат отправки": "Formato de envío",
  "Фото": "Foto",
  "Фотосессии": "Sesiones de fotos",
  "Фотосессия": "Sesión de fotos",
  "Фотосессия товара": "Sesión de fotos del producto",
  "Части": "Partes",
  "Шаблон": "Plantilla",
  "Эта работа недоступна вашему аккаунту.": "Este trabajo no está disponible para tu cuenta.",
  "Это вся история": "Este es todo el historial",
  "Этот инструмент сейчас недоступен. Попробуйте обновить форму.": "Esta herramienta no está disponible ahora. Intenta actualizar el formulario.",
  "Язык записи": "Idioma de la grabación",
  "MP3 · пауза между репликами 0,6 с": "MP3 · pausa de 0,6 s entre intervenciones",
  "{0} / 1 000 знаков": "{0} / 1 000 caracteres",
  "{0} / 20 000 знаков · версия {1}": "{0} / 20 000 caracteres · versión {1}",
  "{0} реплик": "{0} intervenciones",
  "{0} ролей · {1} новых реплик": "{0} roles · {1} nuevas intervenciones",
  "Аудио больше недоступно. Обновите статус проекта.": "El audio ya no está disponible. Actualiza el estado del proyecto.",
  "Буфер недоступен. Вставьте текст в поле вручную.": "El portapapeles no está disponible. Pega el texto manualmente en el campo.",
  "В проекте должно быть от 1 до 50 ролей.": "El proyecto debe tener entre 1 y 50 roles.",
  "В проекте может быть не больше 500 реплик.": "El proyecto no puede tener más de 500 intervenciones.",
  "Вставить из буфера": "Pegar desde el portapapeles",
  "Вставить сценарий": "Pegar guion",
  "Выберите голос для каждой непустой роли.": "Selecciona una voz para cada rol que no esté vacío.",
  "Выше": "Arriba",
  "Голос {0}": "Voz {0}",
  "Голос роли": "Voz del rol",
  "Готовим аудио…": "Preparando audio…",
  "Добавить {0} реплик": "Añadir {0} intervenciones",
  "Добавьте реплику или вставьте сценарий.": "Añade una intervención o pega un guion.",
  "Дождитесь загрузки общего файла и попробуйте ещё раз.": "Espera a que se cargue el archivo compartido e inténtalo de nuevo.",
  "Дублировать": "Duplicar",
  "Загружаем аудио…": "Cargando audio…",
  "Загружаем проекты…": "Cargando proyectos…",
  "Загрузить версию сервера": "Cargar versión del servidor",
  "Закрыть раздел без сохранения изменений?": "¿Cerrar la sección sin guardar los cambios?",
  "Заменить текущие роли и реплики?": "¿Reemplazar los roles y las intervenciones actuales?",
  "Заменить текущий сценарий": "Reemplazar el guion actual",
  "Изменить сценарий": "Editar guion",
  "Имя роли": "Nombre del rol",
  "Кто говорит": "Quién habla",
  "Мои проекты": "Mis proyectos",
  "Нажмите воспроизведение в плеере, чтобы разрешить звук.": "Pulsa reproducir en el reproductor para activar el sonido.",
  "Название проекта": "Nombre del proyecto",
  "Название слишком длинное.": "El nombre es demasiado largo.",
  "Не удалось восстановить операции. Не запускайте озвучку повторно; проверьте историю.": "No se pudieron recuperar las operaciones. No vuelvas a iniciar la locución; consulta el historial.",
  "Не удалось выполнить действие. Изменения остаются на экране.": "No se pudo realizar la acción. Los cambios siguen en pantalla.",
  "Не удалось загрузить аудио. Проверьте соединение и попробуйте ещё раз.": "No se pudo cargar el audio. Comprueba la conexión e inténtalo de nuevo.",
  "Не удалось озвучить проект": "No se pudo generar la locución del proyecto",
  "Не удалось подготовить аудио. Проверьте реплику и выбранный голос.": "No se pudo preparar el audio. Comprueba la intervención y la voz seleccionada.",
  "Не удалось проверить владельца проекта. Обновите страницу.": "No se pudo verificar quién es el propietario del proyecto. Actualiza la página.",
  "Не удалось связаться с сервером. Проверьте соединение и повторите попытку.": "No se pudo conectar con el servidor. Comprueba la conexión e inténtalo de nuevo.",
  "Не хватает Circle. Пополните баланс и повторите действие.": "No hay suficientes Circle. Recarga el saldo y vuelve a intentarlo.",
  "Ниже": "Abajo",
  "Новый дубль реплики": "Nueva toma de la intervención",
  "Общий файл · MP3": "Archivo compartido · MP3",
  "Один из голосов больше недоступен. Выберите другой голос.": "Una de las voces ya no está disponible. Selecciona otra voz.",
  "Озвучено реплик: {0} из {1}": "Intervenciones locutadas: {0} de {1}",
  "Озвучиваем проект": "Generando la locución del proyecto",
  "Озвучить · {0} Circle": "Generar locución · {0} Circle",
  "Озвучить проект": "Generar locución del proyecto",
  "Озвучка проектов": "Locución de guiones",
  "Озвучка уже выполняется. Дождитесь результата.": "La locución ya está en curso. Espera el resultado.",
  "Операция уже принята или её исход неизвестен. Проверьте прежний запрос.": "La operación ya se ha aceptado o se desconoce su resultado. Comprueba la solicitud anterior.",
  "Отбросить локальные изменения и загрузить версию сервера?": "¿Descartar los cambios locales y cargar la versión del servidor?",
  "Открыть в истории": "Abrir en el historial",
  "Отменить изменения": "Deshacer cambios",
  "Отменить несохранённые изменения?": "¿Cancelar los cambios sin guardar?",
  "Перед озвучкой дождитесь сохранения изменений.": "Espera a que se guarden los cambios antes de generar la locución.",
  "Переозвучить": "Volver a generar la locución",
  "Переозвучить реплику": "Volver a generar la locución de la intervención",
  "Повторить проверку": "Volver a comprobar",
  "Подтвердить и запустить": "Confirmar e iniciar",
  "Подтверждение озвучки": "Confirmación de la locución",
  "Проверить прежний запрос": "Comprobar solicitud anterior",
  "Проверить статус": "Comprobar estado",
  "Проверьте роли, голоса и длину реплик.": "Comprueba los roles, las voces y la longitud de las intervenciones.",
  "Проект больше недоступен.": "El proyecto ya no está disponible.",
  "Проект длиннее 20 000 знаков.": "El proyecto supera los 20 000 caracteres.",
  "Проект изменился в другом окне. Сравните свою версию и загрузите свежую.": "El proyecto ha cambiado en otra ventana. Compara tu versión y carga la más reciente.",
  "Проект изменился. Сохраните его и проверьте цену ещё раз.": "El proyecto ha cambiado. Guárdalo y vuelve a comprobar el precio.",
  "Проект или результат больше недоступен.": "El proyecto o el resultado ya no están disponibles.",
  "Проект озвучен": "Proyecto locutado",
  "Проекты {0}": "Proyectos {0}",
  "Прослушать": "Escuchar",
  "Прослушать реплику": "Escuchar intervención",
  "Прослушать текущую версию": "Escuchar versión actual",
  "Прослушивание в очереди": "Escucha en cola",
  "Прослушивание реплики": "Escuchando intervención",
  "Результат изменился. Загрузите его актуальную версию.": "El resultado ha cambiado. Carga su versión más reciente.",
  "Результат озвучки проекта": "Resultado de la locución del proyecto",
  "Результат уточняется. Повторная генерация автоматически не запускается.": "El resultado aún se está determinando. No se inicia automáticamente una nueva generación.",
  "Реплика {0}": "Intervención {0}",
  "Реплика длиннее 1 000 знаков.": "La intervención supera los 1 000 caracteres.",
  "Реплики · {0}": "Intervenciones · {0}",
  "Реплику {0} выше": "Mover la intervención {0} hacia arriba",
  "Реплику {0} ниже": "Mover la intervención {0} hacia abajo",
  "Роли и голоса": "Roles y voces",
  "Роль {0}": "Rol {0}",
  "Роль реплики": "Rol de la intervención",
  "Скачать MP3": "Descargar MP3",
  "Слишком много запросов. Подождите и повторите проверку.": "Demasiadas solicitudes. Espera e inténtalo de nuevo.",
  "Создайте проект, затем вставьте сценарий или добавьте роли и реплики.": "Crea un proyecto y luego pega un guion o añade roles e intervenciones.",
  "Стоимость подтверждена сервером. Повторная проверка этого же запроса не создаёт нового списания.": "El servidor ha confirmado el coste. Volver a comprobar esta misma solicitud no genera un nuevo cargo.",
  "Стоимость: {0} Circle": "Coste: {0} Circle",
  "Строки «Имя: реплика» станут ролями и репликами. Таймкоды можно оставить.": "Las líneas «Nombre: intervención» se convertirán en roles e intervenciones. Puedes conservar los códigos de tiempo.",
  "Сценарий": "Guion",
  "Сценарий изменился. Эта дорожка относится к предыдущей версии проекта.": "El guion ha cambiado. Esta pista corresponde a una versión anterior del proyecto.",
  "Сценарий по ролям — каждая роль звучит своим голосом.": "Guion por roles: cada rol habla con su propia voz.",
  "Текст или голос изменились. Для текущей версии нужно новое прослушивание.": "El texto o la voz han cambiado. Es necesario escuchar de nuevo la versión actual.",
  "Текст реплики": "Texto de la intervención",
  "Удалить проект": "Eliminar proyecto",
  "Удалить реплику {0}": "Eliminar intervención {0}",
  "Удалить реплику?": "¿Eliminar la intervención?",
  "Удалить роль {0}": "Eliminar rol {0}",
  "Удалить роль «{0}» вместе с её репликами ({1})?": "¿Eliminar el rol «{0}» junto con sus intervenciones ({1})?",
  "Удалить этот проект?": "¿Eliminar este proyecto?",
  "Укажите имя каждой роли.": "Introduce el nombre de cada rol.",
  "Уточняем результат озвучки": "Determinando el resultado de la locución",
  "Цена изменилась. Проверьте новую цену перед запуском.": "El precio ha cambiado. Comprueba el nuevo precio antes de iniciar.",
  "есть несохранённые изменения": "hay cambios sin guardar",
  "сохранено": "guardado",
  "＋ Новый проект": "＋ Nuevo proyecto",
  "＋ Реплика": "＋ Intervención",
  "＋ Роль": "＋ Rol",
  "Circle из пакетов без срока действия.": "Circle de paquetes sin fecha de caducidad.",
  "Circle каждый месяц": "Circle cada mes",
  "Circle приходят каждые {0} дней, первая партия — сразу.": "Los Circle se entregan cada {0} días; el primer lote, de inmediato.",
  "Circle этой партии действуют до {0}": "Los Circle de este lote son válidos hasta {0}",
  "{0} Circle каждый месяц": "{0} Circle cada mes",
  "{0} Circle каждый месяц · до {1} своих голосов": "{0} Circle cada mes · hasta {1} voces propias",
  "{0} мес.": "{0} meses",
  "Баланс и профиль": "Saldo y perfil",
  "В текущем месяце осталось {0} из {1} Circle": "Este mes quedan {0} de {1} Circle",
  "Ваш текущий тариф": "Tu plan actual",
  "Включить тестовое продление": "Activar renovación de prueba",
  "Выбор тарифа": "Elegir plan",
  "Действует до {0}": "Válido hasta {0}",
  "Для этой подписки продление пока недоступно.": "La renovación aún no está disponible para esta suscripción.",
  "До {0} своих голосов": "Hasta {0} voces propias",
  "До {0} сохраняется текущий тариф.": "El plan actual se mantiene hasta {0}.",
  "Докупить Circle": "Comprar Circle adicionales",
  "Доступные сроки": "Duraciones disponibles",
  "Загружаем подписку…": "Cargando suscripción…",
  "Запланировать переход": "Programar cambio de plan",
  "Запрос не совпадает с сохранённой операцией. Не повторяйте покупку; обратитесь в поддержку.": "La solicitud no coincide con la operación guardada. No repitas la compra; contacta con soporte.",
  "Исход прежнего запроса нужно проверить. Новая покупка пока заблокирована.": "Es necesario comprobar el resultado de la solicitud anterior. Las nuevas compras están bloqueadas temporalmente.",
  "Начислить {0} тестовых Circle": "Añadir {0} Circle de prueba",
  "Не удалось восстановить операцию. Проверьте подписку перед новой покупкой.": "No se pudo recuperar la operación. Comprueba la suscripción antes de realizar otra compra.",
  "Операция подтверждена. Обновите данные; повторять покупку не нужно.": "Operación confirmada. Actualiza los datos; no es necesario repetir la compra.",
  "Оставить текущий тариф": "Mantener el plan actual",
  "Отмена продления сохраняет тариф и лимиты до конца оплаченного срока.": "Cancelar la renovación mantiene el plan y los límites hasta el final del período pagado.",
  "Отменить продление": "Cancelar renovación",
  "Оформить dev-подписку": "Contratar suscripción de desarrollo",
  "Пакет Circle начислен.": "Paquete de Circle añadido.",
  "Пакеты Circle доступны с активной подпиской.": "Los paquetes de Circle están disponibles con una suscripción activa.",
  "Перейти на выбранный тариф": "Cambiar al plan seleccionado",
  "Переход начнётся после окончания текущей подписки. Сейчас оплата не требуется.": "El cambio comenzará cuando termine la suscripción actual. No es necesario pagar ahora.",
  "Подписка": "Suscripción",
  "Подписка временно недоступна. Попробуйте обновить данные.": "La suscripción no está disponible temporalmente. Intenta actualizar los datos.",
  "Подписка не продлится": "La suscripción no se renovará",
  "Подписка обновлена.": "Suscripción actualizada.",
  "Подписка уже активна. Обновите данные и выберите доступное действие.": "La suscripción ya está activa. Actualiza los datos y elige una acción disponible.",
  "Подписка уже закончилась. Обновите данные.": "La suscripción ya ha caducado. Actualiza los datos.",
  "Подтвердить": "Confirmar",
  "Подтверждение подписки": "Confirmación de suscripción",
  "Покупка сейчас недоступна. Реальные платежи не включены.": "La compra no está disponible ahora. Los pagos reales no están habilitados.",
  "Получить dev-пакет бесплатно": "Obtener paquete de desarrollo gratis",
  "Потом: {0}": "Después: {0}",
  "Предыдущая подписка закончилась {0}": "La suscripción anterior terminó el {0}",
  "При продлении оплаченного срока новая партия придёт в следующем периоде.": "Al renovar un período pagado, el nuevo lote se entregará en el siguiente período.",
  "Проверка операции": "Comprobando operación",
  "Продление включено": "Renovación activada",
  "Продлить подписку": "Renovar suscripción",
  "Свои голоса": "Voces propias",
  "Свои голоса: {0} из {1}": "Voces propias: {0} de {1}",
  "Сравнить тарифы": "Comparar planes",
  "Срок": "Duración",
  "Срок подписки": "Duración de la suscripción",
  "Срок: {0} мес.": "Duración: {0} meses",
  "Тариф останется до конца срока. Следующего продления не будет.": "El plan se mantendrá hasta el final del período. No habrá otra renovación.",
  "Тарифы пока недоступны. Попробуйте обновить данные позже.": "Los planes aún no están disponibles. Intenta actualizar los datos más tarde.",
  "Текущий тариф": "Plan actual",
  "Тестовый dev-каталог. Реальных платежей нет; начисляются тестовые Circle.": "Catálogo de desarrollo de prueba. No hay pagos reales; se abonan Circle de prueba.",
  "Управление подпиской": "Gestionar suscripción",
  "Условия тарифа изменились. Обновите данные перед подтверждением.": "Las condiciones del plan han cambiado. Actualiza los datos antes de confirmar.",
  "Что входит": "Qué incluye",
  "Это бесплатная dev-операция. Деньги и Telegram Stars не списываются.": "Esta es una operación de desarrollo gratuita. No se cobran dinero ni Telegram Stars.",
  "Этот переход между тарифами недоступен.": "Este cambio de plan no está disponible.",
  "Этот тариф больше недоступен. Обновите список.": "Este plan ya no está disponible. Actualiza la lista.",
  "QR-код": "Código QR",
  "QR-код приглашения": "Código QR de invitación",
  "{0} из {1} · {2} Circle": "{0} de {1} · {2} Circle",
  "Виды заданий": "Tipos de tareas",
  "Выполнение этого задания пока недоступно.": "Esta tarea aún no está disponible.",
  "Готовим материал…": "Preparando material…",
  "Действие подтверждено. Обновляем задания.": "Acción confirmada. Actualizando tareas.",
  "День {0}": "Día {0}",
  "День {0} из {1}": "Día {0} de {1}",
  "Дней подряд: {0}": "Días consecutivos: {0}",
  "Друзья": "Amigos",
  "Ежедневная серия": "Racha diaria",
  "Ежедневные": "Diarias",
  "Есть награды": "Hay recompensas",
  "Забрать {0} Circle": "Reclamar {0} Circle",
  "Загружаем награды…": "Cargando recompensas…",
  "Задание ещё не выполнено. Обновите прогресс.": "La tarea aún no se ha completado. Actualiza el progreso.",
  "Задание засчитывает открытие отправки сторис. Telegram не подтверждает публикацию.": "La tarea cuenta la apertura de la opción para compartir una historia. Telegram no confirma su publicación.",
  "Заданий в этой группе пока нет.": "Aún no hay tareas en este grupo.",
  "Задания дня": "Tareas del día",
  "Заходите каждый день. Пропуск дня начинает серию заново.": "Entra cada día. Si te saltas un día, la racha se reinicia.",
  "Исход прежнего запроса нужно проверить. Новые начисления пока заблокированы.": "Es necesario comprobar el resultado de la solicitud anterior. Los nuevos créditos están bloqueados por ahora.",
  "Копирование недоступно. Выделите текст вручную.": "La copia no está disponible. Selecciona el texto manualmente.",
  "Материал для сторис": "Material para historias",
  "Награда подтверждена. Обновите данные; повторять начисление не нужно.": "Recompensa confirmada. Actualiza los datos; no es necesario volver a reclamarla.",
  "Награда получена": "Recompensa recibida",
  "Награда получена. Завтра +{0} Circle": "Recompensa recibida. Mañana +{0} Circle",
  "Награда уже получена. Обновите данные.": "La recompensa ya se ha recibido. Actualiza los datos.",
  "Награды временно недоступны. Попробуйте обновить данные.": "Las recompensas no están disponibles temporalmente. Intenta actualizar los datos.",
  "Награды за друзей": "Recompensas por amigos",
  "Награды приходят в Circle: ими можно платить в STEOS, выводить нельзя.": "Las recompensas se reciben en Circle: puedes usarlas para pagar en STEOS, pero no puedes retirarlas.",
  "Начисление не подтверждено. Проверьте прежний запрос; новая награда пока заблокирована.": "El crédito no está confirmado. Comprueba la solicitud anterior; la nueva recompensa está bloqueada por ahora.",
  "Начисления приостановлены.": "Los créditos están suspendidos.",
  "Начислено {0} Circle": "Se han acreditado {0} Circle",
  "Начислено: {0} Circle": "Acreditado: {0} Circle",
  "Не удалось восстановить запрос награды. Проверьте баланс и обратитесь в поддержку.": "No se pudo recuperar la solicitud de recompensa. Comprueba el saldo y contacta con soporte.",
  "Не удалось загрузить QR-код.": "No se pudo cargar el código QR.",
  "Не удалось открыть отправку сторис. Награда не начислена.": "No se pudo abrir la opción para compartir una historia. No se ha acreditado ninguna recompensa.",
  "Не удалось подготовить сторис. Попробуйте ещё раз.": "No se pudo preparar la historia. Inténtalo de nuevo.",
  "Новый день: {0}": "Nuevo día: {0}",
  "Обновить награды": "Actualizar recompensas",
  "Обновятся: {0}": "Se actualizarán: {0}",
  "Откройте Mini App в Telegram с поддержкой сторис.": "Abre la Mini App en Telegram con soporte para historias.",
  "Открыть STEOS ID в профиле": "Abrir STEOS ID en el perfil",
  "Открыть сторис": "Abrir historia",
  "Отправить в сторис": "Compartir en historias",
  "Партнёрские данные временно недоступны.": "Los datos de los socios no están disponibles temporalmente.",
  "Партнёрство · Статистика, материалы и вывод": "Colaboración · Estadísticas, materiales y retiros",
  "Первые шаги": "Primeros pasos",
  "Перейти к заданию": "Ir a la tarea",
  "Получить ежедневную награду": "Obtener recompensa diaria",
  "Приглашено: {0} · Покупателей: {1}": "Invitados: {0} · Compradores: {1}",
  "Прогресс задания": "Progreso de la tarea",
  "Прогресс задания временно недоступен.": "El progreso de la tarea no está disponible temporalmente.",
  "Промокод": "Código promocional",
  "Разовые": "Únicas",
  "Скопировать приглашение": "Copiar invitación",
  "Скопировать промокод": "Copiar código promocional",
  "Ссылка приглашения": "Enlace de invitación",
  "Сторис в Telegram": "Historias en Telegram",
  "Челленджи недели": "Retos semanales",
  "Circle используются внутри STEOS": "Los Circle se utilizan dentro de STEOS",
  "Telegram подтвердил отправку сообщения.": "Telegram confirmó el envío del mensaje.",
  "Без покупок": "Sin compras",
  "В этом списке пока нет друзей.": "Todavía no hay amigos en esta lista.",
  "Возможен вывод по условиям программы": "Es posible retirar fondos según las condiciones del programa",
  "Вопросы": "Preguntas",
  "Всё время": "Todo el tiempo",
  "Вы здесь": "Estás aquí",
  "Выберите PDF, JPG или PNG.": "Selecciona un PDF, JPG o PNG.",
  "Выберите плательщика": "Selecciona al pagador",
  "Выбрать чат в Telegram": "Seleccionar chat en Telegram",
  "Выбрать чат для отправки": "Seleccionar chat para enviar",
  "Вывод": "Retirada",
  "Вывод недоступен на текущем уровне.": "Las retiradas no están disponibles en el nivel actual.",
  "Вывод сейчас недоступен.": "Las retiradas no están disponibles en este momento.",
  "Вывод средств": "Retirada de fondos",
  "Выплачен": "Pagado",
  "Выставьте счёт на": "Factura a nombre de",
  "Для вывода войдите в STEOS ID.": "Inicia sesión en STEOS ID para retirar fondos.",
  "Для расчёта нужны опубликованные уровни и тарифы.": "Para realizar el cálculo, deben publicarse los niveles y las tarifas.",
  "До уровня «{0}»: ещё {1} покупателей": "Hasta el nivel «{0}»: faltan {1} compradores",
  "Доступно к выводу": "Disponible para retirar",
  "Доступных шаблонов пока нет.": "Todavía no hay plantillas disponibles.",
  "Доход": "Ingresos",
  "Если купят {0} друзей": "Si {0} amigos compran",
  "Есть покупки": "Hay compras",
  "За этот период начислений пока нет.": "Todavía no hay importes abonados en este período.",
  "Загружаем QR-код…": "Cargando código QR…",
  "Загружаем друзей…": "Cargando amigos…",
  "Загружаем материалы…": "Cargando materiales…",
  "Загружаем партнёрские данные…": "Cargando datos de afiliados…",
  "Загрузите проверенный счёт на оплату.": "Sube una factura de pago verificada.",
  "Заказать материал в чат": "Solicitar material en el chat",
  "Запрос принят. Доставка в чат ещё не подтверждена.": "Solicitud aceptada. La entrega en el chat aún no está confirmada.",
  "Заявка принята. Статус выплаты появится в истории.": "Solicitud aceptada. El estado del pago aparecerá en el historial.",
  "Заявок на вывод пока нет.": "Todavía no hay solicitudes de retirada.",
  "Изменение реквизитов заблокировано до получения результата этой заявки.": "El cambio de los datos de pago está bloqueado hasta que se resuelva esta solicitud.",
  "Имя получателя": "Nombre del destinatario",
  "История выводов": "Historial de retiradas",
  "Исход запроса нужно проверить. Новый материал пока заблокирован.": "Es necesario comprobar el resultado de la solicitud. El nuevo material está bloqueado por ahora.",
  "Как определяется уровень?": "¿Cómo se determina el nivel?",
  "Как это работает": "Cómo funciona",
  "Калькулятор станет доступен после публикации расчётной политики.": "La calculadora estará disponible cuando se publique la política de cálculo.",
  "Количество друзей": "Número de amigos",
  "Материалы": "Materiales",
  "Материалы временно недоступны. Попробуйте обновить список.": "Los materiales no están disponibles temporalmente. Intenta actualizar la lista.",
  "Материалы пока недоступны.": "Los materiales aún no están disponibles.",
  "Месяц": "Mes",
  "Минимальная сумма": "Importe mínimo",
  "На рассмотрении": "Pendiente de revisión",
  "Налоговый номер": "Número de identificación fiscal",
  "Начисления за период": "Importes abonados durante el período",
  "Начислено Circle": "Circle abonados",
  "Начислено за период: {0} Circle": "Importe abonado durante el período: {0} Circle",
  "Не удалось безопасно сохранить заявку или проверить владельца. Отправка не выполнена.": "No se pudo guardar la solicitud de forma segura ni verificar al titular. No se realizó el envío.",
  "Не удалось восстановить отправку. Обратитесь в поддержку перед новым запросом.": "No se pudo recuperar el envío. Contacta con soporte antes de realizar una nueva solicitud.",
  "Не удалось загрузить друзей.": "No se pudieron cargar los amigos.",
  "Не удалось загрузить историю выводов.": "No se pudo cargar el historial de retiradas.",
  "Не удалось загрузить тарифы.": "No se pudieron cargar las tarifas.",
  "Не удалось открыть отправку в Telegram.": "No se pudo abrir el envío en Telegram.",
  "Не удалось проверить владельца. Обновите страницу.": "No se pudo verificar al titular. Actualiza la página.",
  "Не удалось прочитать сохранённую заявку. Новый вывод заблокирован.": "No se pudo leer la solicitud guardada. Las nuevas retiradas están bloqueadas.",
  "Не удалось сохранить состояние отправки.": "No se pudo guardar el estado del envío.",
  "Неделя": "Semana",
  "Нет данных": "Sin datos",
  "Новая заявка": "Nueva solicitud",
  "Новая заявка на вывод сейчас недоступна.": "No se pueden crear nuevas solicitudes de retirada en este momento.",
  "О программе": "Acerca del programa",
  "Обзор": "Resumen",
  "Обновите страницу или обратитесь в поддержку.": "Actualiza la página o contacta con soporte.",
  "Обновить историю выводов": "Actualizar historial de retiradas",
  "Обновить материалы": "Actualizar materiales",
  "От {0} покупателей": "De {0} compradores",
  "Ответ не получен. Проверьте ту же заявку: её данные и ключ сохранены.": "No se recibió respuesta. Comprueba la misma solicitud: sus datos y su clave se han guardado.",
  "Отклонён": "Rechazado",
  "Откройте Mini App в Telegram с поддержкой отправки материалов.": "Abre la Mini App en Telegram con compatibilidad para enviar materiales.",
  "Открыть сторис в Telegram": "Abrir historia en Telegram",
  "Отправка не подтверждена. Повтор проверит прежний запрос без новой отправки.": "El envío no está confirmado. Al reintentar, se comprobará la solicitud anterior sin realizar un nuevo envío.",
  "Отправка отменена. Можно открыть выбор чата ещё раз.": "Envío cancelado. Puedes volver a abrir la selección de chat.",
  "Оценка дохода": "Estimación de ingresos",
  "Оценка за {0} месяцев: {1} Circle": "Estimación para {0} meses: {1} Circle",
  "Оценка за месяц: {0} Circle": "Estimación mensual: {0} Circle",
  "Переходы": "Visitas",
  "Период обзора": "Período del resumen",
  "Плательщик": "Pagador",
  "Подать заявку на вывод": "Solicitar retirada",
  "Подготовить QR-код": "Preparar código QR",
  "Подготовить другой материал": "Preparar otro material",
  "Подготовить материал": "Preparar material",
  "Поделитесь своей ссылкой или промокодом.": "Comparte tu enlace o código promocional.",
  "Поделиться": "Compartir",
  "Пока без покупок": "Todavía sin compras",
  "Пока недоступно": "Todavía no disponible",
  "Покупатели": "Compradores",
  "Покупки друзей учитывает сервер STEOS ID.": "El servidor de STEOS ID contabiliza las compras de los amigos.",
  "Полные условия программы": "Condiciones completas del programa",
  "Пользователь": "Usuario",
  "Попробуйте STEOS: {0}\nПромокод: {1}": "Prueba STEOS: {0}\nCódigo promocional: {1}",
  "Привязка до: {0}": "Vinculación hasta: {0}",
  "Привязка приглашённого друга действует {0} месяцев.": "La vinculación del amigo invitado dura {0} meses.",
  "Приглашён: {0}": "Invitado: {0}",
  "Проверить загрузку счёта": "Comprobar la carga de la factura",
  "Проверить ту же заявку": "Comprobar la misma solicitud",
  "Проверьте налоговый номер получателя.": "Comprueba el número de identificación fiscal del destinatario.",
  "Проверьте реквизиты и счёт.": "Comprueba los datos de pago y la factura.",
  "Проверьте сумму вывода: целое число в доступном диапазоне.": "Comprueba el importe de la retirada: debe ser un número entero dentro del rango disponible.",
  "Проверяем владельца…": "Verificando al titular…",
  "Проверяем заявку или счёт…": "Verificando la solicitud o la factura…",
  "Процент и доступность вывода определяет опубликованная программа.": "El porcentaje y la disponibilidad de las retiradas se determinan según el programa publicado.",
  "Проценты, сроки и ограничения показаны по опубликованным данным сервера.": "Los porcentajes, los plazos y las restricciones se muestran según los datos publicados por el servidor.",
  "Размер счёта должен быть от 1 байта до 10 МБ.": "El tamaño de la factura debe ser de entre 1 byte y 10 MB.",
  "Регистрации": "Registros",
  "Результат загрузки счёта неизвестен. Проверьте загрузку без повторной отправки файла.": "Se desconoce el resultado de la carga de la factura. Comprueba la carga sin volver a enviar el archivo.",
  "Скачать PNG": "Descargar PNG",
  "Сколько действует привязка друга?": "¿Cuánto tiempo dura la vinculación de un amigo?",
  "Скопировать текст": "Copiar texto",
  "Сохранена неподтверждённая заявка": "Solicitud no confirmada guardada",
  "Срок рассмотрения, дней": "Plazo de revisión, días",
  "Ссылка и промокод добавляются сервером. Выберите доступный материал.": "El servidor añade el enlace y el código promocional. Selecciona un material disponible.",
  "Ссылка на полный документ условий пока не опубликована.": "Todavía no se ha publicado el enlace al documento completo de las condiciones.",
  "Сторис открыта в Telegram. Публикацию нужно подтвердить в редакторе.": "La historia se ha abierto en Telegram. Debes confirmar la publicación en el editor.",
  "Сумма в Circle": "Importe en Circle",
  "Сумма меньше минимальной суммы вывода.": "El importe es inferior al mínimo para retirar fondos.",
  "Сумма превышает доступный остаток.": "El importe supera el saldo disponible.",
  "Счёт на оплату · PDF, JPG или PNG, до 10 МБ": "Factura de pago · PDF, JPG o PNG, hasta 10 MB",
  "Счёт не прошёл загрузку или проверку. Выберите PDF, JPG или PNG до 10 МБ.": "No se pudo cargar o verificar la factura. Selecciona un PDF, JPG o PNG de hasta 10 MB.",
  "Счёт пока не подтверждён. Повторите проверку или выберите другой файл.": "La factura aún no está confirmada. Vuelve a comprobarla o selecciona otro archivo.",
  "Счёт проверен": "Factura verificada",
  "Текст приглашения": "Texto de invitación",
  "Текст сообщения": "Texto del mensaje",
  "Тексты": "Textos",
  "Тестовая заявка": "Solicitud de prueba",
  "Тестовая программа dev. Реальные выплаты выключены.": "Programa de prueba dev. Los pagos reales están desactivados.",
  "Тестовая программа: реальные выплаты отключены.": "Programa de prueba: los pagos reales están desactivados.",
  "Тестовый расчёт dev. Это оценка, начисление не выполняется.": "Cálculo de prueba dev. Es una estimación; no se realiza ningún abono.",
  "Укажите имя получателя: до 200 символов.": "Introduce el nombre del destinatario: hasta 200 caracteres.",
  "Уровень показывает сервер по учтённым покупателям. Смотрите вкладку «Уровни».": "El servidor muestra el nivel según los compradores contabilizados. Consulta la pestaña «Niveles».",
  "Уровни": "Niveles",
  "Условия начислений пока не опубликованы.": "Todavía no se han publicado las condiciones de los abonos.",
  "Условия программы": "Condiciones del programa",
  "Учёт переходов по ссылке пока недоступен.": "El seguimiento de los clics en el enlace aún no está disponible.",
  "Фильтр друзей": "Filtro de amigos",
  "Что делать, если данные не обновились?": "¿Qué hacer si los datos no se han actualizado?",
  "Шаги": "Pasos",
  "Баннер": "Banner",
  "QR-постер": "Póster QR",
  "{0} / 300 знаков": "{0} / 300 caracteres",
  "· до 20 МБ": "· hasta 20 MB",
  "Агент готовит ответ…": "El agente está preparando una respuesta…",
  "Аудиозапись": "Grabación de audio",
  "Бесплатно только в dev. До 30 секунд и 10 МБ. Текст можно исправить перед отправкой.": "Gratis solo en dev. Hasta 30 segundos y 10 MB. Puedes corregir el texto antes de enviarlo.",
  "Ваш вопрос": "Tu pregunta",
  "Вопрос или название инструмента": "Pregunta o nombre de la herramienta",
  "Вопросов: {0}": "Preguntas: {0}",
  "Вопросы · {0}": "Preguntas · {0}",
  "Восстанавливаем чат…": "Restaurando el chat…",
  "Все сервисы работают": "Todos los servicios funcionan",
  "Выберите MP3, WAV или M4A до 20 МБ.": "Selecciona un archivo MP3, WAV o M4A de hasta 20 MB.",
  "Выберите инструкцию к нужному инструменту или странице.": "Selecciona las instrucciones para la herramienta o página que necesitas.",
  "Диктовать вопрос": "Dictar pregunta",
  "Диктовка не подтверждена. Повторите проверку прежнего запроса или загрузки.": "El dictado no está confirmado. Vuelve a comprobar la solicitud o la carga anterior.",
  "До": "Hasta",
  "Ещё спрашивают": "También preguntan",
  "Загружаем справку…": "Cargando la ayuda…",
  "Загружаем статус…": "Cargando el estado…",
  "Закрыть чат": "Cerrar chat",
  "ИИ-агент поддержки": "Agente de soporte con IA",
  "ИИ-агент сейчас недоступен.": "El agente de IA no está disponible en este momento.",
  "Инструкции": "Instrucciones",
  "Инструкции · {0}": "Instrucciones · {0}",
  "Инструкции пока не опубликованы.": "Aún no se han publicado instrucciones.",
  "Исход запроса пока неизвестен. Новый вопрос не отправляется.": "Aún se desconoce el resultado de la solicitud. No se envía ninguna pregunta nueva.",
  "Как пользоваться STEOS": "Cómo usar STEOS",
  "Кружки и говорящие видео": "Mensajes de vídeo y vídeos con voz",
  "Медленнее обычного": "Más lento de lo habitual",
  "Написать агенту": "Escribir al agente",
  "Начать": "Empezar",
  "Начать новую диктовку": "Iniciar un nuevo dictado",
  "Не помогло": "No ha sido útil",
  "Не удалось восстановить диктовку. Новый запрос заблокирован.": "No se pudo restaurar el dictado. La nueva solicitud está bloqueada.",
  "Не удалось восстановить чат. Обратитесь в поддержку.": "No se pudo restaurar el chat. Contacta con soporte.",
  "Не удалось загрузить поддержку. Попробуйте ещё раз.": "No se pudo cargar la ayuda. Inténtalo de nuevo.",
  "Не удалось загрузить статус сервисов.": "No se pudo cargar el estado de los servicios.",
  "Не удалось подтвердить ответ. Можно начать новый чат или написать в поддержку.": "No se pudo confirmar la respuesta. Puedes iniciar un nuevo chat o escribir a soporte.",
  "Не удалось получить ответ. Повторите проверку без нового вопроса.": "No se pudo obtener una respuesta. Vuelve a comprobar la solicitud anterior sin enviar una pregunta nueva.",
  "Не удалось проверить владельца чата. Повторите открытие.": "No se pudo verificar el propietario del chat. Vuelve a abrirlo.",
  "Не удалось сохранить новый чат.": "No se pudo guardar el nuevo chat.",
  "Не удалось сохранить оценку. Попробуйте ещё раз.": "No se pudo guardar la valoración. Inténtalo de nuevo.",
  "Недоступен": "No disponible",
  "Некоторые сервисы работают медленнее обычного. Открыть статус": "Algunos servicios funcionan más lentamente de lo habitual. Ver estado",
  "Нет подтверждённых данных": "No hay datos confirmados",
  "Ничего не нашли. Попробуйте другие слова или спросите ИИ-агента.": "No encontramos nada. Prueba con otras palabras o pregunta al agente de IA.",
  "Новый чат": "Nuevo chat",
  "Обзор приложения": "Descripción general de la aplicación",
  "Обновить справку": "Actualizar la ayuda",
  "Обновить статус": "Actualizar el estado",
  "Опубликованная проверка. Автоматический мониторинг не заявлен.": "Comprobación publicada. No se ha declarado ningún seguimiento automático.",
  "Ответ не подтверждён. Проверьте прежний запрос или напишите в поддержку.": "La respuesta no está confirmada. Comprueba la solicitud anterior o escribe a soporte.",
  "Отвечает по опубликованной справке STEOS": "Responde según la ayuda publicada de STEOS",
  "Открыть инструкции": "Abrir instrucciones",
  "Открыть инструкцию": "Abrir instrucciones",
  "Открыть инструмент": "Abrir herramienta",
  "Открыть ответ справки": "Abrir respuesta de la ayuda",
  "Открыть раздел": "Abrir sección",
  "Отправить вопрос": "Enviar pregunta",
  "Оценка ответа": "Valoración de la respuesta",
  "Очистить поиск": "Borrar búsqueda",
  "Поиск по справке": "Buscar en la ayuda",
  "Полезно": "Útil",
  "Помощь": "Ayuda",
  "Популярные вопросы": "Preguntas frecuentes",
  "Последняя проверка устарела. Текущее состояние неизвестно.": "La última comprobación está desactualizada. Se desconoce el estado actual.",
  "Посмотреть короткий обзор": "Ver una breve descripción general",
  "Предыдущая": "Anterior",
  "Проверено: {0}": "Comprobado: {0}",
  "Проверить диктовку": "Verificar dictado",
  "Пропустить": "Omitir",
  "Работает": "En funcionamiento",
  "Распознать вопрос": "Reconocer pregunta",
  "Распознаём вопрос…": "Reconociendo la pregunta…",
  "Результаты поиска": "Resultados de búsqueda",
  "Следующая": "Siguiente",
  "Советы": "Consejos",
  "Справка пока не опубликована.": "La ayuda aún no se ha publicado.",
  "Спросите что угодно": "Pregunta lo que quieras",
  "Спросить ИИ-агента": "Preguntar al agente de IA",
  "Спросить ИИ-агента поддержки": "Preguntar al agente de soporte con IA",
  "Статус": "Estado",
  "Статус сервисов": "Estado de los servicios",
  "Статус сервисов пока не публикуется.": "El estado de los servicios aún no se publica.",
  "Статья недоступна": "Artículo no disponible",
  "Темы": "Temas",
  "Темы пока не опубликованы.": "Aún no se han publicado temas.",
  "Точного ответа в справке нет.": "No hay una respuesta exacta en la ayuda.",
  "Чат не отправляет сообщения человеку автоматически.": "El chat no envía mensajes automáticamente a una persona.",
  "Читаем запись…": "Leyendo la grabación…",
  "Эта статья больше не входит в опубликованную справку.": "Este artículo ya no forma parte de la ayuda publicada.",
  "Выберите MP3, WAV или M4A до {0} МБ.": "Selecciona un archivo MP3, WAV o M4A de hasta {0} MB.",
  "До {0} · до {1} МБ": "Hasta {0} · hasta {1} MB",
  "Нужна запись от 1 секунды до {0}.": "Se necesita una grabación de entre 1 segundo y {0}.",
  "Остановить запись · {0}": "Detener grabación · {0}",
  "{0} C/сек": "{0} C/s",
  "Все инструменты": "Todas las herramientas",
  "Все шаблоны": "Todas las plantillas",
  "Вся подборка": "Toda la colección",
  "Выбрать, кто играет": "Elegir quién actúa",
  "Голос и музыка": "Voz y música",
  "Двое": "Dos",
  "Дети": "Niños",
  "Дешевле": "Más barato",
  "Для бизнеса": "Para empresas",
  "Для этого действия доступно несколько шаблонов. Выберите подходящий в каталоге.": "Hay varias plantillas disponibles para esta acción. Elige la adecuada en el catálogo.",
  "Загружаем шаблон…": "Cargando plantilla…",
  "Закрыть поиск": "Cerrar búsqueda",
  "Закрыть превью": "Cerrar vista previa",
  "Инструменты": "Herramientas",
  "Искать во всех шаблонах": "Buscar en todas las plantillas",
  "Короче": "Más corto",
  "Кто играет": "Quién actúa",
  "Найти инструмент или шаблон": "Buscar una herramienta o plantilla",
  "Не удалось загрузить выбранный вариант.": "No se pudo cargar la opción seleccionada.",
  "Не удалось загрузить шаблон. Обновите превью.": "No se pudo cargar la plantilla. Actualiza la vista previa.",
  "Не удалось открыть инструмент.": "No se pudo abrir la herramienta.",
  "Несколько": "Varios",
  "Новые": "Nuevos",
  "Один": "Uno",
  "от {0} C": "Desde {0} C",
  "от {0} C/сек": "Desde {0} C/s",
  "От {0} Circle": "Desde {0} Circle",
  "От А до Я": "De la A a la Z",
  "Очистить": "Borrar",
  "Питомцы": "Mascotas",
  "По желанию": "Opcional",
  "Подборка пока недоступна.": "La colección todavía no está disponible.",
  "Подборки": "Colecciones",
  "Поиск": "Buscar",
  "Пока нет доступных шаблонов": "Todavía no hay plantillas disponibles",
  "Популярные": "Populares",
  "После": "Después",
  "Превью шаблона": "Vista previa de la plantilla",
  "Пример результата пока не опубликован.": "Todavía no se ha publicado ningún ejemplo del resultado.",
  "Пример сейчас недоступен.": "El ejemplo no está disponible en este momento.",
  "Рекомендуем": "Recomendados",
  "Смотреть все": "Ver todo",
  "Сначала": "Ordenar",
  "Сравнить до и после": "Comparar antes y después",
  "Стилей: {0}. Выбор на следующем шаге.": "Estilos: {0}. La selección se realizará en el siguiente paso.",
  "Удерживайте для просмотра": "Mantén pulsado para ver",
  "Цена уточняется в форме создания.": "El precio se confirma en el formulario de creación.",
  "Частые вопросы": "Preguntas frecuentes",
  "Что нужно": "Qué se necesita",
  "Что хотите сделать?": "¿Qué quieres hacer?",
  "Шаблоны и подборки": "Plantillas y colecciones",
  "Это действие пока недоступно.": "Esta acción todavía no está disponible.",
  "е": "e",
  "за секунду": "por segundo",
  "ё": "ё",
  "{0} C в минуту": "{0} C por minuto",
  "{0} C за 100 знаков": "{0} C por cada 100 caracteres",
  "Владелец сессии изменился. Вернитесь в студию после обновления страницы.": "El propietario de la sesión ha cambiado. Vuelve al estudio después de actualizar la página.",
  "Не удалось восстановить сохранённую заявку. Новая генерация заблокирована.": "No se ha podido recuperar la solicitud guardada. Se ha bloqueado la nueva generación.",
  "Не удалось обновить сохранённую заявку. Новая генерация заблокирована.": "No se ha podido actualizar la solicitud guardada. Se ha bloqueado la nueva generación.",
  "Не удалось проверить владельца. Новая генерация заблокирована.": "No se ha podido verificar al propietario. Se ha bloqueado la nueva generación.",
  "Не удалось сохранить заявку. Отправка не выполнена.": "No se ha podido guardar la solicitud. No se ha enviado.",
  "от {0} C в минуту": "Desde {0} C por minuto",
  "от {0} C за 100 знаков": "Desde {0} C por cada 100 caracteres",
  "Проверить статус заказа": "Comprobar el estado del pedido",
  "Статус пока не подтверждён. Проверьте этот же заказ позже.": "El estado aún no está confirmado. Comprueba este mismo pedido más tarde.",
  "в минуту": "por minuto",
  "за 100 знаков": "por cada 100 caracteres",
  "Анимация звука": "Animación del sonido",
  "В видео останется исходная речь. Выберите фрагмент до одной минуты.": "El video conservará el audio original. Seleccione un fragmento de hasta un minuto.",
  "В видео останутся исходные слова. Голос можно изменить. Выберите фрагмент до одной минуты.": "El video conservará las palabras originales. Puede cambiar la voz. Seleccione un fragmento de hasta un minuto.",
  "Вид персонажа": "Aspecto del personaje",
  "Видео готово": "Video listo",
  "Видео не создано": "No se ha creado el video",
  "Волна": "Onda",
  "Выберите, кто говорит": "Seleccione quién habla",
  "Выбранное фото": "Foto seleccionada",
  "Движение": "Movimiento",
  "Добавьте видео": "Añada un video",
  "Дополнительная настройка": "Configuración adicional",
  "Другой голос для записи": "Otra voz para la grabación",
  "Ещё вариант": "Otra opción",
  "Ещё настройки": "Más ajustes",
  "Изменить данные": "Editar datos",
  "Источник": "Fuente",
  "Источник лица": "Fuente del rostro",
  "Источник речи": "Fuente de voz",
  "Кадр по вертикали": "Encuadre vertical",
  "Кадр по горизонтали": "Encuadre horizontal",
  "Каких движений избегать": "Qué movimientos evitar",
  "Конец фрагмента, секунды": "Final del fragmento, segundos",
  "Кружком": "Como videomensaje",
  "Кружок готов": "Círculo listo",
  "Кружок не создан": "No se ha creado el círculo",
  "Люди и персонажи": "Personas y personajes",
  "Напишите текст или добавьте запись": "Escriba un texto o añada una grabación",
  "Начало фрагмента, секунды": "Inicio del fragmento, segundos",
  "Не удалось загрузить виды персонажа.": "No se pudieron cargar los aspectos de los personajes.",
  "Не удалось загрузить людей и персонажей.": "No se pudieron cargar las personas y los personajes.",
  "Не удалось подтвердить завершение заказа. Новая генерация не начата.": "No se pudo confirmar la finalización del pedido. No se ha iniciado una nueva generación.",
  "Не удалось проверить доставку. Откройте историю заказа.": "No se pudo verificar la entrega. Abra el historial del pedido.",
  "Оставить голос записи": "Conservar la voz de la grabación",
  "Открыть в чате": "Abrir en el chat",
  "Отправлено в чат": "Enviado al chat",
  "По умолчанию": "Por defecto",
  "Подтвердите право использовать материалы": "Confirme que tiene derecho a utilizar los materiales",
  "Полосы": "Franjas",
  "Портретное": "Formato vertical",
  "Прежний заказ ещё не завершён. Сначала проверьте его результат.": "El pedido anterior aún no ha finalizado. Compruebe primero su resultado.",
  "Приближение": "Acercamiento",
  "Проверка отклонила материал. Измените исходные данные.": "La verificación ha rechazado el material. Modifique los datos de origen.",
  "Продолжить проверку отправки": "Continuar verificando el envío",
  "Результат недоступен. Проверьте историю заказа.": "El resultado no está disponible. Compruebe el historial del pedido.",
  "Результат отправки пока не подтверждён. Продолжите проверку с тем же ключом.": "El resultado del envío aún no está confirmado. Continúe la verificación con la misma clave.",
  "Результат пока не подтверждён. Проверьте этот заказ, прежде чем создавать новый.": "El resultado aún no está confirmado. Compruebe este pedido antes de crear uno nuevo.",
  "Своё видео": "Tu propio video",
  "Своё фото": "Tu propia foto",
  "Создание сейчас недоступно": "La creación no está disponible en este momento",
  "Создать кружок": "Crear videomensaje",
  "Создаём видео": "Creando el video",
  "Списание возвращено": "Se ha reembolsado el cargo",
  "Тестовый заказ без списания": "Pedido de prueba sin cargo",
  "Файлом": "Como archivo",
  "Фоновый звук": "Sonido de fondo",
  "Фото с лицом": "Foto con rostro",
  "Цена или версия инструмента изменилась. Обновите форму и проверьте стоимость.": "El precio o la versión de la herramienta ha cambiado. Actualice el formulario y compruebe el coste.",
  "Человек или персонаж": "Persona o personaje",
  "Что скажет?": "¿Qué dirá?",
  "Напишите не меньше {0} знаков": "Escribe al menos {0} caracteres",
  "Текст отклонён проверкой. Измените текст.": "El texto ha sido rechazado durante la revisión. Modifica el texto.",
  "В видео прозвучат новые слова.": "En el video se escucharán palabras nuevas.",
  "Если речь длиннее видео, ролик повторится.": "Si el discurso es más largo que el video, el clip se repetirá.",
  "Исходная речь": "Discurso original",
  "Новая запись": "Nueva grabación",
  "Новые слова текстом": "Palabras nuevas en texto",
  "Речь в видео": "Discurso en el video",
  "Размер файла не должен превышать {0} МБ.": "El archivo no debe superar {0} MB.",
  "До {0} МБ": "Hasta {0} MB",
  "Альбомное": "Horizontal",
  "Альбомом": "En formato horizontal",
  "Без стиля": "Sin estilo",
  "В новом стиле": "Con un estilo nuevo",
  "Вариант": "Variante",
  "Во весь экран": "Pantalla completa",
  "Восстановить фото": "Restaurar foto",
  "Все стили": "Todos los estilos",
  "Все темы": "Todos los temas",
  "Выберите инструмент в каталоге, затем подтвердите использование фото.": "Selecciona una herramienta del catálogo y luego confirma el uso de la foto.",
  "Выберите подходящее фото до {0} МБ.": "Selecciona una foto adecuada de hasta {0} MB.",
  "Выберите стиль или свой референс": "Elige un estilo o una referencia propia",
  "Выбран свой референс": "Referencia propia seleccionada",
  "Выбрать стиль": "Elegir estilo",
  "Двигайте картинку, чтобы выбрать кадр": "Mueve la imagen para seleccionar el encuadre",
  "Диафрагма": "Apertura",
  "Добавить человека": "Añadir persona",
  "Добавьте описание, от 10 знаков": "Añade una descripción de al menos 10 caracteres",
  "Загрузите фото": "Sube una foto",
  "Заполните обязательные поля": "Completa los campos obligatorios",
  "Изменить фото": "Cambiar foto",
  "Использовать выбранное фото результата": "Usar la foto de resultado seleccionada",
  "Кадр": "Encuadre",
  "Кадрирование": "Recorte",
  "Как у фото": "Como en la foto",
  "Камера": "Cámara",
  "Найти настройку съёмки": "Buscar ajustes de fotografía",
  "Найти стиль": "Buscar estilo",
  "Настройки съёмки недоступны.": "Los ajustes de fotografía no están disponibles.",
  "Начать новое улучшение": "Iniciar una nueva mejora",
  "Не выбран": "Ninguno seleccionado",
  "Не удалось восстановить улучшение. Новая отправка заблокирована.": "No se pudo restaurar la mejora. Se ha bloqueado un nuevo envío.",
  "Не удалось загрузить режимы фото.": "No se pudieron cargar los modos de foto.",
  "Не удалось загрузить фото.": "No se pudo cargar la foto.",
  "Не удалось использовать фото результата. Откройте исходный заказ и попробуйте снова.": "No se pudo usar la foto del resultado. Abre el pedido original e inténtalo de nuevo.",
  "Не удалось открыть режим. Попробуйте ещё раз.": "No se pudo abrir el modo. Inténtalo de nuevo.",
  "Не удалось передать выбранное фото. Попробуйте снова.": "No se pudo transferir la foto seleccionada. Inténtalo de nuevo.",
  "Не удалось проверить владельца.": "No se pudo verificar al propietario.",
  "Не удалось прочитать фото.": "No se pudo leer la foto.",
  "Не удалось улучшить текст. Исходный текст сохранён.": "No se pudo mejorar el texto. Se ha conservado el texto original.",
  "О стиле": "Sobre el estilo",
  "Объектив": "Objetivo",
  "Оживить фото": "Animar foto",
  "Описание во весь экран": "Descripción a pantalla completa",
  "Описание длиннее допустимого": "La descripción supera la longitud permitida",
  "По вертикали": "Vertical",
  "По горизонтали": "Horizontal",
  "По описанию": "Según la descripción",
  "Повторить прежнее улучшение": "Repetir la mejora anterior",
  "Подтвердите права на материалы": "Confirma los derechos sobre los materiales",
  "Пример": "Ejemplo",
  "Проверить улучшение": "Verificar mejora",
  "Проверяем фото…": "Comprobando la foto…",
  "Ракурс": "Ángulo",
  "Раскрасить чёрно-белое": "Colorear foto en blanco y negro",
  "Режим фото": "Modo de foto",
  "Референс должен быть не меньше 256 × 256 пикселей.": "La referencia debe tener al menos 256 × 256 píxeles.",
  "Свернуть": "Contraer",
  "Свет": "Iluminación",
  "Свой референс": "Referencia propia",
  "Свой референс сейчас недоступен": "La referencia propia no está disponible en este momento",
  "Сделать рилс": "Crear un reel",
  "Сколько фото": "Número de fotos",
  "Создать фото": "Crear foto",
  "Создаём фото": "Creando foto",
  "Срок проверки улучшения истёк. Исходный текст сохранён.": "Se ha agotado el tiempo de verificación de la mejora. Se ha conservado el texto original.",
  "Тема стиля": "Tema del estilo",
  "Убрать из кадра": "Eliminar del encuadre",
  "Улучшение пока не подтверждено. Исходный текст сохранён.": "La mejora aún no se ha confirmado. Se ha conservado el texto original.",
  "Улучшить": "Mejorar",
  "Формат файла": "Formato de archivo",
  "Фото готовы": "Fotos listas",
  "Фото на аватарку": "Foto de perfil",
  "Фото не создано": "No se ha creado la foto",
  "Цвет": "Color",
  "Что дальше": "Qué sigue",
  "Что делает в кадре": "Qué hace en el encuadre",
  "Выберите разных людей в кадре": "Elige personas diferentes para la escena",
  "Измените описание и попробуйте улучшить его снова.": "Cambia la descripción e intenta mejorarla de nuevo.",
  "Использовать референс": "Usar referencia",
  "Авто": "Auto",
  "Без движения": "Sin movimiento",
  "Видео должно длиться не меньше секунды": "El vídeo debe durar al menos un segundo",
  "Выберите главное фото": "Selecciona la foto principal",
  "Выберите один исходный файл": "Elige un solo archivo de origen",
  "Выберите файл подходящего формата и размера": "Elige un archivo con formato y tamaño admitidos",
  "Выберите фрагмент от 1 до 10 секунд": "Selecciona un fragmento de 1 a 10 segundos",
  "Главное фото": "Foto principal",
  "Длительность исходника: {0} с": "Duración del original: {0} s",
  "Добавить речь": "Añadir voz",
  "Загрузите видео": "Sube un vídeo",
  "Загрузите фото или видео": "Sube una foto o un vídeo",
  "Загрузить": "Subir",
  "Загрузить видео": "Subir vídeo",
  "Загрузить фото": "Subir foto",
  "Звук исходника не сохраняется: модель создаёт новый звук.": "No se conserva el audio original: el modelo crea uno nuevo.",
  "Звук от модели": "Audio del modelo",
  "Звук создаёт модель: фон, шумы и музыка. Речь можно добавить после создания.": "El modelo crea sonido ambiente, ruidos y música. Puedes añadir voz después.",
  "Использовать видео результата": "Usar el vídeo resultante",
  "Исходное видео": "Vídeo original",
  "Исходный файл": "Archivo original",
  "Как двигаться": "Cómo moverse",
  "Конец фрагмента, мс": "Fin del fragmento, ms",
  "Конец, секунды": "Fin, segundos",
  "Люди в кадре недоступны для этого режима": "Este modo no permite personas en escena",
  "Начало фрагмента, мс": "Inicio del fragmento, ms",
  "Начало, секунды": "Inicio, segundos",
  "Не удалось загрузить режимы видео.": "No se pudieron cargar los modos de vídeo.",
  "Не удалось использовать видео результата. Откройте исходный заказ и попробуйте снова.": "No se pudo usar el vídeo resultante. Abre el pedido original e inténtalo de nuevo.",
  "Не удалось передать видео. Откройте исходный заказ и попробуйте снова.": "No se pudo transferir el vídeo. Abre el pedido original e inténtalo de nuevo.",
  "Новое": "Nuevo",
  "Объёмное фото создаётся без звука": "La foto con volumen se crea sin sonido",
  "Первый кадр": "Primer fotograma",
  "Продолжить загрузку": "Continuar carga",
  "Разрешение": "Resolución",
  "Режим видео": "Modo de vídeo",
  "Снимем из главного фото. Выберите главное фото для кадрирования.": "Usaremos la foto principal. Selecciona la principal para recortarla.",
  "Снять": "Capturar",
  "Снять видео": "Grabar vídeo",
  "Создать видео": "Crear vídeo",
  "Темп": "Ritmo",
  "Формат задаёт инструмент: портрет 3:4, ролик на 5 секунд": "Formato fijo: vertical 3:4, vídeo de 5 segundos",
  "Фото товара": "Fotos del producto",
  "Фрагмент от 1 до 10 секунд": "Fragmento de 1 a 10 segundos",
  "Хит": "Popular",
  "Что изменить": "Qué cambiar",
  "Этот режим видео пока недоступен": "Este modo de vídeo no está disponible por ahora",
  "Как у исходника": "Como el original",
  "Со звуком": "Con sonido",
  "Без звука": "Sin sonido",
  "5 секунд": "5 segundos",
  "10 секунд": "10 segundos",
  "Не удалось прочитать файл.": "No se pudo leer el archivo.",
  "1. Видео с вами": "1. Vídeo contigo",
  "1. Видео с движениями": "1. Vídeo de movimientos",
  "2. Кем стать": "2. En quién convertirte",
  "2. Кто повторит": "2. Quién lo repetirá",
  "Видео должно длиться не меньше {0} секунд": "El vídeo debe durar al menos {0} segundos",
  "Водяной знак — недоступен": "Marca de agua: no disponible",
  "Вы, близкий или персонаж": "Tú, alguien cercano o un personaje",
  "Выберите допустимый фрагмент видео": "Selecciona un fragmento de duración permitida",
  "Выберите одного героя": "Elige un solo protagonista",
  "Выберите фон": "Selecciona un fondo",
  "Выберите, кто повторит движения": "Elige quién repetirá los movimientos",
  "Голос героя — недоступен": "Voz del personaje: no disponible",
  "Другой голос — недоступен": "Otra voz: no disponible",
  "Загрузите видео с движениями": "Sube un vídeo de movimientos",
  "Из видео": "Del vídeo",
  "Изменить людей и свои фото": "Gestionar personas y tus fotos",
  "Источник героя": "Origen del protagonista",
  "Исходный звук сохраняется, если он есть в ролике.": "Se conserva el audio original si el vídeo lo tiene.",
  "Кадр, ракурс и фон берутся с фото героя.": "El encuadre, el ángulo y el fondo se toman de la foto del protagonista.",
  "Кто повторит движения": "Quién repetirá los movimientos",
  "На фото должны быть видны голова, плечи и корпус.": "En la foto deben verse la cabeza, los hombros y el torso.",
  "Нужен один человек в кадре. На фото и видео должны быть видны голова, плечи и корпус.": "Debe haber una sola persona en el encuadre. En la foto y el vídeo deben verse la cabeza, los hombros y el torso.",
  "Подтвердите права и согласие человека": "Confirma tus derechos y el consentimiento de la persona",
  "Подтверждаю права на материалы и согласие человека на использование его изображения": "Confirmo mis derechos sobre los materiales y el consentimiento de la persona para usar su imagen",
  "Преобразование в кружок недоступно: в результате нет подтверждённой звуковой дорожки.": "No se puede convertir a vídeo circular: el resultado no tiene una pista de audio confirmada.",
  "Режим движения": "Modo de movimiento",
  "С героя": "Del protagonista",
  "Смена голоса пока недоступна": "El cambio de voz no está disponible por ahora",
  "Снять выбор": "Quitar selección",
  "Сохранение исходного звука не подтверждено.": "No se ha confirmado la conservación del audio original.",
  "Стать персонажем": "Convertirte en un personaje",
  "Сцена и движения берутся из видео; внешность может отличаться.": "La escena y los movimientos se toman del vídeo; la apariencia puede variar.",
  "Только свои фото или с согласием человека на фото": "Solo tus fotos o fotos con el consentimiento de la persona",
  "Фон": "Fondo",
  "Фото героя": "Foto del protagonista",
  "Фрагмент от {0} до {1} секунд": "Fragmento de {0} a {1} segundos",
  "{0} символов": "{0} caracteres",
  "Авито": "Avito",
  "Английский": "Inglés",
  "Выберите аудио или видео": "Elige audio o vídeo",
  "Выбрать": "Elegir",
  "Гарантия": "Garantía",
  "Да": "Sí",
  "Для чего нужен промпт": "Para qué es el prompt",
  "Для этого инструмента сократите текст до 500 символов.": "Acorta el texto a 500 caracteres para esta herramienta.",
  "Добавьте текст": "Añade texto",
  "Добавьте файл": "Añade un archivo",
  "Дополнительные варианты": "Más variantes",
  "Дополнительные варианты пока не подтверждены.": "Las variantes adicionales aún no están confirmadas.",
  "Дружелюбный": "Cercano",
  "Загрузите запись или запишите голос. Распознавание начнётся после подтверждения.": "Sube una grabación o graba tu voz. La transcripción empieza tras confirmar.",
  "Исходное фото": "Foto original",
  "Как изменить текст": "Cómo cambiar el texto",
  "Комплект": "Contenido del paquete",
  "Короткий": "Breve",
  "Материал": "Material",
  "Музыка": "Música",
  "На весь экран": "Pantalla completa",
  "Не удалось открыть инструмент. Проверьте аккаунт и длину текста.": "No se pudo abrir la herramienta. Revisa la cuenta y la longitud del texto.",
  "Не удалось подтвердить дополнительные варианты. Проверьте тот же запрос.": "No se pudieron confirmar las variantes. Comprueba la misma solicitud.",
  "Не удалось скачать текст.": "No se pudo descargar el texto.",
  "Не удалось скопировать текст.": "No se pudo copiar el texto.",
  "Не удалось сохранить черновик. Создание заблокировано, чтобы не потерять данные.": "No se pudo guardar el borrador. La creación está bloqueada para evitar perder datos.",
  "Нейтральный": "Neutro",
  "Нет": "No",
  "Объём описания": "Longitud de la descripción",
  "Описание товара": "Descripción del producto",
  "Повторить запрос с тем же ключом": "Reintentar con la misma clave",
  "Подарочный": "Para regalo",
  "Подробнее": "Más detalle",
  "Подробный": "Detallado",
  "Подтверждаю права на материалы": "Confirmo mis derechos sobre los materiales",
  "Пожелания": "Preferencias",
  "Показать время": "Mostrar tiempos",
  "Показать всё": "Mostrar todo",
  "Премиальный": "Premium",
  "Проверить тот же запрос": "Comprobar la misma solicitud",
  "Продающий": "Orientado a ventas",
  "Промпт из видео пока недоступен.": "Crear prompts desde vídeo aún no está disponible.",
  "Промпт из фото": "Prompt desde foto",
  "Разделить по собеседникам": "Separar hablantes",
  "Размеры": "Dimensiones",
  "Распознавание по ссылке YouTube пока недоступно.": "La transcripción desde enlaces de YouTube aún no está disponible.",
  "Распознать": "Transcribir",
  "Редактировать текст": "Editar texto",
  "Сайт": "Sitio web",
  "Сбросить сохранённый черновик": "Restablecer borrador guardado",
  "Скачать TXT": "Descargar TXT",
  "Скопировать весь текст": "Copiar todo el texto",
  "Собеседник {0}": "Hablante {0}",
  "Создать промпт": "Crear un prompt",
  "Создать сценарий": "Crear un guion",
  "Создаём текст": "Creando texto",
  "Сократите пожелания": "Acorta las preferencias",
  "Сократите текст": "Acorta el texto",
  "Список": "Lista",
  "Текст готов": "Texto listo",
  "Текст из аудио и видео": "Texto de audio y vídeo",
  "Текст не создан": "No se creó el texto",
  "Тестовый режим без списания": "Modo de prueba sin cargos",
  "Тон описания": "Tono de la descripción",
  "Улучшить промпт": "Mejorar un prompt",
  "Уход": "Cuidados",
  "Что добавить в описание": "Qué añadir a la descripción",
  "Экспертный": "Experto",
  "Язык": "Idioma",
  "Яндекс Маркет": "Yandex Market",
  "Добавьте фото в открывшемся инструменте.": "Añade una foto en la herramienta abierta.",
  "Не удалось открыть фото.": "No se pudo abrir la foto.",
  "Текст для видео": "Texto para el vídeo",
  "Цена этого выбора пока не подтверждена": "El precio de esta opción aún no está confirmado",
  "C за фото": "C por foto",
  "C за секунду": "C por segundo",
  "Обычный": "Normal",
  "Кто повторил": "Quién lo repitió",
  "Человек с фото": "Persona de la foto",
  "Сменить фон": "Cambiar fondo",
  "Убрать лишнее": "Quitar lo que sobra",
  "Добавить очки": "Añadir gafas",
  "Причёска": "Peinado",
  "Улыбка": "Sonrisa",
  "Деловой образ": "Estilo formal",
  "Летний фон": "Fondo de verano",
  "Машет рукой": "Saluda con la mano",
  "Ветер": "Viento",
  "Плавнее": "Más fluido",
  "Ярче": "Más brillo",
  "День в ночь": "Del día a la noche",
  "Снег": "Nieve",
  "Очки": "Gafas",
  "Что должно быть на фото? Например: девушка с зонтом на мокрой улице, вечер, огни витрин": "¿Qué debe aparecer en la foto? Por ejemplo: una chica con paraguas en una calle mojada, al atardecer, luces de escaparates",
  "Что поменять на фото? Например: замени фон на ночной город, добавь очки": "¿Qué cambiar en la foto? Por ejemplo: cambia el fondo por una ciudad de noche, añade gafas",
  "Что добавить или поменять? Например: деловой костюм, лёгкая улыбка": "¿Qué añadir o cambiar? Por ejemplo: un traje formal, una ligera sonrisa",
  "Что происходит в ролике? Например: камера медленно летит над ночным городом, огни и мокрый асфальт": "¿Qué pasa en el vídeo? Por ejemplo: la cámara vuela despacio sobre una ciudad de noche, luces y asfalto mojado",
  "Как двигаться? Например: улыбается и машет рукой, ветер в волосах": "¿Cómo moverse? Por ejemplo: sonríe y saluda con la mano, viento en el pelo",
  "Что поменять в видео? Например: замени фон на ночной город, добавь снег": "¿Qué cambiar en el vídeo? Por ejemplo: cambia el fondo por una ciudad de noche, añade nieve",
  "Что добавить? Например: движения плавнее, ярче": "¿Qué añadir? Por ejemplo: movimientos más fluidos, más brillo",
  "Сменить голос в записи": "Cambiar la voz de una grabación",
  "Загрузите запись": "Sube una grabación",
  "Ваша речь зазвучит выбранным голосом": "Tus palabras sonarán con la voz elegida",
  "Голосовое, интервью или заметку: уберём шум": "Un mensaje de voz, una entrevista o una nota: quitaremos el ruido",
  "Библиотека и ваши клоны": "Biblioteca y tus clones",
  "Без переозвучки, выберите другой": "Sin conversión de voz, elige otra",
  "· Мой голос": "· Mi voz",
  "· ещё {0}+ голосов": "· {0}+ voces más",
  "Убрать шум": "Quitar ruido",
  "Перед сменой голоса уберём фон и эхо": "Antes de cambiar la voz quitaremos el fondo y el eco",
  "Оставим только голос, без фона и эха": "Dejaremos solo la voz, sin fondo ni eco",
  "Голосовым или файлом: выберете, когда запись будет готова": "Como mensaje de voz o archivo: lo elegirás cuando la grabación esté lista",
  "Сменить голос": "Cambiar voz",
  "Сделать голосовым": "Convertir en mensaje de voz",
  "{0} · от {1} C": "{0} · desde {1} C",
  "Сначала остановите запись": "Primero detén la grabación",
  "Загрузите или запишите аудио": "Sube o graba un audio",
  "Читаем запись, секунду": "Leyendo la grabación, un momento",
  "Запись длиннее {0}, загрузите короче": "La grabación dura más de {0}, sube una más corta",
  "Выберите голос, которым зазвучит запись": "Elige la voz con la que sonará la grabación",
  "Этот голос не умеет переозвучку, выберите другой": "Esta voz no admite conversión, elige otra",
  "Пауза": "Pausa",
  "Длиннее {0}": "Más de {0}",
  "Звучит запись": "Reproduciendo la grabación",
  "Прослушать запись": "Escuchar la grabación",
  "Загрузите запись короче": "Sube una grabación más corta",
  "Запись с микрофона": "Grabación del micrófono",
  "Без шума": "Sin ruido",
  "Как в записи": "Como en la grabación",
  "Слушать": "Escuchar",
  "Отправить голосовым": "Enviar como mensaje de voz",
  "Отправить файлом": "Enviar como archivo",
  "Голосовое в чате": "Mensaje de voz en el chat",
  "Файл в чате": "Archivo en el chat",
  "Голосовое в чате, в отдельной теме": "Mensaje de voz en el chat, en un tema aparte",
  "Файл в чате, в отдельной теме": "Archivo en el chat, en un tema aparte",
  "Тут откроется тема чата, куда бот прислал голосовое": "Aquí se abrirá el tema del chat donde el bot envió el mensaje de voz",
  "Тут откроется тема чата, куда бот прислал запись": "Aquí se abrirá el tema del chat donde el bot envió la grabación",
  "Меняем голос": "Cambiando la voz",
  "Собираем запись": "Montando la grabación",
  "Шум убран": "Ruido eliminado",
  "Запись готова": "La grabación está lista",
  "Голос изменён": "Voz cambiada",
  "Можно уйти с экрана: бот напишет, когда запись будет готова.": "Puedes salir de la pantalla: el bot te escribirá cuando la grabación esté lista.",
  "Голос ваш, шума больше нет.": "Tu voz, sin ruido.",
  "Голос ваш, запись готова стать голосовым.": "Tu voz, y la grabación está lista para convertirse en mensaje de voz.",
  "Слова и интонация ваши, голос новый.": "Tus palabras y tu entonación, con una voz nueva.",
  "Пришлём в чат голосовым или файлом, как удобнее.": "Te lo enviaremos al chat como mensaje de voz o archivo, como prefieras.",
  "Запись ещё собирается": "La grabación aún se está montando",
  "Заставить говорить": "Hacer que hable",
  "Заменить запись": "Reemplazar la grabación",
  "Загружаем запись": "Subiendo la grabación",
  "Запись загружена": "Grabación subida",
  "Запись собрана": "Grabación montada",
  "Запись не прошла проверку": "La grabación no superó la revisión",
  "запись не собрана": "la grabación no se montó",
  "голос не изменён": "la voz no se cambió",
  "Не получилось убрать шум": "No se pudo quitar el ruido",
  "Не получилось собрать запись": "No se pudo montar la grabación",
  "Не получилось сменить голос": "No se pudo cambiar la voz",
  "Обновить форму": "Actualizar el formulario",
  "Запись {0}": "Grabación {0}",
  "Проверяем доступность": "Comprobando la disponibilidad",
  "Загрузите запись заново": "Vuelve a subir la grabación",
  "Не удалось выбрать голос. Попробуйте ещё раз.": "No se pudo elegir la voz. Inténtalo de nuevo.",
  "Запись здесь недоступна, загрузите файл": "Aquí no se puede grabar, sube un archivo",
  "Не удалось прочитать запись, попробуйте ещё раз": "No se pudo leer la grabación, inténtalo de nuevo",
  "Ваш голос": "Tu voz",
  "в аудио": "en el audio",
  "со скидкой, {0} водяной знак": "con descuento, marca de agua {0}",
  "Запись ещё загружается": "La grabación aún se está cargando",
  "Проверяем отправку": "Comprobando el envío",
  "Этот способ отправки сейчас недоступен": "Este método de envío no está disponible ahora",
  "Отправка пока не подтверждена. Нажмите ещё раз — проверим тот же запрос.": "El envío aún no está confirmado. Pulsa de nuevo y comprobaremos la misma solicitud.",
  "Не удалось передать запись. Откройте работу в «Истории» и попробуйте снова.": "No se pudo pasar la grabación. Abre el trabajo en «Historial» y vuelve a intentarlo.",
  "Попробовать ещё раз": "Intentar de nuevo",
  "Проверить ещё раз": "Comprobar de nuevo",
  "К настройкам": "Volver a los ajustes",
  "Заказ не создан": "Pedido no creado",
  "Заказ не подтверждён": "Pedido no confirmado",
  "остаток": "saldo",
  "Права на материалы": "Derechos sobre los materiales",
  "Только свои файлы или с согласия владельца": "Solo archivos propios o con el consentimiento del titular",
  "Загружаем файл": "Subiendo el archivo",
  "Создаём": "Creando",
  "Файл больше {0} МБ, загрузите меньше": "El archivo supera los {0} MB, sube uno más pequeño",
  "Фото меньше {0} × {1} пикселей, загрузите крупнее": "La foto es menor de {0} × {1} píxeles, sube una más grande",
  "Видео длиннее {0}, загрузите короче": "El vídeo dura más de {0}, sube uno más corto",
  "Запись короче {0}, загрузите длиннее": "La grabación dura menos de {0}, sube una más larga",
  "Видео короче {0}, загрузите длиннее": "El vídeo dura menos de {0}, sube uno más largo",
  "Не удалось открыть фото. Загрузите его заново.": "No se pudo abrir la foto. Vuelve a subirla.",
  "Не удалось открыть видео. Загрузите его заново.": "No se pudo abrir el vídeo. Vuelve a subirlo.",
  "Можно до {0} фото": "Hasta {0} fotos",
  "Этот человек не участвует": "Esta persona no participa",
  "Добавьте фото": "Añade fotos",
  "Файл не читается, загрузите другой": "No se puede leer el archivo, sube otro",
  "Запись слишком короткая": "La grabación es demasiado corta",
  "Не удалось открыть запись для прослушивания. Загрузите её заново.": "No se pudo abrir la grabación para escucharla. Vuelve a subirla.",
  "Файл не прошёл проверку. Выберите другой файл.": "El archivo no superó la comprobación. Elige otro archivo.",
  "Слишком много загрузок подряд. Подождите минуту и выберите файл снова.": "Demasiadas cargas seguidas. Espera un minuto y vuelve a elegir el archivo.",
  "Файл не принят. Выберите его снова.": "El archivo no se aceptó. Vuelve a elegirlo.",
  "Выбранный персонаж, голос или шаблон стал недоступен. Выберите другой — заказ не создан.": "El personaje, la voz o la plantilla elegidos ya no están disponibles. Elige otro: el pedido no se ha creado.",
  "Создание сейчас недоступно. Заказ не создан, Circle не списаны.": "La creación no está disponible ahora. El pedido no se ha creado y no se han descontado Circle.",
  "Предыдущая работа ещё создаётся. Когда она будет готова, отправьте заказ снова.": "El trabajo anterior aún se está creando. Cuando esté listo, vuelve a enviar el pedido.",
  "Политику и запрещённые темы не пропускаем.": "No admitimos política ni temas prohibidos.",
  "{0} C списаны, {1}.": "Se han descontado {0} C, {1}.",
  "{0} C вернулись на баланс.": "{0} C han vuelto a tu saldo.",
  ", на шаге «{0}»": ", en el paso «{0}»",
  "Сбой на нашей стороне": "Fallo por nuestra parte",
  "{0} или {1}": "{0} o {1}",
  "до {0}": "hasta {0}",
  "Записать": "Grabar",
  "Заменить": "Reemplazar",
  "Нужна запись: MP3, WAV или M4A": "Se necesita una grabación: MP3, WAV o M4A",
  "Нужно фото: JPG или PNG": "Se necesita una foto: JPG o PNG",
  "Нужно видео: MP4 или MOV": "Se necesita un vídeo: MP4 o MOV",
  "Нужен файл PDF, DOCX или TXT": "Se necesita un archivo PDF, DOCX o TXT",
  "Нужно фото или видео": "Se necesita una foto o un vídeo",
  "Файл больше {0} МБ": "El archivo supera los {0} MB",
  "Остановить запись": "Detener la grabación",
  "Запрашиваем микрофон": "Solicitando el micrófono",
  "Отменить запись": "Cancelar la grabación",
  "{0} КБ": "{0} KB",
  "{0} МБ": "{0} MB",
  "Не хватает {0} C · Пополнить": "Faltan {0} C · Añadir saldo",
  "Не хватает Circle": "No hay suficientes Circle",
  "Не хватает {0} C": "Faltan {0} C",
  "На балансе {0} C, нужно {1} C": "Tienes {0} C, se necesitan {1} C",
  "Создать за {0} вместо {1} C": "Crear por {0} en lugar de {1} C",
  "Создать за {0} C вместо {1} C": "Crear por {0} C en lugar de {1} C",
  "Со скидкой всё равно не хватает {0}": "Incluso con descuento faltan {0}",
  "Со скидкой всё равно не хватает {0} C": "Incluso con descuento faltan {0} C",
  "Для этой работы скидки нет": "No hay descuento para este trabajo",
  "Сделать дешевле на {0}%, с водяным знаком": "Hacerlo un {0}% más barato, con marca de agua",
  "Сделать дешевле на 10%, с водяным знаком": "Hacerlo un 10% más barato, con marca de agua",
  "Назад в студию": "Volver al estudio",
  "Работа ещё создаётся": "El trabajo aún se está creando",
  "Ваше фото": "Tu foto",
  "Ваши фото": "Tus fotos",
  "Ваш текст": "Tu texto",
  "Ваша тема": "Tu tema",
  "Тема поста": "Tema de la publicación",
  "Готовые кадры": "Fotos listas",
  "Готовый кружок": "Círculo listo",
  "Готовый ролик": "Vídeo listo",
  "Готовое фото": "Foto lista",
  "Готовая аватарка": "Avatar listo",
  "Готовые слайды": "Diapositivas listas",
  "Готовый сюжет с вами: монтаж и музыка уже в шаблоне": "Una historia lista contigo: el montaje y la música ya están en la plantilla",
  "Пост в стиле шаблона, {0} на выбор": "Una publicación al estilo de la plantilla, {0} para elegir",
  "Аватарка для соцсетей и мессенджеров, {0} на выбор": "Un avatar para redes sociales y mensajería, {0} para elegir",
  "Фотосессия из {0} кадра в стиле шаблона": "Una sesión de {0} foto al estilo de la plantilla",
  "Фотосессия из {0} кадров в стиле шаблона": "Una sesión de {0} fotos al estilo de la plantilla",
  "Ваш снимок оживёт в коротком ролике, {0} на выбор": "Tu foto cobrará vida en un vídeo corto, {0} para elegir",
  "Персонаж скажет ваш текст в кружке Telegram, {0} на выбор": "Un personaje dirá tu texto en un círculo de Telegram, {0} para elegir",
  "Карусель слайдов для поста, {0} на выбор": "Un carrusel de diapositivas para la publicación, {0} para elegir",
  "{0} стиль": "{0} estilo",
  "{0} стиля": "{0} estilos",
  "{0} стилей": "{0} estilos",
  "{0}, выберете на следующем шаге": "{0}, elegirás en el siguiente paso",
  "Что скажет герой, до 250 знаков": "Lo que dirá el personaje, hasta 250 caracteres",
  "1 фото": "1 foto",
  "Любое, где хорошо видно лицо": "Cualquiera en la que se vea bien la cara",
  "Лицо крупно и при хорошем свете": "Cara en primer plano y con buena luz",
  "Селфи, лицо крупно": "Un selfi, cara en primer plano",
  "Снимок оживёт в ролике": "La foto cobrará vida en un vídeo",
  "Или фото, из которых сделаем слайды": "O fotos con las que haremos las diapositivas",
  "Стиль кружка": "Estilo del círculo",
  "1 человек": "1 persona",
  "Вы, близкие или персонаж": "Tú, alguien cercano o un personaje",
  "Ваши дети, до {0}": "Tus hijos, hasta {0}",
  "Ребёнок, одно фото": "Un niño, una foto",
  "Питомец, одно фото": "Una mascota, una foto",
  "Вы или близкие, одно фото": "Tú o alguien cercano, una foto",
  "По желанию: вы, близкие или персонаж": "Opcional: tú, alguien cercano o un personaje",
  "По желанию: ваши дети, до {0}": "Opcional: tus hijos, hasta {0}",
  "По желанию: ребёнок, одно фото": "Opcional: un niño, una foto",
  "По желанию: питомец, одно фото": "Opcional: una mascota, una foto",
  "По желанию: вы или близкие, одно фото": "Opcional: tú o alguien cercano, una foto",
  "Reels": "Reels",
  "Аватар": "Avatar",
  "{0} кадр": "{0} foto",
  "{0} кадра": "{0} fotos",
  "{0} кадров": "{0} fotos",
  "Выбрать, кто играет: {0}": "Elegir quién actúa: {0}",
  "Сравнить: {0} и {1}": "Comparar: {0} y {1}",
  "Поровну": "Mitad y mitad",
  "Пример результата пока не опубликован": "El ejemplo del resultado aún no se ha publicado",
  "Результат сохранён в «Истории». В чат не отправляем — так выбрано в настройках.": "El resultado está guardado en «Historial». No lo enviamos al chat: así lo elegiste en los ajustes.",
  "Результат сохранён в «Истории».": "El resultado está guardado en «Historial».",
  "Файл результата пока недоступен. Проверьте работу в «Истории».": "El archivo del resultado aún no está disponible. Revisa el trabajo en «Historial».",
  ", голос для: {0}": ", voz para: {0}",
  ", играет: {0}": ", interpreta: {0}",
  ": добавьте свои фото": ": añade tus fotos",
  ": добавьте фото": ": añade fotos",
  "<b class=\"mono\">{0}</b> из <span class=\"mono\">{1}</span>": "<b class=\"mono\">{0}</b> de <span class=\"mono\">{1}</span>",
  "JPG или PNG, до 10 МБ": "JPG o PNG, hasta 10 MB",
  "JPG, PNG · до {0} снимков": "JPG, PNG · hasta {0} fotos",
  "MP3, WAV или M4A, до 50 МБ": "MP3, WAV o M4A, hasta 50 MB",
  "MP4 или MOV, до 200 МБ": "MP4 o MOV, hasta 200 MB",
  "PDF, DOCX или TXT, до 20 МБ": "PDF, DOCX o TXT, hasta 20 MB",
  "{0} и {1}": "{0} y {1}",
  "{0} фото": "{0} fotos",
  "{0} фото · как в жизни": "{0} fotos · como en la vida real",
  "{0}, персонаж": "{0}, personaje",
  "Анфас, вполоборота, с улыбкой и без": "De frente, de tres cuartos, con y sin sonrisa",
  "Без модели": "Sin modelo",
  "Без сильных теней и фильтров": "Sin sombras fuertes ni filtros",
  "Было": "Antes",
  "В близких": "En personas cercanas",
  "В кадре {0}": "En el fotograma: {0}",
  "В кадре уже {0} из {1}: снимите отметку с кого-нибудь": "Ya hay {0} de {1} en el fotograma: desmarca a alguien",
  "В кадре: {0}": "En el fotograma: {0}",
  "В роли «{0}» не больше {1}": "En el papel «{0}», como máximo {1}",
  "В роль «{0}» персонажи не входят": "Los personajes no entran en el papel «{0}»",
  "В роль «{0}» подходят {1}": "Para el papel «{0}» encajan {1}",
  "Варианты делаются из ваших фото в разделе «Свой аватар». Выбранный встаёт в «Кто в кадре» на всех экранах.": "Las variantes se crean a partir de tus fotos en «Avatar propio». La elegida aparece en «Quién aparece en el fotograma» en todas las pantallas.",
  "Ваш питомец из близких": "Tu mascota de personas cercanas",
  "Ваш ребёнок из близких": "Tu hijo de personas cercanas",
  "Ваши фото: один раз для всех инструментов": "Tus fotos: una vez para todas las herramientas",
  "Вкл": "Sí",
  "Впишите имя": "Escribe un nombre",
  "Все <span class=\"mono\">{0}</span>": "Todos <span class=\"mono\">{0}</span>",
  "Все варианты на виду": "Todas las opciones están a la vista",
  "Все персонажи": "Todos los personajes",
  "Вы и персонажи": "Tú y personajes",
  "Вы или персонаж": "Tú o un personaje",
  "Вы, близкие и персонажи": "Tú, personas cercanas y personajes",
  "Вы, свои фото": "Tú, tus fotos",
  "Вы: добавьте свои фото": "Tú: añade tus fotos",
  "Выберите вариант": "Elige una variante",
  "Выберите вариант для поля «{0}»": "Elige una opción para el campo «{0}»",
  "Выберите ниже": "Elige abajo",
  "Выберите одного": "Elige a una persona",
  "Выберите, кто играет: {0}": "Elige quién interpreta: {0}",
  "Выберите, кто это для вас": "Elige quién es para ti",
  "Выбирать во всех инструментах без загрузки": "Elegir en todas las herramientas sin volver a subir",
  "Выбор встанет во все инструменты": "La elección se aplicará a todas las herramientas",
  "Выбрать «{0}»": "Elegir «{0}»",
  "Выбрать вариант": "Elegir una variante",
  "Выбрать: {0}": "Elegir: {0}",
  "Выкл": "No",
  "Выключится, когда выберете вариант": "Se desactivará al elegir una opción",
  "Группы": "Grupos",
  "Добавить": "Añadir",
  "Добавить в кадр": "Añadir al fotograma",
  "Добавьте свои фото": "Añade tus fotos",
  "Добавьте свои фото или вариант": "Añade tus fotos o una variante",
  "Добавьте фото: {0}": "Añade fotos: {0}",
  "Другой голос": "Otra voz",
  "Ещё {0}: {1}": "{0} más: {1}",
  "Заготовки": "Plantillas",
  "Загрузите файл": "Sube un archivo",
  "Загрузить ещё": "Subir más",
  "Закрыть камеру": "Cerrar cámara",
  "Запись недоступна. Загрузите видео.": "La grabación no está disponible. Sube un vídeo.",
  "Здесь подходят {0}": "Aquí encajan {0}",
  "Здесь только персонажи своей подборки": "Aquí solo personajes de su colección",
  "Играет: {0}": "Interpreta: {0}",
  "Из ваших фото": "A partir de tus fotos",
  "Из каталога": "Del catálogo",
  "Изменить ваши фото": "Editar tus fotos",
  "Изменить свои фото": "Editar tus fotos",
  "Изменить: {0}": "Editar: {0}",
  "Иллюстрация": "Ilustración",
  "Имя": "Nombre",
  "Имя и фото · роли выбираются в ряду": "Nombre y fotos · los papeles se eligen en la fila",
  "Искать стиль": "Buscar estilo",
  "Каким вы будете": "Cómo vas a aparecer",
  "Камера · лицо в кадр": "Cámara · cara en el encuadre",
  "Камера · селфи в кадр": "Cámara · selfi en el encuadre",
  "Камера недоступна · имитация": "Cámara no disponible · simulación",
  "Камера недоступна. Загрузите файл.": "La cámara no está disponible. Sube un archivo.",
  "Каталог 2 400+ голосов, подборки": "Catálogo de más de 2400 voces, colecciones",
  "Ко всем стилям": "A todos los estilos",
  "Кто будет моделью на фото": "Quién será el modelo en la foto",
  "Кто играет: <b>{0}</b>": "Quién interpreta: <b>{0}</b>",
  "Кто играет: {0}": "Quién interpreta: {0}",
  "Кто это для вас": "Quién es para ti",
  "Лицо в круг, смотрите в камеру": "Cara en el círculo, mira a la cámara",
  "Люди": "Personas",
  "Можно близких или персонажа": "Personas cercanas o un personaje",
  "Можно ваших близких": "Tus personas cercanas",
  "Можно до {0} видео": "Hasta {0} vídeos",
  "Можно до {0} записей": "Hasta {0} grabaciones",
  "Можно до {0} записи": "Hasta {0} grabaciones",
  "Можно до {0} запись": "Hasta {0} grabación",
  "Можно до {0} файл": "Hasta {0} archivo",
  "Можно до {0} файла": "Hasta {0} archivos",
  "Можно до {0} файлов": "Hasta {0} archivos",
  "Можно и так, но 3 или больше снимков дадут сходство точнее": "Así sirve, pero 3 fotos o más darán un parecido más fiel",
  "Можно и так, но 3 или больше фото дадут сходство точнее": "Así sirve, pero 3 fotos o más darán un parecido más fiel",
  "Можно себя или близких": "Tú o personas cercanas",
  "Можно себя, близких или персонажа": "Tú, personas cercanas o un personaje",
  "На этом экране вы в кадре всегда": "En esta pantalla siempre apareces en el fotograma",
  "Навсегда, вместе с фото": "Para siempre, junto con las fotos",
  "Нажмите, чтобы выбрать": "Pulsa para elegir",
  "Найти": "Buscar",
  "Напишите пару слов, и мы предложим варианты": "Escribe unas palabras y te propondremos opciones",
  "Например: Барсик": "Por ejemplo: Max",
  "Например: Лёша": "Por ejemplo: Álex",
  "Нашли": "Encontrados",
  "Не получилось подготовить файл": "No se pudo preparar el archivo",
  "Не получилось улучшить. Попробуйте дописать пару слов": "No se pudo mejorar. Prueba a añadir unas palabras",
  "Не помещается<span class=\"nfx\">: до {0} знаков</span>": "No cabe<span class=\"nfx\">: hasta {0} caracteres</span>",
  "Необязательно: всё уже настроено": "Opcional: todo ya está configurado",
  "Ничего не нашлось": "No se encontró nada",
  "Нужно выбрать": "Hay que elegir",
  "Объём": "Volumen",
  "Один раз для всех инструментов": "Una vez para todas las herramientas",
  "Отменить свой вариант": "Cancelar tu opción",
  "Отметьте, кто будет в кадре · {0}": "Marca quién aparecerá en el fotograma · {0}",
  "Персонажи": "Personajes",
  "Подберём сами": "Lo elegimos nosotros",
  "Подбираем варианты": "Buscando opciones",
  "Пожилой": "Mayor",
  "Поиск стилей": "Búsqueda de estilos",
  "Пока нечего сохранять": "Todavía no hay nada que guardar",
  "Попробуйте другое слово": "Prueba otra palabra",
  "Порядок здесь один": "Aquí solo hay un orden",
  "Примеры": "Ejemplos",
  "Пропадёт {0} вместе с фото. Вернуть не получится.": "Desaparecerá {0} junto con las fotos. No se podrá recuperar.",
  "Пропадёт из близких вместе с фото. Вернуть не получится.": "Desaparecerá de personas cercanas junto con las fotos. No se podrá recuperar.",
  "Пропадёт из близких и {0} вместе с фото. Вернуть не получится.": "Desaparecerá de personas cercanas y {0} junto con las fotos. No se podrá recuperar.",
  "Профиль близкого": "Perfil de la persona cercana",
  "Разные ракурсы и выражения": "Distintos ángulos y expresiones",
  "Реалистичный": "Realista",
  "Реалистичный, иллюстрация или 3D": "Realista, ilustración o 3D",
  "Роли": "Papeles",
  "Роль «{0}»": "Papel «{0}»",
  "Роль «{0}» для женского персонажа": "El papel «{0}» es para un personaje femenino",
  "Роль «{0}» для мужского персонажа": "El papel «{0}» es para un personaje masculino",
  "Роль «{0}» для персонажей своей подборки": "El papel «{0}» es para personajes de su colección",
  "Свой вариант": "Tu opción",
  "Скачать здесь не получится": "Aquí no se puede descargar",
  "Создайте новый вариант": "Crea una nueva variante",
  "Сортировка": "Ordenar",
  "Сохранится в близких": "Se guardará en personas cercanas",
  "Сохранить в близких": "Guardar en personas cercanas",
  "Стало": "Después",
  "Только для этой фотосессии": "Solo para esta sesión de fotos",
  "Удаление": "Eliminación",
  "Удалить «{0}» {1}?": "¿Eliminar a «{0}» {1}?",
  "Удалить «{0}» из близких?": "¿Eliminar a «{0}» de personas cercanas?",
  "Удалить из близких": "Eliminar de personas cercanas",
  "Удалить из фотосессии": "Eliminar de la sesión de fotos",
  "Удерживайте, чтобы посмотреть примеры": "Mantén pulsado para ver ejemplos",
  "Управление": "Gestión",
  "Файл готов. Нажмите ещё раз": "El archivo está listo. Pulsa otra vez",
  "Фото до 10 МБ, видео до 200 МБ": "Fotos de hasta 10 MB, vídeos de hasta 200 MB",
  "Фрагмент": "Fragmento",
  "Что делает? Например: поправляет шарф": "¿Qué hace? Por ejemplo: se arregla la bufanda",
  "Что делают в кадре": "Qué hacen en el fotograma",
  "Эта настройка здесь закреплена": "Este ajuste está fijado aquí",
  "Этот голос не умеет переозвучку записи": "Esta voz no puede redoblar una grabación",
  "вариант «{0}»": "variante «{0}»",
  "взрослая": "adulta",
  "взрослый": "adulto",
  "всё видео умещается": "cabe todo el vídeo",
  "выберите": "elige",
  "до <span class=\"mono\">{0}</span>": "hasta <span class=\"mono\">{0}</span>",
  "до {0} человек": "hasta {0} personas",
  "до {0} человека": "hasta {0} personas",
  "ещё {0} из {1}": "quedan {0} de {1}",
  "женская роль": "papel femenino",
  "из фотосессии": "de la sesión de fotos",
  "из этой фотосессии": "de esta sesión de fotos",
  "камера": "cámara",
  "максимум {0} секунд": "máximo {0} segundos",
  "максимум {0} секунда": "máximo {0} segundo",
  "максимум {0} секунды": "máximo {0} segundos",
  "можно до <span class=\"mono\">{0}</span>": "hasta <span class=\"mono\">{0}</span>",
  "мужская роль": "papel masculino",
  "не из подборки этой роли": "no es de la colección de este papel",
  "не подходит по возрасту": "no encaja por la edad",
  "не участвует в этой фотосессии": "no participa en esta sesión de fotos",
  "необязательно": "opcional",
  "нет фото": "sin fotos",
  "нужно выбрать": "hay que elegir",
  "нужно: Вы": "se necesita: tú",
  "персонажи в эту роль не входят": "los personajes no entran en este papel",
  "питомец": "mascota",
  "по желанию": "opcional",
  "пожилая": "mayor",
  "пожилой": "mayor",
  "ребёнок": "niño",
  "роль для взрослого": "papel para un adulto",
  "роль для женщины": "papel para una mujer",
  "роль для мужчины": "papel para un hombre",
  "роль для питомца": "papel para una mascota",
  "роль для ребёнка": "papel para un niño",
  "роль для человека": "papel para una persona",
  "Попробуйте другое слово или сбросьте тему": "Prueba otra palabra o quita el tema",
  "Искать среди {n}+ голосов": "Buscar entre {n}+ voces",
  "Голосов: {n}": "Voces: {n}",
  "Персонажей: {n}": "Personajes: {n}",
  "Голосов: {0}": "Voces: {0}",
  "Прослушать {n}": "Escuchar a {n}",
  "Загружаем ещё {n}": "Cargando {n} más",
  "{a} из {b}": "{a} de {b}",
  "Подборка": "Colección",
  "Закрыть подборку": "Cerrar colección",
  "По имени": "Por nombre",
  "Загружаем подборки…": "Cargando colecciones…",
  "Не удалось загрузить голоса": "No se pudieron cargar las voces",
  "Не удалось воспроизвести пример. Попробуйте ещё раз.": "No se pudo reproducir la muestra. Inténtalo de nuevo.",
  "Мой голос": "Mía",
  "Мои": "Mías",
  "Своих голосов пока нет": "Aún no tienes voces propias",
  "Клонируйте свой голос, и он появится на этой вкладке.": "Clona tu voz y aparecerá aquí.",
  "Клонировать голос": "Clonar voz",
  "Открыть персонажа {0}": "Abrir {0}",
  "От": "Desde",
  "Тренды недели": "Tendencias de la semana",
  "Голоса, которые быстрее всего набирают заказы": "Las voces que más rápido suman pedidos",
  "Мужские": "Masculinas",
  "Все мужские голоса библиотеки": "Todas las voces masculinas",
  "Женские": "Femeninas",
  "Все женские голоса библиотеки": "Todas las voces femeninas",
  "Детские": "Infantiles",
  "Детские и мультяшные голоса": "Voces infantiles y de dibujos",
  "меню: Озвучка": "Voces",
  "Системная": "Sistema",
  "Для аватарки и ленты": "Para avatar y feed",
  "Как снимок с телефона": "Como una foto de móvil",
  "Для ленты": "Para el feed",
  "На весь экран телефона": "Pantalla completa del móvil",
  "Для обложки и экрана": "Para portadas y pantallas",
  "Станет голосом по умолчанию для озвучки.": "Será la voz predeterminada para locuciones.",
  "Когда генерация закончится": "Cuando termine la generación",
  "Награды и серия": "Premios y racha",
  "Напомним о награде за день": "Recordatorio del premio diario",
  "Новые шаблоны и стили": "Nuevas plantillas y estilos",
  "Не чаще раза в неделю": "Como máximo una vez por semana",
  "Новости STEOS": "Novedades de STEOS",
  "Только крупные обновления": "Solo actualizaciones importantes",
  "Тут откроется документ в браузере": "El documento se abrirá en el navegador",
  "Язык и валюта": "Idioma y moneda",
  "Интерфейс и цены картой": "Interfaz y precios con tarjeta",
  "новое|новых|новых": "nuevo|nuevos",
  "работа|работы|работ": "trabajo|trabajos",
  "заказ|заказа|заказов": "pedido|pedidos",
  "Счётчики недоступны": "Contadores no disponibles",
  "История пуста": "El historial está vacío",
  "Не задан": "Sin definir",
  "Недоступны": "No disponibles",
  "Срок истёк": "Caducado",
  "Не удалась": "Fallida",
  "Готовится": "Preparando",
  "Запрошено": "Solicitado",
  "Запрошено {0}": "Solicitado {0}",
  "Недоступно": "No disponible",
  "Пусто": "Vacío",
  "Данные Mini App удалены": "Datos de la Mini App eliminados",
  "Удаление данных не удалось": "No se pudieron eliminar los datos",
  "Данные удалены частично": "Datos eliminados parcialmente",
  "Удаление требует проверки": "La eliminación requiere revisión",
  "Запрос удаления принят": "Solicitud de eliminación recibida",
  "Удаляем данные Mini App": "Eliminando datos de la Mini App",
  "Удаление данных в очереди": "Eliminación en cola",
  "STEOS ID сохранён": "STEOS ID se conserva",
  "Финансовые квитанции сохранены": "Recibos financieros conservados",
  "Статус удаления не подтверждён": "Estado de eliminación sin confirmar",
  "Удаление аккаунта": "Eliminar cuenta",
  "Удалить данные Mini App?": "¿Eliminar los datos de la Mini App?",
  "Удалить аккаунт?": "¿Eliminar la cuenta?",
  "Работы, голоса и варианты «Вы» в Mini App удалятся. STEOS ID и финансовые квитанции сохранятся.": "Se eliminarán tus trabajos, voces y looks de la Mini App. Tu STEOS ID y los recibos se conservarán.",
  "Работы, голоса, варианты «Вы» и Circle удалятся. Вернуть их не получится.": "Se eliminarán tus trabajos, voces, looks y Circle. No se puede deshacer.",
  "Удалить данные Mini App": "Eliminar datos de la Mini App",
  "Удалить аккаунт": "Eliminar cuenta",
  "Данные Mini App. STEOS ID сохранится": "Solo datos de la Mini App. STEOS ID se queda",
  "Все данные удалятся навсегда": "Todos los datos se eliminarán para siempre",
  "В прототипе аккаунт не удаляется": "En el prototipo la cuenta no se elimina",
  "Автовоспроизведение": "Reproducción automática",
  "Пример при выборе голоса": "Muestra al elegir una voz",
  "Присылать в чат": "Enviar al chat",
  "Готовые работы от бота": "Trabajos listos del bot",
  "Уведомления и отклик": "Notificaciones y vibración",
  "Данные": "Datos",
  "Выгрузить данные": "Exportar datos",
  "Настройки создания сейчас только для чтения": "Los ajustes de creación son de solo lectura ahora",
  "Формат по умолчанию": "Formato predeterminado",
  "Для новых фото и видео": "Para nuevas fotos y vídeos",
  "На экране создания их можно поменять для одной работы.": "Puedes cambiarlo para un solo trabajo en la pantalla de creación.",
  "Сообщения приходят в чат с ботом": "Los mensajes llegan al chat con el bot",
  "Бот напишет только в ответ на действия": "El bot solo responderá a tus acciones",
  "Уведомления пока недоступны": "Las notificaciones aún no están disponibles",
  "Вибрация": "Vibración",
  "Лёгкий отклик на нажатия": "Respuesta ligera al tocar",
  "Выгрузка данных": "Exportar datos",
  "Выгрузка запрошена": "Exportación solicitada",
  "Пришлём архив в чат в течение суток": "Te enviaremos el archivo al chat en 24 horas",
  "Настройки и доступные текстовые данные аккаунта": "Ajustes y datos de texto disponibles de la cuenta",
  "Ссылка на архив придёт в чат с ботом": "El enlace al archivo llegará al chat con el bot",
  "Готовые работы и заказы": "Trabajos listos y pedidos",
  "Клоны и записи образцов": "Clones y grabaciones de muestra",
  "Ваши фото и варианты себя": "Tus fotos y looks",
  "Люди и питомцы из фотосессий": "Personas y mascotas de las sesiones",
  "Запросить выгрузку": "Solicitar exportación",
  "Готовим архив": "Preparando el archivo",
  "Это займёт несколько минут. Лист можно закрыть, выгрузка продолжится": "Tardará unos minutos. Puedes cerrar esto, la exportación seguirá",
  "Срок хранения архива истёк": "El archivo ha caducado",
  "Запросите новую выгрузку данных": "Solicita una nueva exportación",
  "Архив не собрался": "No se pudo crear el archivo",
  "Запросите выгрузку ещё раз": "Vuelve a solicitar la exportación",
  "Не вошли: {0}": "No incluido: {0}",
  "Вошли частично: {0}": "Incluido en parte: {0}",
  "Не входят в выгрузку: {0}": "No forman parte de la exportación: {0}",
  "Часть данных недоступна. Точный состав указан в manifest.json внутри архива": "Faltan algunos datos. El contenido exacto está en manifest.json dentro del archivo",
  "Архив готов, но не полностью": "Archivo listo, pero incompleto",
  "Архив готов": "Archivo listo",
  "Скачать можно до {0}": "Descarga disponible hasta {0}",
  "Архив в формате ZIP": "Archivo ZIP",
  "Скачать архив": "Descargar archivo",
  "Счётчики истории не загрузились": "No se cargaron los contadores",
  "Загружаем историю": "Cargando historial",
  "Проверьте связь и повторите загрузку": "Revisa la conexión e inténtalo de nuevo",
  "История очищена": "Historial borrado",
  "Голоса, варианты «Вы», близкие и Circle на месте": "Tus voces, looks, seres queridos y Circle siguen aquí",
  "Здесь появятся работы, когда вы что-то создадите": "Aquí aparecerán tus trabajos cuando crees algo",
  "Раздел «История»": "Sección Historial",
  "Работы": "Trabajos",
  "Фото, видео, кружки и озвучки": "Fotos, vídeos, círculos y locuciones",
  "Заказы": "Pedidos",
  "Параметры и статусы генераций": "Parámetros y estados de las generaciones",
  "Голоса, варианты «Вы», близкие и Circle останутся.": "Tus voces, looks, seres queridos y Circle se quedan.",
  "Удалить работы и заказы": "Eliminar trabajos y pedidos",
  "Без возможности восстановления": "No se puede deshacer",
  "Подтверждение удаления": "Confirmar eliminación",
  "Попробовать: {0}": "Probar: {0}",
  "Обновление": "Actualización",
  "Загружаем «Что нового»": "Cargando Novedades",
  "Новых обновлений пока нет": "Aún no hay novedades",
  "Уведомления сейчас не сохранить": "Ahora no se pueden guardar las notificaciones",
  "Настройки сейчас только для чтения": "Los ajustes son de solo lectura ahora",
  "Выгрузка не запросилась. Попробуйте ещё раз": "No se pudo solicitar la exportación. Inténtalo de nuevo",
  "Удалить всю историю?": "¿Borrar todo el historial?",
  "{0}. Вернуть не получится.": "{0}. No se puede deshacer.",
  "История не очистилась. Попробуйте ещё раз": "No se borró el historial. Inténtalo de nuevo",
  "Удаление не началось. Попробуйте ещё раз": "La eliminación no empezó. Inténtalo de nuevo",
  "Не удалось загрузить настройки": "No se pudieron cargar los ajustes",
  "«Что нового» не загрузилось": "No se cargaron las Novedades",
  "Сохранение настроек сейчас недоступно": "Ahora no se pueden guardar los ajustes",
  "Настройки уже изменились, показываем актуальные": "Los ajustes cambiaron, mostramos los actuales",
  "Не удалось сохранить. Попробуйте ещё раз": "No se pudo guardar. Inténtalo de nuevo",
  "Настройки, ресурсы и история": "Ajustes, recursos e historial",
  "Данные Mini App": "Datos de la Mini App",
  "Учётная запись и финансовые данные STEOS ID": "Cuenta y datos financieros de STEOS ID",
  "Переписка с ботом": "Chat con el bot",
  "Фото, аудио, видео и модели": "Fotos, audio, vídeos y modelos",
  "Данные других продуктов STEOS": "Datos de otros productos STEOS",
  "Рубли": "Rublos",
  "Драмы": "Drams",
  "Евро": "Euros",
  "Доллары": "Dólares",
  "Другие языки": "Más idiomas",
  "Интерфейс и сообщения бота": "Interfaz y mensajes del bot",
  "Цены картой покажем в этой валюте. Звёзды Telegram везде одинаковые.": "Los precios con tarjeta se muestran en esta moneda. Las Telegram Stars son iguales en todas partes.",
  "сегодня, {0}": "hoy, {0}",
  "вчера, {0}": "ayer, {0}",
  "Старт": "Start",
  "Плюс": "Plus",
  "Про": "Pro",
  "Картой или СБП": "Tarjeta o SBP",
  "СБП только для РФ": "SBP solo en Rusia",
  "1 месяц": "1 mes",
  "3 месяца": "3 meses",
  "6 месяцев": "6 meses",
  "Год": "Año",
  "год": "un año",
  "С днём рождения": "Feliz cumpleaños",
  "С днём рождения. Пусть всё задуманное получается с первого раза": "Feliz cumpleaños. Que todo te salga a la primera",
  "Просто так": "Porque sí",
  "Просто так. Пусть у тебя будет больше кружков и смешных голосов": "Porque sí. Que tengas más círculos y voces divertidas",
  "Спасибо": "Gracias",
  "Спасибо, что ты рядом. Это маленький подарок от меня": "Gracias por estar ahí. Un pequeño regalo de mi parte",
  "С праздником": "Felices fiestas",
  "С праздником. Твори, снимай и удивляй": "Felices fiestas. Crea, graba y sorprende",
  "Для блога": "Para tu blog",
  "Для твоего блога: пусть ролики выходят чаще и легче": "Para tu blog: más vídeos, con menos esfuerzo",
  "Удачи": "Suerte",
  "Удачи в новом проекте. Пусть голос и картинка будут такими, как задумано": "Suerte con tu nuevo proyecto. Que la voz y la imagen salgan como las imaginas",
  "картой": "con tarjeta",
  "оплата картой каждый месяц": "pago con tarjeta cada mes",
  "оплата картой за {0}": "pago con tarjeta por {0}",
  "{0} в месяц": "{0} al mes",
  "{0} за {1}": "{0} por {1}",
  "кружок|кружка|кружков": "videomensaje|videomensajes",
  "рилс|рилса|рилсов": "reel|reels",
  "свой голос|своих голоса|своих голосов": "voz propia|voces propias",
  "своего голоса|своих голосов|своих голосов": "voz propia|voces propias",
  "день|дня|дней": "día|días",
  "звезда|звезды|звёзд": "estrella|estrellas",
  "Подписаться на {0}": "Suscribirse por {0}",
  "Продлевается каждый месяц, отмена в любой момент": "Se renueva cada mes, cancela cuando quieras",
  "Без автопродления, Circle приходят каждый месяц": "Sin renovación automática, los Circle llegan cada mes",
  "Перейти на {0}": "Cambiar a {0}",
  "Сразу придут {0} C, а {1} больше не продлится": "Llegan {0} C ahora y {1} ya no se renovará",
  "Сразу придут {0} C": "Llegan {0} C ahora",
  "Перейти на {0} с {1}": "Cambiar a {0} el {1}",
  "До {0} остаётся {1}, потом {2}": "{1} sigue hasta el {0}, luego {2}",
  "Продлить на {0}": "Extender {0}",
  "Ещё {0} после {1}, без автопродления": "{0} más tras el {1}, sin renovación",
  "Следующее списание {0}, {1}": "Próximo cobro el {0}, {1}",
  "Способ оплаты": "Método de pago",
  "Звёздами": "Con estrellas",
  "Тестовая оплата": "Pago de prueba",
  "Звёзды и деньги не списываются": "No se cobran estrellas ni dinero",
  "Оплата картой скоро": "Pago con tarjeta próximamente",
  "Ваш тариф": "Tu plan",
  "выгоднее на {0}%": "{0} % más ventajoso",
  "{0} C в месяц": "{0} C al mes",
  "или": "o",
  "Что сотворим в этом месяце?": "¿Qué crearás este mes?",
  "Готовы творить без пауз?": "¿Listo para crear sin pausas?",
  "Ваш тариф {0}": "Tu plan: {0}",
  "{0} C каждый месяц": "{0} C cada mes",
  "До {0} {1}": "Hasta {0} {1}",
  "Пакеты Circle, если не хватит": "Paquetes de Circle si te faltan",
  "{0} включает": "{0} incluye",
  "Сравнить": "Comparar",
  "Помесячно": "Mensual",
  "Выгода {0}": "Ahorra {0}",
  "Одним платежом": "Un solo pago",
  "{0} с {1}": "{0} desde el {1}",
  "Оставить {0}": "Mantener {0}",
  "Продлить {0}": "Renovar {0}",
  "Продлить": "Renovar",
  "Включить продление": "Activar renovación",
  "Возобновить {0}": "Reanudar {0}",
  "Возобновить": "Reanudar",
  "Оплата пока не подключена": "El pago aún no está conectado",
  "Сейчас недоступно": "No disponible ahora",
  "Переход на {0} на {1}": "Cambio a {0} por {1}",
  "Переход на {0}": "Cambio a {0}",
  "Продление {0} на {1}": "Extender {0} por {1}",
  "Подписка {0} на {1}": "{0} por {1}",
  "Как удобнее оплатить": "Elige cómo pagar",
  "Подарок друга": "Regalo de un amigo",
  "{0} на первый пакет {1} после подписки": "{0} en tu primer paquete durante {1} tras suscribirte",
  "Не загрузилось": "No se cargó",
  "Прошлую операцию не проверить": "No se puede comprobar la última operación",
  "разрешите хранение данных и откройте раздел снова": "permite el almacenamiento de datos y vuelve a abrir la sección",
  "Оплата требует проверки": "El pago requiere revisión",
  "Исход подтверждения оплаты ещё неизвестен": "Aún no se sabe si se confirmó el pago",
  "Исход отмены счёта неизвестен": "No se sabe si se canceló la factura",
  "Ждём подтверждения оплаты": "Esperando la confirmación del pago",
  "Исход прошлой операции неизвестен": "Se desconoce el resultado de la última operación",
  "проверьте его перед новой покупкой": "compruébalo antes de una nueva compra",
  "Проверить": "Comprobar",
  "Открыть оплату": "Abrir pago",
  "Отменить счёт": "Cancelar factura",
  "Продление отменено": "Renovación cancelada",
  "Сообщение со старым счётом может прийти. Оно не подтверждает новую подписку": "Puede llegar un mensaje con la factura antigua. No confirma una nueva suscripción",
  "Продление требует проверки": "La renovación requiere revisión",
  "Счёт не подтверждён. Обновите данные или обратитесь в поддержку": "Factura no confirmada. Actualiza o contacta con soporte",
  "Не удалось подготовить счёт": "No se pudo preparar la factura",
  "Сервер повторит проверку. Текущие права не меняются": "El servidor volverá a comprobar. Tu acceso actual no cambia",
  "Счёт отправлен": "Factura enviada",
  "Бот прислал счёт. Подписка начнётся после подтверждённой оплаты": "El bot envió una factura. La suscripción empieza al confirmarse el pago",
  "Счёт подготовлен": "Factura preparada",
  "Передан боту. Доставка и оплата ещё не подтверждены": "Entregada al bot. Entrega y pago aún sin confirmar",
  "Срок счёта истёк": "La factura caducó",
  "Продление не оплачено. Выберите тариф ещё раз": "La renovación no se pagó. Elige un plan de nuevo",
  "Запланированное продление отменено": "Renovación programada cancelada",
  "Текущий тариф не меняется. Для новой подписки потребуется отдельная оплата": "Tu plan actual no cambia. Una nueva suscripción requiere otro pago",
  "Продление запланировано": "Renovación programada",
  "Счёт на свою подписку придёт в конце подарочного месяца": "La factura de tu suscripción llegará al final del mes de regalo",
  "Подарок ещё действует": "El regalo sigue activo",
  "Месячная подписка будет доступна после его окончания. Сейчас можно продлить на 3 или 12 месяцев": "La suscripción mensual estará disponible cuando termine. Ahora puedes extender 3 o 12 meses",
  "выберите другой тариф или срок": "elige otro plan o periodo",
  "−{0}% на первый пакет · ещё {1}": "−{0} % en tu primer paquete · quedan {1}",
  "Circle из пакетов не сгорают": "Los Circle de paquetes no caducan",
  "Подарить другу": "Regalar a un amigo",
  "С открыткой, без продления": "Con tarjeta, sin renovación",
  "Промокод {0}": "Código {0}",
  "{0} C, сгорят {1}": "{0} C, caducan el {1}",
  "Промокод применён": "Código aplicado",
  "{0} C и {1} на первый пакет": "{0} C y {1} en tu primer paquete",
  "после подписки": "tras suscribirte",
  "Вы пришли по ссылке партнёра": "Llegaste por un enlace de socio",
  "привязка уже действует": "el vínculo ya está activo",
  "Есть промокод?": "¿Tienes un código?",
  "Загружаем тарифы": "Cargando planes",
  "Счёт придёт {0}": "La factura llegará el {0}",
  "Счёт придёт в конце текущего срока": "La factura llegará al final del periodo actual",
  "Новый тариф начнётся после оплаты. Сейчас ничего не списывается.": "El nuevo plan empieza tras el pago. Ahora no se cobra nada.",
  "Оплата подтверждена": "Pago confirmado",
  "Оплаченный период уже закончился. Circle за прошедший период не начисляются.": "El periodo pagado ya terminó. No se acreditan Circle de periodos pasados.",
  "Баланс пополнен": "Saldo recargado",
  "Теперь на балансе {0} C. Circle из пакетов не сгорают": "Ahora tienes {0} C. Los Circle de paquetes no caducan",
  "следующие {0} C придут {1}": "los próximos {0} C llegarán el {1}",
  "До этой даты действует {0}": "{0} sigue activo hasta esa fecha",
  "{0} продлён до {1}": "{0} extendido hasta el {1}",
  "Circle приходят каждый месяц, {0}": "Los Circle llegan cada mes, {0}",
  "Тариф {0} подключён": "Plan {0} activado",
  "Подписка {0} оформлена": "Suscripción {0} activada",
  "Оплачено до {0}. Circle приходят каждый месяц, {1}": "Pagado hasta el {0}. Los Circle llegan cada mes, {1}",
  "Тестовая подписка действует до {0}. Звёзды и деньги не списываются": "Suscripción de prueba activa hasta el {0}. No se cobra nada",
  "Circle действуют до {0}, тогда же следующее списание {1}": "Los Circle valen hasta el {0}, ese día el próximo cobro: {1}",
  "Circle действуют до {0}, продление выключено": "Los Circle valen hasta el {0}, renovación desactivada",
  "В месяц": "Al mes",
  "Кружки или фото": "Círculos o fotos",
  "Видео говорит": "El vídeo habla",
  "Рилсы": "Reels",
  "Сравнение тарифов": "Comparación de planes",
  "В любом тарифе {0} {1} вместо {2}, все инструменты студии и пакеты Circle": "Todos los planes: {0} {1} en vez de {2}, todas las herramientas y paquetes Circle",
  "Следующее списание": "Próximo cobro",
  "Сумма": "Importe",
  "Тестовая, без списаний": "Prueba, sin cobros",
  "Картой": "Con tarjeta",
  "Оплачено до": "Pagado hasta",
  "Действует до": "Activo hasta",
  "Потом": "Después",
  "Продление": "Renovación",
  "Счёт на {0} запланирован": "Factura de {0} programada",
  "подписку": "suscripción",
  "Придёт {0}. Новый тариф начнётся после оплаты": "Llegará el {0}. El nuevo plan empieza tras el pago",
  "Отменить": "Cancelar",
  "Отменить подписку": "Cancelar suscripción",
  "Тариф останется до {0}": "El plan sigue hasta el {0}",
  "Потом тариф {0}": "Luego {0}",
  "Подарок на месяц": "Regalo de un mes",
  "Оплачено вперёд": "Pagado por adelantado",
  "Подписка {0}": "Suscripción {0}",
  "Условия тарифа уточняются": "Se están confirmando los detalles del plan",
  "Сменить тариф": "Cambiar de plan",
  "Отмена подписки": "Cancelar suscripción",
  "Этот переход сейчас недоступен": "Este cambio no está disponible ahora",
  "Переход уже назначен": "El cambio ya está programado",
  "Выберите другой тариф": "Elige otro plan",
  "С {0} начнётся этот тариф": "Este plan empieza el {0}",
  "Это ваш тариф": "Este es tu plan",
  "К подписке": "Volver a la suscripción",
  "Сейчас {0}, {1}": "Ahora {0}, {1}",
  "Латиница, цифры и «_»": "Letras latinas, números y _",
  "Ник начинается с буквы": "Debe empezar por una letra",
  "Не короче 5 знаков": "Mínimo 5 caracteres",
  "Не длиннее 32 знаков": "Máximo 32 caracteres",
  "Ник не кончается на _": "No puede terminar en _",
  "Это ваш ник": "Ese es tu usuario",
  "Сначала проверьте прежнюю операцию": "Primero revisa la operación anterior",
  "Подарок сейчас недоступен": "El regalo no está disponible ahora",
  "Укажите ник друга в Telegram": "Introduce el usuario de Telegram de tu amigo",
  "Проверьте ник": "Revisa el usuario",
  "Друг увидит: {0}": "Tu amigo verá: {0}",
  "Подарок придёт без имени": "El regalo llegará sin nombre",
  "{0} дарит вам": "{0} te regala",
  "вам подарили": "te han regalado",
  "Вам подарили": "Te han regalado",
  "{0} подписку STEOS {1} на месяц.": "{0} una suscripción STEOS {1} por un mes.",
  "Забрать подарок": "Reclamar regalo",
  "От друга": "De un amigo",
  "{0} C и {1} {2}": "{0} C y {1} {2}",
  "Подарить {0}": "Regalar {0}",
  "Тестовый подарок: звёзды и деньги не списываются": "Regalo de prueba: no se cobra nada",
  "На месяц, без продления": "Por un mes, sin renovación",
  "Тариф подарка": "Plan de regalo",
  "Кому": "Para",
  "ник друга в Telegram": "usuario de Telegram",
  "Ник друга в Telegram": "Usuario de Telegram de tu amigo",
  "Пожелание": "Mensaje",
  "Пара тёплых слов, по желанию": "Unas palabras cálidas, opcional",
  "Подписать от меня": "Firmar de mi parte",
  "Так увидит друг": "Así lo verá tu amigo",
  "Подарок оформлен для {0}": "Regalo preparado para {0}",
  "Подарок отправлен {0}": "Regalo enviado a {0}",
  "Бот прислал открытку со ссылкой «Забрать подарок» в подписи.": "El bot envió una tarjeta con el enlace «Reclamar regalo».",
  "Месяц {0} начнётся, когда друг заберёт подарок": "El mes de {0} empieza cuando tu amigo lo reclame",
  "Друг ещё не запускал STEOS? Перешлите открытку сами": "¿Tu amigo aún no abrió STEOS? Reenvíale la tarjeta tú",
  "Переслать": "Reenviar",
  "Загружаем подарок": "Cargando regalo",
  "Вам подарок": "Un regalo para ti",
  "Подписка STEOS на месяц": "Suscripción STEOS de un mes",
  "Этот подарок предназначен {0}. Перешлите получателю открытку со ссылкой.": "Este regalo es para {0}. Reenvíale la tarjeta con el enlace.",
  "Подарок уже получен": "Regalo ya reclamado",
  "Подарок добавлен": "Regalo añadido",
  "Подписка {0} подключена": "Suscripción {0} activada",
  "Circle подарка сгорят {0}": "Los Circle del regalo caducan el {0}",
  "Месяц без продления, Circle действуют до {0}": "Un mes sin renovación, Circle válidos hasta el {0}",
  "У вас уже есть {0}: подарок добавит {1} C, они сгорят через месяц": "Ya tienes {0}: el regalo suma {1} C que caducan en un mes",
  "Придут {0} C и {1} {2}. Подписка не продлится сама": "Recibirás {0} C y {1} {2}. No se renovará sola",
  "За последние 7 дней": "Últimos 7 días",
  "Потрачено": "Gastado",
  "Начислено": "Acreditado",
  "Пакеты пока недоступны": "Los paquetes aún no están disponibles",
  "Пакет": "Paquete",
  "Оплата пакетов пока не подключена": "El pago de paquetes aún no está conectado",
  "Введите промокод": "Introduce un código",
  "Применить": "Aplicar",
  "Промокод партнёра работает до первой покупки, промокод STEOS можно применить один раз": "Los códigos de socio valen hasta la primera compra; uno de STEOS, una vez",
  "От партнёра или от STEOS": "De un socio o de STEOS",
  "Например, ANNA24": "Por ejemplo, ANNA24",
  "Не удалось загрузить операции": "No se pudieron cargar las operaciones",
  "Начисление": "Abono",
  "Списание": "Cargo",
  "Загружаем операции": "Cargando operaciones",
  "Журнал STEOS ID": "Registro de STEOS ID",
  "Операций пока нет": "Aún no hay operaciones",
  "Применение не подтверждено. Проверьте прежний запрос": "Sin confirmar. Revisa la solicitud anterior",
  "Отменить подписку?": "¿Cancelar la suscripción?",
  "Тариф {0} останется до {1}, потом не продлится.": "{0} sigue hasta el {1} y luego no se renovará.",
  "Оставить": "Mantener",
  "Не удалось подготовить открытку": "No se pudo preparar la tarjeta",
  "Откройте Mini App в Telegram, чтобы переслать открытку": "Abre la Mini App en Telegram para reenviar la tarjeta",
  "Отправка отменена": "Envío cancelado",
  "Ссылка на подарок скопирована": "Enlace del regalo copiado",
  "Не получилось. Попробуйте ещё раз": "No funcionó. Inténtalo de nuevo",
  "Счёт отменён": "Factura cancelada",
  "Оплата не завершена": "Pago no completado",
  "Подтверждение оплаты": "Confirmación del pago",
  "Проверяем подтверждение оплаты": "Comprobando la confirmación del pago",
  "Проверяем отмену счёта": "Comprobando la cancelación",
  "Telegram начал подтверждение счёта. Его исход ещё неизвестен. Не оплачивайте повторно: проверяйте этот счёт или обратитесь в поддержку.": "Telegram está confirmando la factura. Aún no se sabe el resultado. No pagues de nuevo: revisa esta factura o contacta con soporte.",
  "Подарок будет оформлен после подтверждения сервера. Месяц подписки начнётся, когда друг заберёт подарок. Возврат из окна оплаты ещё не означает, что платёж завершён.": "El regalo se preparará cuando el servidor lo confirme. El mes empieza cuando tu amigo lo reclame. Volver de la ventana de pago no significa que el pago esté completo.",
  "Circle поступят на баланс после подтверждения сервера. Возврат из окна оплаты ещё не означает, что платёж завершён.": "Los Circle llegarán cuando el servidor lo confirme. Volver de la ventana de pago no significa que el pago esté completo.",
  "Circle и подписка появятся после подтверждения сервера. Возврат из окна оплаты ещё не означает, что платёж завершён.": "Los Circle y la suscripción aparecerán cuando el servidor lo confirme. Volver de la ventana de pago no significa que el pago esté completo.",
  "Не удалось открыть оплату. Проверьте прежний запрос": "No se pudo abrir el pago. Revisa la solicitud anterior",
  "Откройте Mini App в Telegram, чтобы оплатить звёздами": "Abre la Mini App en Telegram para pagar con estrellas",
  "Оплата ещё не подтверждена сервером": "El servidor aún no confirmó el pago",
  "Открытка готова. Откройте Mini App в Telegram, чтобы переслать её": "La tarjeta está lista. Abre la Mini App en Telegram para reenviarla",
  "Отменить счёт?": "¿Cancelar la factura?",
  "Отменится только этот неоплаченный счёт. Текущая подписка останется. Если оплата уже подтверждается, сервер не разрешит отмену.": "Solo se cancela esta factura sin pagar. Tu suscripción actual sigue. Si el pago ya se está confirmando, el servidor no permitirá cancelarla.",
  "Вернуться к оплате": "Volver al pago",
  "{0} на первый пакет после подписки": "{0} en tu primer paquete tras suscribirte",
  "{0} на первый пакет, ещё {1}": "{0} en tu primer paquete, quedan {1}",
  "{0} на первый пакет": "{0} en tu primer paquete",
  "Промокод {0} применён": "Código {0} aplicado",
  "Circle сгорят {0}": "Los Circle caducan el {0}",
  "Circle начислены": "Circle acreditados",
  "Привязка к партнёру подтверждена": "Vínculo con el socio confirmado",
  "Скидка {0}. Бонусные Circle сгорят {1}": "Descuento: {0}. Los Circle de bono caducan el {1}",
  "Привязка к партнёру действует": "Vínculo con el socio activo",
  "{0} C и {1}": "{0} C y {1}",
  "Открытка передана боту для доставки.": "La tarjeta se entregó al bot para enviarla.",
  "Бот готовит доставку открытки. Можно переслать её самостоятельно.": "El bot está preparando el envío. También puedes reenviarla tú.",
  "Доставка открытки не подтверждена. Можно переслать её самостоятельно.": "El envío no está confirmado. Puedes reenviarla tú.",
  "Сначала тратятся Circle со сроком: бонусные и по подписке, потом все остальные, а те, что можно вывести, в последнюю очередь.": "Primero se gastan los Circle con caducidad (de bono y de suscripción), luego el resto; los retirables, al final.",
  "Получатель не найден среди пользователей STEOS. Проверьте ник или попросите друга запустить бота.": "No encontramos al destinatario en STEOS. Revisa el usuario o pide a tu amigo que inicie el bot.",
  "Условия оплаты изменились. Обновите данные.": "Las condiciones de pago cambiaron. Actualiza los datos.",
  "Эту открытку может переслать только отправитель подарка.": "Solo quien envió el regalo puede reenviar esta tarjeta.",
  "Откройте чат с ботом и попробуйте ещё раз.": "Abre el chat con el bot e inténtalo de nuevo.",
  "Доставка получателю не подтверждена. Перешлите открытку самостоятельно.": "La entrega no está confirmada. Reenvía la tarjeta tú.",
  "Предложение не найдено. Обновите данные.": "Oferta no encontrada. Actualiza los datos.",
  "Такого промокода нет": "Ese código no existe",
  "Срок действия промокода закончился": "Este código ha caducado",
  "Этот промокод пока не действует": "Este código aún no está activo",
  "Вы уже активировали этот промокод": "Ya usaste este código",
  "Промокод больше не действует": "Este código ya no es válido",
  "Это ваш промокод": "Ese es tu propio código",
  "Партнёрские промокоды работают только до первой покупки": "Los códigos de socio solo valen antes de la primera compra",
  "Промокод партнёра временно недоступен": "Este código de socio no está disponible por ahora",
  "Вы уже привязаны к партнёру": "Ya estás vinculado a un socio",
  "Получатель изменился. Отмените прежний неоплаченный счёт и проверьте ник перед новой покупкой.": "El destinatario cambió. Cancela la factura anterior sin pagar y revisa el usuario antes de comprar de nuevo.",
  "Пожелание должно быть не длиннее 200 знаков, без управляющих символов.": "El mensaje debe tener hasta 200 caracteres, sin caracteres de control.",
  "Проверьте ник: получатель должен запускать STEOS, нельзя дарить себе": "Revisa el usuario: el destinatario debe haber abierto STEOS y no puedes regalarte a ti mismo",
  "Получатель сейчас занят. Повторите позже": "El destinatario está ocupado ahora. Inténtalo más tarde",
  "Подарок не найден": "Regalo no encontrado",
  "Этот подарок предназначен другому пользователю": "Este regalo es para otro usuario",
  "Не удалось подтвердить условия продления. Обновите тарифы.": "No se pudieron confirmar las condiciones de renovación. Actualiza los planes.",
  "Подписка изменилась. Обновите данные перед новым продлением.": "Tu suscripción cambió. Actualiza antes de renovar de nuevo.",
  "Продление уже запланировано. Его можно отменить в управлении подпиской.": "La renovación ya está programada. Puedes cancelarla en la gestión de la suscripción.",
  "Запланированное продление отменено. Обновите данные.": "Renovación programada cancelada. Actualiza los datos.",
  "Счёт будет доступен в конце текущего срока.": "La factura estará disponible al final del periodo actual.",
  "Месячная подписка будет доступна после окончания подарка. Сейчас можно продлить на 3 или 12 месяцев.": "La suscripción mensual estará disponible al terminar el regalo. Ahora puedes extender 3 o 12 meses.",
  "Предыдущее изменение подписки ещё проверяется. Повторите его проверку.": "El cambio anterior aún se está comprobando. Vuelve a comprobarlo.",
  "Изменение подписки ещё не подтверждено Telegram.": "Telegram aún no confirmó el cambio de suscripción.",
  "Подписка изменилась. Обновите данные и повторите проверку.": "Tu suscripción cambió. Actualiza y vuelve a comprobar.",
  "Скидка уже закреплена за предыдущим счётом. Проверьте его оплату.": "El descuento ya está asignado a la factura anterior. Revisa su pago.",
  "Счёт уже подтверждается или недоступен для отмены. Проверьте результат оплаты.": "La factura ya se está confirmando o no se puede cancelar. Revisa el resultado del pago.",
  "Оплата требует проверки. Сервер сохранил платёж; права пока не подтверждены. Не оплачивайте повторно — проверьте результат позже или обратитесь в поддержку.": "El pago requiere revisión. El servidor lo guardó, pero el acceso aún no está confirmado. No pagues de nuevo: revisa más tarde o contacta con soporte.",
  "Счёт отменён. Подписка и Circle по нему не начислены. Можно выбрать новую оплату.": "Factura cancelada. No se acreditó suscripción ni Circle. Puedes iniciar un nuevo pago.",
  "Оплата не завершена. Деньги и Circle не подтверждены; можно начать новую оплату.": "Pago no completado. Dinero y Circle sin confirmar; puedes iniciar un nuevo pago.",
  "Открытка готовится. Нажмите «Проверить», чтобы получить результат прежнего запроса.": "La tarjeta se está preparando. Pulsa «Comprobar» para ver el resultado.",
  "Подарить подписку": "Regalar suscripción",
  "Оплата подписки": "Pago de suscripción",
  "Итог оплаты": "Resultado del pago",
  "Подарок": "Regalo",
  "Пакет Circle": "Paquete de Circle",
  "лента: Хит": "Top",
  "настройки: Очистить историю": "Borrar historial",
  "Разделы, которых нет в меню": "Secciones fuera del menú",
  "Базовый": "Básico",
  "Продвинутый": "Avanzado",
  "Амбассадор": "Embajador",
  "задание ждёт|задания ждут|заданий ждут": "tarea pendiente|tareas pendientes",
  ", до +{0} C": ", hasta +{0} C",
  "Серия {0}, задания на сегодня": "Racha de {0}, tareas de hoy",
  "Задания на каждый день": "Tareas diarias",
  "Всё созданное в одном месте": "Todo lo que creaste en un lugar",
  "Пока пусто: всё созданное будет здесь": "Vacío por ahora: aquí aparecerá lo que crees",
  "{0}, последняя {1}": "{0}, la última {1}",
  "тариф {0}": "plan {0}",
  "без подписки": "sin suscripción",
  "{0}, {1}% с покупок": "{0}, {1} % de las compras",
  "{0} уровень, {1}% с покупок": "Nivel {0}, {1} % de las compras",
  "До {0}% с покупок друзей": "Hasta el {0} % de las compras de amigos",
  "ИИ-агент ответит сразу": "El agente de IA responde al instante",
  "Черновики ролей и реплик": "Borradores de papeles y frases",
  "Тема, язык и валюта": "Tema, idioma y moneda",
  "{0} ждут": "{0} pendientes",
  "Тут Telegram откроет выбор чата: бот добавится в группу и будет работать там": "Aquí Telegram abrirá el selector de chats: el bot se unirá al grupo y funcionará allí",
  "голос {0}": "voz {0}",
  "Искать в {0} {1}": "Buscar en {0} {1}",
  "работе|работах|работах": "trabajo|trabajos",
  "Не прошло модерацию": "No pasó la moderación",
  "Бесплатно": "Gratis",
  "Цена недоступна": "Precio no disponible",
  "Не удалось загрузить историю": "No se pudo cargar el historial",
  "Проверьте написание или поищите по номеру заказа": "Revisa la ortografía o busca por número de pedido",
  "Проверьте написание или поищите по названию, голосу или персонажу": "Revisa la ortografía o busca por título, voz o personaje",
  "Сбросить поиск": "Borrar búsqueda",
  "В этой вкладке пока пусто": "Aún no hay nada aquí",
  "Отмечайте работы сердцем в карточке, чтобы быстро находить их здесь": "Marca tus trabajos con el corazón para encontrarlos aquí rápido",
  "Новые работы этого вида появятся здесь сами": "Los nuevos trabajos de este tipo aparecerán aquí",
  "Показать все": "Ver todo",
  "Поиск по истории": "Buscar en el historial",
  "Что показать": "Qué mostrar",
  "Кружки, фото, видео, озвучки и тексты, которые вы создадите": "Círculos, fotos, vídeos, locuciones y textos que crees",
  "Открыть студию": "Abrir Estudio",
  "{0}: шаг {1} из {2}. Открыть": "{0}: paso {1} de {2}. Abrir",
  "Шаг {0} из {1}": "Paso {0} de {1}",
  "{0}: {1}. Открыть": "{0}: {1}. Abrir",
  "Раскладка": "Diseño",
  "Широкий": "Ancho",
  "Инструмент": "Herramienta",
  "голос|голоса|голосов": "voz|voces",
  "Как в оригинале": "Como el original",
  "фото|фото|фото": "foto|fotos",
  "слайд|слайда|слайдов": "diapositiva|diapositivas",
  "снимок|снимка|снимков": "foto|fotos",
  "кадр|кадра|кадров": "foto|fotos",
  "Длительность записи": "Duración de la grabación",
  "Цена": "Precio",
  "Списание не подтверждено": "Cargo no confirmado",
  "Кадры": "Tomas",
  "знак|знака|знаков": "carácter|caracteres",
  "пункт|пункта|пунктов": "punto|puntos",
  "фраза|фразы|фраз": "frase|frases",
  "человек|человека|человек": "persona|personas",
  "Смотреть видео": "Ver vídeo",
  "символ|символа|символов": "carácter|caracteres",
  "Дорожка": "Pista",
  "фрагмент 1:00": "fragmento de 1:00",
  "вся песня": "canción completa",
  "образец|образца|образцов": "muestra|muestras",
  "Свой голос": "Voz propia",
  "{0} C списаны": "{0} C cobrados",
  "Работа ещё создаётся. Результат появится здесь и придёт в чат": "Aún se está creando. El resultado aparecerá aquí y en el chat",
  "Проверяем результат. Обычно это занимает пару минут": "Comprobando el resultado. Suele tardar un par de minutos",
  "Не прошло модерацию. Политику и запрещённые темы не пропускаем, {0}": "No pasó la moderación. No admitimos política ni temas prohibidos. {0}",
  "Не прошло модерацию. {0}": "No pasó la moderación. {0}",
  "Не получилось. {0}": "No se pudo crear. {0}",
  "Не получилось. {0} C вернулись на баланс": "No se pudo crear. {0} C devueltos a tu saldo",
  "Удалится только запись о заказе": "Solo se eliminará el registro del pedido",
  "Удаление из истории": "Eliminar del historial",
  "Смотреть: {0}": "Ver: {0}",
  "В этой работе нет файлов для просмотра": "Este trabajo no tiene archivos para ver",
  "Вернуть запись в историю не получится.": "No podrás recuperar el registro.",
  "Файл в чате останется. Вернуть работу в историю не получится.": "El archivo seguirá en el chat. No podrás recuperar el trabajo.",
  "Отправка пока не подтвердилась. Нажмите ещё раз": "El envío aún no se ha confirmado. Toca de nuevo",
  "Принято": "Aceptado",
  "Бот пришлёт результат в чат": "El bot enviará el resultado al chat",
  "Возврат обрабатывается": "Reembolso en curso",
  "Не списано": "No cobrado",
  "Circle не списаны": "No se cobraron Circle",
  "Circle вернулись на баланс": "Los Circle volvieron a tu saldo",
  "Списание пока не подтверждено": "El cargo aún no está confirmado",
  "Возврат не подтверждён": "Reembolso no confirmado",
  "Ожидаем подтверждения оплаты": "Esperando el pago",
  "история: Повторить": "Repetir",
  "история: Кружки": "Videomensajes",
  "Фотосессия из селфи": "Sesión de fotos con un selfie",
  "Рилс с вами": "Reels contigo",
  "Фото говорит": "La foto habla",
  "Слайды с преимуществами": "Diapositivas de beneficios",
  "Карусель для поста": "Carrusel para publicación",
  "Коллаж из фото": "Collage de fotos",
  "Карточка для маркетплейса": "Ficha para marketplace",
  "шаг|шага|шагов": "paso|pasos",
  "вопрос|вопроса|вопросов": "pregunta|preguntas",
  "Открыть": "Abrir",
  "Ответ на этот вопрос не подтвердился. Если он важен, напишите в поддержку: {0}.": "La respuesta a esta pregunta no se confirmó. Si es importante, escribe a soporte: {0}.",
  "Ответ на этот вопрос не подтвердился. Если он важен, напишите в поддержку.": "La respuesta a esta pregunta no se confirmó. Si es importante, escribe a soporte.",
  "Ответ ещё не пришёл. Проверим этот же вопрос, второй раз он не задастся.": "Aún no hay respuesta. Comprobaremos la misma pregunta; no se enviará dos veces.",
  "Открыть профиль": "Abrir perfil",
  "Войти через STEOS ID": "Entrar con STEOS ID",
  "Тут Telegram откроет выбор чата": "Aquí Telegram abrirá la selección de chat",
  "Разделы поддержки": "Secciones de soporte",
  "Ответит сразу": "Responde al instante",
  "Отвечает сразу": "Responde al instante",
  "Поддержка в Telegram, {0}": "Soporte en Telegram, {0}",
  "Поддержка в Telegram": "Soporte en Telegram",
  "Видео медленнее обычного": "Vídeo: más despacio de lo habitual",
  "Видео работает медленнее обычного": "El vídeo funciona más despacio de lo habitual",
  "Спросить ИИ‑агента поддержки": "Preguntar al agente de soporte de IA",
  "Отвечает сразу и знает всё о STEOS": "Responde al instante y lo sabe todo sobre STEOS",
  "Поиск по вопросам и инструкциям": "Buscar preguntas e instrucciones",
  "Шесть коротких сторис о главном": "Seis historias breves sobre lo básico",
  "Попробуйте другие слова или спросите ИИ-агента": "Prueba con otras palabras o pregunta al agente de IA",
  "Проверено в {0}": "Comprobado a las {0}",
  "Заказы не теряются: результат придёт в чат, а если что-то сорвётся, Circle вернутся на баланс.": "Los pedidos no se pierden: el resultado llegará al chat y, si algo falla, los Circle volverán a tu saldo.",
  "Сервисы": "Servicios",
  "Загружаем статус сервисов": "Cargando el estado de los servicios",
  "Загружаем справку": "Cargando la ayuda",
  "Статус не загрузился": "No se cargó el estado",
  "Статус сервисов пока не отслеживается": "El estado de los servicios aún no se supervisa",
  "Если что-то не работает, напишите в поддержку": "Si algo no funciona, escribe a soporte",
  "Часть сервисов работает с перебоями": "Algunos servicios presentan fallos",
  "Статусы ваших работ и подтверждённые возвраты смотрите в «Истории».": "Consulta el estado de tus trabajos y los reembolsos confirmados en «Historial».",
  "Справка не загрузилась": "No se cargó la ayuda",
  "Справка пока не опубликована": "La ayuda aún no está publicada",
  "Вопрос можно задать поддержке в Telegram": "Puedes preguntar a soporte en Telegram",
  "Инструкции появятся после публикации справки": "Las instrucciones aparecerán cuando se publique la ayuda",
  "Назад к ИИ-агенту": "Volver al agente de IA",
  "Инструкция · {0}": "Guía · {0}",
  "Вопрос · {0}": "Pregunta · {0}",
  "Справка": "Ayuda",
  "Вопрос из Справки": "Pregunta de la Ayuda",
  "Подробнее из Справки": "Más en la Ayuda",
  "Назад по таблице": "Desplazar la tabla atrás",
  "Вперёд по таблице": "Desplazar la tabla adelante",
  "Здравствуйте, {0}.": "Hola, {0}.",
  "Здравствуйте.": "Hola.",
  "Я ИИ-агент поддержки STEOS: подскажу про тарифы и Circle, инструменты и шаблоны, промокоды, STEOS ID и партнёрство. Спросите своими словами или выберите вопрос.": "Soy el agente de soporte con IA de STEOS: te ayudo con planes y Circle, herramientas y plantillas, códigos promocionales, STEOS ID y el programa de socios. Pregunta con tus palabras o elige una pregunta.",
  "ИИ-агент печатает": "El agente de IA está escribiendo",
  "ИИ-агент ещё отвечает": "El agente de IA aún está respondiendo",
  "Напишите вопрос": "Escribe una pregunta",
  "Диалог с ИИ-агентом": "Conversación con el agente de IA",
  "Распознаём…": "Reconociendo…",
  "Слушаю": "Escuchando",
  "Спросите о STEOS": "Pregunta sobre STEOS",
  "Вопрос ИИ-агенту": "Pregunta para el agente de IA",
  "Остановить диктовку": "Detener el dictado",
  "Сказать голосом": "Dictar por voz",
  "Отправить": "Enviar",
  "Не удалось начать новый чат": "No se pudo iniciar un chat nuevo",
  "Спасибо, учтём": "Gracias, lo tendremos en cuenta",
  "Спасибо, передадим команде": "Gracias, se lo pasaremos al equipo",
  "Оценка не сохранилась": "No se guardó la valoración",
  "Чат ещё загружается": "El chat aún se está cargando",
  "В чате уже {0} вопросов. Начните новый": "Este chat ya tiene {0} preguntas. Empieza uno nuevo",
  "Вопрос не сохранился. Попробуйте ещё раз": "No se guardó la pregunta. Inténtalo de nuevo",
  "Некоторые сервисы работают медленнее обычного": "Algunos servicios funcionan más despacio de lo habitual",
  "{0} не работают": "{0} no funcionan",
  "{0} не работает": "{0} no funciona",
  "{0} медленнее обычного": "{0}: más despacio de lo habitual",
  "{0} работают медленнее обычного": "{0} funcionan más despacio de lo habitual",
  "{0} работает медленнее обычного": "{0} funciona más despacio de lo habitual",
  "Микрофон здесь недоступен": "El micrófono no está disponible aquí",
  "Нет доступа к микрофону": "Sin acceso al micrófono",
  "Нужна запись от 1 до 30 секунд": "La grabación debe durar de 1 a 30 segundos",
  "Не удалось разобрать запись": "No se pudo entender la grabación",
  "Диктовка не распозналась. Нажмите микрофон, чтобы проверить ещё раз": "No se reconoció el dictado. Toca el micrófono para comprobarlo de nuevo",
  "Вопрос не подошёл. Сформулируйте иначе": "La pregunta no es válida. Formúlala de otra manera",
  "Ответ не подтвердился. Напишите в поддержку": "La respuesta no se confirmó. Escribe a soporte",
  "Ответ не пришёл. Проверьте ещё раз": "No llegó la respuesta. Vuelve a comprobarlo",
  "Говорящий кружок, видео и фото говорят, повтори движения, свой аватар": "Círculo parlante, El vídeo habla, La foto habla, Repite los movimientos, avatar propio",
  "Оживить фото, видео по описанию, рилсы и сцены": "Animar foto, vídeo a partir de una descripción, reels y escenas",
  "Фото, фотосессии, товары, карусели": "Fotos, sesiones de fotos, productos, carruseles",
  "Голоса, клон, озвучка проектов, кавер": "Voces, clon, locución de guiones, cover",
  "Звёзды Telegram и карты": "Telegram Stars y tarjetas",
  "Не работает": "Sin servicio",
  "Как сделать по шагам": "Paso a paso",
  "Полезный ответ": "Respuesta útil",
  "Ответ не помог": "No me ayudó",
  "Проверьте связь и попробуйте ещё раз": "Comprueba la conexión e inténtalo de nuevo",
  "Не удалось проверить владельца чата": "No se pudo verificar el propietario del chat",
  "Не удалось восстановить чат. Начните новый": "No se pudo restaurar el chat. Empieza uno nuevo",
  "Клоны для озвучки": "Clones para locuciones",
  "Создайте первый голос": "Crea tu primera voz",
  "Люди и питомцы для фото": "Personas y mascotas para fotos",
  "Добавьте близких для фото": "Añade seres queridos para fotos",
  "Сохранённые работы": "Trabajos guardados",
  "Отмечайте работы сердцем": "Marca trabajos con un corazón",
  "Ежедневная серия и бонусы": "Racha diaria y bonos",
  "Частые вопросы и связь с нами": "Preguntas frecuentes y contacto",
  "Обучается": "Entrenando",
  "Аккаунт недоступен": "Cuenta no disponible",
  "Эта неделя · {0}": "Esta semana · {0}",
  "Неделя с {0} · {1}": "Semana del {0} · {1}",
  "ID скопирован": "ID copiado",
  "Скопировать ID": "Copiar ID",
  "Баланс временно недоступен": "Saldo no disponible por ahora",
  "Разбивка остатка временно недоступна": "Desglose del saldo no disponible por ahora",
  "Из них {0} C сгорит {1}|Из них {0} C сгорят {1}|Из них {0} C сгорят {1}": "De ellos, {0} C caduca el {1}|De ellos, {0} C caducan el {1}",
  "Ближайшие {0} C сгорят {1}": "Los próximos {0} C caducan el {1}",
  "Circle каждый месяц от {0}": "Circle cada mes desde {0}",
  "Circle каждый месяц с подпиской": "Circle cada mes con suscripción",
  "Тариф временно недоступен": "Plan no disponible por ahora",
  "Аккаунт, подписка и баланс": "Cuenta, suscripción y saldo",
  "Статистика и моё": "Estadísticas y Mío",
  "{0} к прошлой неделе": "{0} vs. semana pasada",
  "Работы по неделям: на этой неделе {0}": "Trabajos por semana: {0} esta semana",
  "Работы по неделям: на этой неделе {0}, на прошлой {1}": "Trabajos por semana: {0} esta semana, {1} la pasada",
  "Статистика пока недоступна": "Estadísticas aún no disponibles",
  "Дата регистрации недоступна": "Fecha de registro no disponible",
  "С {0}": "Desde el {0}",
  "Создано": "Creado",
  "Серия": "Racha",
  "день подряд|дня подряд|дней подряд": "día seguido|días seguidos",
  "Общий аккаунт STEOS": "Cuenta STEOS común",
  "Для вывода Circle": "Para retirar Circle",
  "До {0}% с их покупок": "Hasta un {0}% de sus compras",
  "Обновлено {0}": "Actualizado: {0}",
  "Действия": "Acciones",
  "Сохранить имя": "Guardar nombre",
  "Новое имя": "Nuevo nombre",
  "Больше голосов с подпиской": "Más voces con suscripción",
  "Создание голосов пока недоступно": "Aún no se pueden crear voces",
  "Свободных мест нет": "No hay espacios libres",
  "с подпиской до {0}": "hasta {0} con suscripción",
  "Пауза «{0}»": "Pausar «{0}»",
  "Прослушать «{0}»": "Escuchar «{0}»",
  "Переименовать": "Renombrar",
  "Запишите от 2 секунд речи или загрузите файлы, и голос будет звучать как вы": "Graba 2 segundos de voz o sube archivos, y la voz sonará como tú",
  "Свободных мест нет. Удалите голос, чтобы записать новый": "No hay espacios libres. Elimina una voz para grabar otra",
  "Выбрать за «Вы»": "Usar como «Tú»",
  "голос по умолчанию": "voz predeterminada",
  "Сделать кружок с вариантом «{0}»": "Crear un vídeo circular con el look «{0}»",
  "Выбраны": "Seleccionadas",
  "{0} фото|{0} фото|{0} фото": "{0} foto|{0} fotos",
  "{0} фото · для всех инструментов|{0} фото · для всех инструментов|{0} фото · для всех инструментов": "{0} foto · para todas las herramientas|{0} fotos · para todas las herramientas",
  "{0} вариант · кружки, фото и видео|{0} варианта · кружки, фото и видео|{0} вариантов · кружки, фото и видео": "{0} look · vídeos circulares, fotos y vídeos|{0} looks · vídeos circulares, fotos y vídeos",
  "{0} вариант|{0} варианта|{0} вариантов": "{0} look|{0} looks",
  "Голос {0} удалён, у варианта {1} теперь голос по умолчанию.": "Se eliminó la voz {0}; el look {1} ahora usa la voz predeterminada.",
  "Голоса удалены, у вариантов {0} теперь голос по умолчанию.": "Se eliminaron voces; los looks {0} ahora usan la voz predeterminada.",
  "Другой голос можно выбрать у каждого кружка": "Puedes elegir otra voz en cada vídeo circular",
  "Вариантов пока нет": "Aún no hay looks",
  "Загрузите свои фото, и вариант себя будет говорить вашим голосом в кружках, фото и видео": "Sube tus fotos y tu look hablará con tu voz en vídeos circulares, fotos y vídeos",
  "Вы: свои фото и варианты": "Tú: tus fotos y looks",
  "добавьте фото": "añade fotos",
  "Изменить «{0}»": "Editar «{0}»",
  "{0} близкий · для фото и видео|{0} близких · для фото и видео|{0} близких · для фото и видео": "{0} ser querido · para fotos y vídeos|{0} seres queridos · para fotos y vídeos",
  "Люди и питомцы для фото и видео": "Personas y mascotas para fotos y vídeos",
  "Близких пока нет": "Aún no hay seres queridos",
  "Добавьте людей и питомцев с фото, и они появятся в кадре рядом с вами": "Añade personas y mascotas con fotos y aparecerán en la imagen a tu lado",
  "Открыть в «Истории»": "Abrir en Historial",
  "Вернуть в избранное": "Volver a añadir a favoritos",
  "{0} работа с сердцем|{0} работы с сердцем|{0} работ с сердцем": "{0} trabajo con corazón|{0} trabajos con corazón",
  "Отмеченные сердцем работы": "Trabajos marcados con corazón",
  "Открыть «Историю»": "Abrir Historial",
  "Не удалось загрузить избранное": "No se pudieron cargar los favoritos",
  "Закройте лист и откройте его ещё раз": "Cierra la ventana y ábrela de nuevo",
  "Отмечайте работы сердцем в «Истории», и они соберутся здесь": "Marca trabajos con un corazón en Historial y se reunirán aquí",
  "Не удалось обновить. Попробуйте позже": "No se pudo actualizar. Inténtalo más tarde",
  "Удалить голос «{0}»?": "¿Eliminar la voz «{0}»?",
  "Голос пропадёт из списка. Вернуть его не получится.": "La voz desaparecerá de la lista. No podrás recuperarla.",
  "Удалить вариант «{0}»?": "¿Eliminar el look «{0}»?",
  "За «Вы» снова встанут ваши фото.": "Tus fotos volverán a usarse como «Tú».",
  "Готовые кружки и фото с ним останутся в «Истории». Вернуть вариант не получится.": "Los vídeos circulares y fotos ya hechos seguirán en Historial. No podrás recuperar el look.",
  "Не удалось удалить голос": "No se pudo eliminar la voz",
  "Не удалось удалить вариант. Попробуйте ещё раз": "No se pudo eliminar el look. Inténtalo de nuevo",
  "«{0}»": "«{0}»",
  "подписка: до {0}": "hasta el {0}",
  "варианты «Вы»: Новый вариант": "Nuevo look",
  "в очереди": "en cola",
  "идёт": "en curso",
  "завершено": "completado",
  "не удалось": "fallido",
  "слово подтверждения: УДАЛИТЬ": "ELIMINAR",
  "Выгрузка: {0}": "Exportación: {0}",
  "Удаление: {0}. STEOS ID и финансовые квитанции сохраняются.": "Eliminación: {0}. El STEOS ID y los recibos financieros se conservan.",
  "Введите {0}": "Escribe {0}",
  "Перенос ещё не подтверждён. Проверка продолжится, откройте лист позже": "La transferencia aún no está confirmada. Seguiremos comprobando: abre la ventana más tarde",
  "Этот STEOS ID уже связан с другим Telegram": "Este STEOS ID ya está vinculado a otra cuenta de Telegram",
  "На обоих аккаунтах есть подписка. Для объединения напишите в поддержку": "Ambas cuentas tienen suscripción. Escribe a soporte para unirlas",
  "Слишком много попыток. Попробуйте позже": "Demasiados intentos. Inténtalo más tarde",
  "Подключение STEOS ID сейчас недоступно. Попробуйте позже": "Ahora no se puede conectar STEOS ID. Inténtalo más tarde",
  "Не удалось создать аккаунт. Попробуйте позже": "No se pudo crear la cuenta. Inténtalo más tarde",
  "Не удалось отправить письмо": "No se pudo enviar el correo",
  "Фото не подошло. Выберите другое": "La foto no sirve. Elige otra",
  "Загрузите фото заново": "Vuelve a subir la foto",
  "Данные изменились. Откройте заново": "Los datos cambiaron. Ábrelo de nuevo",
  "подряд": "seguidos",
  "Начните {0}": "Empieza {0}",
  "серию": "una racha",
  "Завтра +{0} C": "Mañana +{0} C",
  "Заходите каждый день: награда растёт, на седьмой день {0} C. Пропуск дня начинает серию заново.": "Entra cada día: la recompensa crece y el séptimo día son {0} C. Si te saltas un día, la racha empieza de cero.",
  "Забрать {0} C": "Reclamar {0} C",
  "Прогресс": "Progreso",
  "Заданий здесь пока нет": "Aún no hay tareas aquí",
  "Время обновления недоступно": "Hora de renovación no disponible",
  "Новые через {0}": "Nuevas en {0}",
  "Выполнено {0} из {1}": "{0} de {1} hechas",
  "друг|друга|друзей": "amigo|amigos",
  "{0} с вами": "{0} contigo",
  "Прогресс друзей недоступен": "Progreso de amigos no disponible",
  "Пригласить": "Invitar",
  "Засчитываются друзья, которые пришли по вашей ссылке или промокоду и создали первую работу": "Cuentan los amigos que llegan con tu enlace o código promocional y crean su primer trabajo",
  "Ещё {0} {1} до награды {2}": "{0} {1} más para {2}",
  "Все ступени пройдены": "Todos los niveles superados",
  "Получено {0} из {1}": "{0} de {1} obtenidas",
  "Задания": "Tareas",
  "покупатель|покупателя|покупателей": "comprador|compradores",
  "Партнёрская программа": "Programa de socios",
  "Партнёрам": "Para socios",
  "До {0}% {1}": "Hasta el {0}% {1}",
  "с покупок друзей": "de las compras de amigos",
  "Заработано {0} с покупок {1} {2}": "Ganado {0} con compras de {1} {2}",
  "друга|друзей|друзей": "amigo|amigos",
  "Сами выбирайте: больше возможностей в STEOS или доход с рекомендаций.": "Tú eliges: más posibilidades en STEOS o ingresos por recomendaciones.",
  "Ещё {0} до уровня {1}": "{0} más para {1}",
  "Максимальный уровень: вывод через STEOS ID": "Nivel máximo: retirada con STEOS ID",
  "Статистика, материалы и вывод": "Estadísticas, materiales y retiradas",
  "Исход прежнего запроса награды нужно проверить. Новые начисления пока заблокированы": "Hay que comprobar la solicitud de recompensa anterior. Las nuevas recompensas están bloqueadas por ahora",
  "Загружаем награды": "Cargando recompensas",
  "Награды не загрузились": "No se cargaron las recompensas",
  "Создайте 3 работы": "Crea 3 trabajos",
  "Сделайте кружок": "Crea un vídeo circular",
  "Персонаж или вы сами": "Un personaje o tú",
  "Озвучьте текст": "Da voz a un texto",
  "Голосом героя или клона": "Con la voz de un personaje o clon",
  "Улучшите описание": "Mejora una descripción",
  "Бот допишет детали": "El bot añade los detalles",
  "Отправьте работу": "Envía un trabajo",
  "Из «Истории» в любой чат": "Del Historial a cualquier chat",
  "Неделя кружков": "Semana de vídeos circulares",
  "Создайте 10 кружков за неделю": "Crea 10 vídeos circulares en una semana",
  "Исследователь": "Explorador",
  "Попробуйте 5 разных инструментов студии": "Prueba 5 herramientas distintas del Estudio",
  "Первый кружок": "Primer vídeo circular",
  "Видеокружок для Telegram": "Vídeo circular para Telegram",
  "Клон голоса": "Clon de voz",
  "Всего 2 секунды речи": "Solo 2 segundos de voz",
  "Первое фото": "Primera foto",
  "Портрет в любом стиле": "Retrato en cualquier estilo",
  "Первый рилс с вами": "Tu primer reel",
  "Шаблон одной кнопкой": "Plantilla con un toque",
  "Первый кавер": "Primer cover",
  "Песня другим голосом": "Una canción con otra voz",
  "Кружки и видео с вами": "Vídeos circulares y vídeos contigo",
  "С вашей ссылкой": "Con tu enlace",
  "Бот в чате": "Bot en un chat",
  "Добавьте бота в группу": "Añade el bot a un grupo",
  "Вход в STEOS ID": "Entrar con STEOS ID",
  "Один аккаунт с сайтом": "Una cuenta con el sitio web",
  "Первый друг": "Primer amigo",
  "3 друга": "3 amigos",
  "10 друзей": "10 amigos",
  "25 друзей": "25 amigos",
  "Первый покупатель": "Primer comprador",
  "Первая оплата друга": "Primer pago de un amigo",
  "{0} мин": "{0} min",
  "{0} ч": "{0} h",
  "Последний день": "Último día",
  "Ещё {0} {1}": "Quedan {0} {1}",
  "Это задание выполняется вне мини-приложения": "Esta tarea se completa fuera de la Mini App",
  "Задание пока недоступно": "Tarea aún no disponible",
  "Прогресс временно недоступен": "Progreso no disponible por ahora",
  "Не удалось восстановить прежний запрос награды. Проверьте баланс и напишите в поддержку": "No se pudo recuperar la solicitud de recompensa anterior. Revisa tu saldo y escribe a soporte",
  "Награды временно недоступны. Попробуйте обновить данные": "Las recompensas no están disponibles por ahora. Prueba a actualizar",
  "Награда подтверждена. Обновите данные: повторять начисление не нужно": "Recompensa confirmada. Actualiza los datos: no hace falta reclamarla otra vez",
  "Задание ещё не выполнено. Обновите прогресс": "La tarea aún no está hecha. Actualiza el progreso",
  "Награда уже получена. Обновите данные": "La recompensa ya se obtuvo. Actualiza los datos",
  "Начисление не подтверждено. Проверьте прежний запрос: новая награда пока заблокирована": "Abono no confirmado. Comprueba la solicitud anterior: las nuevas recompensas están bloqueadas",
  "Сначала обновите данные наград": "Primero actualiza las recompensas",
  "Сначала проверьте прежний запрос награды": "Primero comprueba la solicitud de recompensa anterior",
  "Рассказчик": "Narrador",
  "Встреча на тракте": "Encuentro en el camino",
  "Геральт": "Geralt",
  "Цири": "Ciri",
  "Дождь шёл третий день, и дорога к крепости почти исчезла под грязью.": "Llovía por tercer día y el camino a la fortaleza casi había desaparecido bajo el barro.",
  "Ты опять ушла вперёд без меня. Я же просил ждать у моста.": "Otra vez te adelantaste sin mí. Te pedí que esperaras junto al puente.",
  "Я ждала. Целый час. Потом решила, что ты заблудился.": "Esperé. Una hora entera. Luego pensé que te habías perdido.",
  "Ведьмаки не блуждают. Мы иногда выбираем длинную дорогу.": "Los brujos no se pierden. A veces elegimos el camino largo.",
  "Тогда в следующий раз выбирай её быстрее. Я замёрзла.": "Pues la próxima vez elígelo más rápido. Estoy helada.",
  "Он молча снял плащ и накинул ей на плечи. Впереди уже виднелись огни крепости.": "En silencio se quitó la capa y se la echó sobre los hombros. Ya se veían las luces de la fortaleza.",
  "Пойдём. Весемир наверняка уже поставил суп на огонь.": "Vamos. Seguro que Vesemir ya ha puesto la sopa al fuego.",
  "Опять ты?": "¿Otra vez tú?",
  "Мне нужна помощь": "Necesito ayuda",
  "Вставьте сценарий или начните с нуля": "Pega un guion o empieza desde cero",
  "Напишите хотя бы одну реплику": "Escribe al menos una intervención",
  "Сократите реплику: до {0} знаков": "Acorta la intervención: hasta {0} caracteres",
  "Сократите проект: до {0} знаков": "Acorta el proyecto: hasta {0} caracteres",
  "Озвучка проектов временно недоступна": "La locución de guiones no está disponible por ahora",
  "Выберите голос для каждой роли": "Elige una voz para cada rol",
  "Озвучить · {0} C": "Dar voz · {0} C",
  "Без названия": "Sin título",
  "Роль": "Rol",
  "вчера": "ayer",
  "Проекты": "Proyectos",
  "роль|роли|ролей": "rol|roles",
  "реплика|реплики|реплик": "intervención|intervenciones",
  "Нет реплик": "Sin intervenciones",
  "{0} знаков": "{0} caracteres",
  "Строки «Имя: реплика» сами станут ролями и голосами": "Las líneas «Nombre: texto» se convierten en roles y voces",
  "Начать с нуля": "Empezar desde cero",
  "Роли и реплики добавите сами": "Añade tú los roles e intervenciones",
  "Открыть пример": "Abrir un ejemplo",
  "Проекты сохраняются сами: вернуться к ним можно в любой момент": "Los proyectos se guardan solos: puedes volver a ellos cuando quieras",
  "Роль с именем персонажа сама получит его голос: Геральт, Цири, Йеннифэр": "Un rol con el nombre de un personaje recibe su voz: Geralt, Ciri, Yennefer",
  "Переименовать проект": "Renombrar proyecto",
  "Загрузить свежую": "Cargar la última",
  "{0}: голос {1}. Сменить голос": "{0}: voz {1}. Cambiar voz",
  "Действия с ролью": "Acciones del rol",
  "Озвучиваем": "Generando voz",
  "Действия с репликой": "Acciones de la intervención",
  "Реплика: {0}": "Intervención: {0}",
  "Реплик пока нет": "Aún no hay intervenciones",
  "Нажмите «Реплика» внизу или вставьте готовый сценарий": "Toca «Intervención» abajo o pega un guion listo",
  "Реплика": "Intervención",
  "за проект": "por proyecto",
  "Цена — по числу знаков": "Precio según los caracteres",
  "Добавить реплику": "Añadir intervención",
  "проект|проекта|проектов": "proyecto|proyectos",
  "{0} {1} · сохраняются сами": "{0} {1} · se guardan solos",
  "Пока ни одного": "Aún no hay ninguno",
  "Новый проект": "Nuevo proyecto",
  "Вставить сценарий или начать с нуля": "Pegar un guion o empezar desde cero",
  "Удаление проекта": "Eliminar proyecto",
  "Новая роль": "Nuevo rol",
  "Это первая реплика": "Es la primera intervención",
  "Это последняя реплика": "Es la última intervención",
  "Удалить роль": "Eliminar rol",
  "Вместе с её репликами": "Junto con sus intervenciones",
  "В проекте нужна хотя бы одна роль": "El proyecto necesita al menos un rol",
  "Удалить роль «{0}»?": "¿Eliminar el rol «{0}»?",
  "Вместе с ней уйдут {0} {1}.": "También se eliminará: {0} {1}.",
  "Удалить проект?": "¿Eliminar el proyecto?",
  "{0}. Роли и реплики удалятся, вернуть проект не получится.": "{0}. Se eliminarán los roles y las intervenciones; no podrás recuperar el proyecto.",
  "Выбор голоса откроется в приложении": "La selección de voz se abrirá en la app",
  "Не удалось удалить проект: {0}": "No se pudo eliminar el proyecto: {0}",
  "Не получилось открыть аудио": "No se pudo abrir el audio",
  "Не получилось включить звук": "No se pudo reproducir el sonido",
  "Сначала напишите текст реплики": "Primero escribe el texto de la intervención",
  "Аудио реплики пока недоступно": "El audio de la intervención aún no está disponible",
  "Готовим роли": "Preparando roles",
  "Роли готовы": "Roles listos",
  "Озвучиваем реплики": "Locutando intervenciones",
  "Реплики озвучены": "Intervenciones locutadas",
  "Собираем дорожку": "Montando la pista",
  "Дорожка собрана": "Pista montada",
  "дубль {0}": "toma {0}",
  "Время реплики пока недоступно": "El tiempo de la intervención aún no está disponible",
  "Общий файл · {0}": "Archivo completo · {0}",
  "Аудио пока недоступно": "Audio aún no disponible",
  "Слушать дорожку": "Escuchar la pista",
  "реплика {0} из {1}": "intervención {0} de {1}",
  "Проект не озвучен": "Proyecto sin locutar",
  "Можно уйти с экрана: озвучка продолжится, дорожка появится здесь и в «Истории».": "Puedes salir de la pantalla: la locución seguirá y la pista aparecerá aquí y en el Historial.",
  "Можно уйти с экрана: бот напишет, когда дорожка будет готова.": "Puedes salir de la pantalla: el bot te escribirá cuando la pista esté lista.",
  "Отправьте общий файл в чат или скачайте его. Любую реплику можно переозвучить отдельно.": "Envía el archivo completo al chat o descárgalo. Puedes volver a locutar cualquier intervención por separado.",
  "Бот уже прислал общий файл в чат, в отдельную тему. Любую реплику можно переозвучить отдельно.": "El bot ya envió el archivo completo al chat, en un tema aparte. Puedes volver a locutar cualquier intervención por separado.",
  "Сценарий не прошёл проверку": "El guion no superó la revisión",
  "проект не озвучен": "proyecto sin locutar",
  "Не получилось собрать дорожку": "No se pudo montar la pista",
  "К сценарию": "Al guion",
  "Звук дорожки не загрузился: скачайте файл": "El audio de la pista no se cargó: descarga el archivo",
  "Каждая реплика с новой строки: имя, двоеточие, текст. Строка без имени достаётся предыдущей роли": "Cada intervención en una línea nueva: nombre, dos puntos, texto. Una línea sin nombre es del rol anterior",
  "голос персонажа": "voz del personaje",
  "Заменить сценарий": "Reemplazar guion",
  "Сейчас {0} {1}, они уйдут": "Ahora hay {0} {1}; se eliminarán",
  "реплику|реплики|реплик": "intervención|intervenciones",
  "Заменить на {0} {1}": "Reemplazar por {0} {1}",
  "Добавить {0} {1}": "Añadir {0} {1}",
  "Заменить реплики": "Reemplazar intervenciones",
  "Добавить реплики": "Añadir intervenciones",
  "Не нашли реплик: имя, двоеточие, текст": "No hay intervenciones: nombre, dos puntos, texto",
  "Вставьте сценарий в поле": "Pega el guion en el campo",
  "Роли и голоса появятся сами": "Los roles y las voces aparecerán solos",
  "Геральт: Опять ты. Что на этот раз? Цири: Мне нужна твоя помощь.": "Geralt: Otra vez tú. ¿Qué pasa esta vez?\nCiri: Necesito tu ayuda.",
  "Сейчас нельзя": "Ahora no se puede",
  "Вставьте текст в поле": "Pega el texto en el campo",
  "Загружаем проекты": "Cargando proyectos",
  "Проекты не загрузились": "No se cargaron los proyectos",
  "Не хватает Circle: пополните баланс": "No hay suficientes Circle: recarga el saldo",
  "Цена: {0} C. Нажмите ещё раз, чтобы озвучить": "Precio: {0} C. Toca otra vez para dar voz",
  "Не удалось посчитать цену. Попробуйте ещё раз": "No se pudo calcular el precio. Inténtalo de nuevo",
  "Сценарий не прошёл проверку. Измените текст и попробуйте ещё раз.": "El guion no superó la revisión. Cambia el texto e inténtalo de nuevo.",
  "Не получилось собрать дорожку. Если Circle списались, они вернутся на баланс.": "No se pudo montar la pista. Si se descontaron Circle, volverán a tu saldo.",
  "Запуск не подтверждён": "Inicio no confirmado",
  "Не получилось собрать дорожку.": "No se pudo montar la pista.",
  "Повторная проверка не спишет Circle дважды.": "Comprobar de nuevo no cobrará Circle dos veces.",
  "Отправили в чат": "Enviado al chat",
  "Отправка принята: бот пришлёт дорожку в чат": "Envío aceptado: el bot enviará la pista al chat",
  "Прослушивание реплики пока недоступно": "La escucha de la intervención aún no está disponible",
  "Прослушать реплику: {0} C. Нажмите ещё раз": "Escuchar intervención: {0} C. Toca otra vez",
  "Переозвучка реплики пока недоступна": "Volver a locutar la intervención aún no está disponible",
  "Переозвучить реплику: {0} C. Нажмите ещё раз": "Volver a locutar: {0} C. Toca otra vez",
  "Сохранение проектов сейчас недоступно. Обновите данные.": "Ahora no se pueden guardar proyectos. Actualiza los datos.",
  "Изменение проектов сейчас недоступно. Обновите данные.": "Ahora no se pueden editar proyectos. Actualiza los datos.",
  "Проект ещё сохраняется. Попробуйте через секунду.": "El proyecto aún se está guardando. Inténtalo en un segundo.",
  "Результат больше недоступен.": "El resultado ya no está disponible.",
  "Не удалось проверить владельца проекта.": "No se pudo verificar el propietario del proyecto.",
  "Операция не найдена. Проверьте историю.": "Operación no encontrada. Revisa el Historial.",
  "Проект ещё не сохранён.": "El proyecto aún no se ha guardado.",
  "Озвучка проектов сейчас недоступна. Обновите данные.": "La locución de guiones no está disponible ahora. Actualiza los datos.",
  "Прослушивание реплики сейчас недоступно. Обновите данные.": "La escucha de la intervención no está disponible ahora. Actualiza los datos.",
  "Переозвучка реплики сейчас недоступна. Обновите данные.": "Volver a locutar la intervención no está disponible ahora. Actualiza los datos.",
  "Дорожка ещё не готова.": "La pista aún no está lista.",
  "Аккаунт сменился. Обновите страницу.": "La cuenta ha cambiado. Recarga la página.",
  "Отправка пока не подтверждена. Нажмите ещё раз, чтобы проверить прежний запрос.": "El envío aún no está confirmado. Toca otra vez para comprobar la solicitud anterior.",
  "Результат проекта пока недоступен. Проверьте статус ещё раз.": "El resultado del proyecto aún no está disponible. Vuelve a comprobar el estado.",
  "Не удалось открыть аудио проекта.": "No se pudo abrir el audio del proyecto.",
  "месяц|месяца|месяцев": "mes|meses",
  "покупателя|покупателей|покупателей": "comprador|compradores",
  "рабочий день|рабочих дня|рабочих дней": "día hábil|días hábiles",
  "друг купит|друга купят|друзей купят": "amigo compra|amigos compran",
  "покупателем|покупателями|покупателями": "comprador|compradores",
  "Баннеры": "Banners",
  "Постер": "Póster",
  "Голос героя": "Voz del personaje",
  "Персонаж говорит": "El personaje habla",
  "Было и стало": "Antes y después",
  "Подарок другу": "Regalo para un amigo",
  "Кружок, который говорит": "Un círculo que habla",
  "Персонаж читает ваш текст": "Un personaje lee tu texto",
  "Рилс с вами одной кнопкой": "Un reel contigo en un toque",
  "Сюжет, монтаж и музыка в шаблоне": "Guion, montaje y música incluidos",
  "Герой говорит": "El héroe habla",
  "Герой говорит вашим текстом": "Un héroe dice tu texto",
  "Голос и губы в такт": "Voz y labios sincronizados",
  "Старое фото как новое": "Fotos antiguas como nuevas",
  "Цвет и резкость за минуту": "Color y nitidez en un minuto",
  "Кавер любым голосом": "Un cover con cualquier voz",
  "Рок, джаз или lo-fi": "Rock, jazz o lo-fi",
  "Фотосессия в любом образе": "Fotos con cualquier look",
  "По паре своих фото": "Con un par de fotos tuyas",
  "Друзьям": "Para amigos",
  "Личное сообщение": "Mensaje privado",
  "Подписчикам": "Para seguidores",
  "Пост в канал": "Publicación en el canal",
  "Семье": "Para la familia",
  "Сообщение родным": "Mensaje a la familia",
  "Геймерам": "Para gamers",
  "Чат по интересам": "Chat temático",
  "Для работы": "Para el trabajo",
  "Коллегам и в рабочий чат": "Compañeros y chat de trabajo",
  "Авторам": "Para creadores",
  "Блогерам и создателям роликов": "Blogueros y creadores de vídeo",
  "Подарок по моему промокоду": "Un regalo con mi código",
  "Кружки, фото и голос с ИИ прямо в Telegram": "Vídeos circulares, fotos y voz con IA en Telegram",
  "Кружки с персонажами": "Vídeos circulares con personajes",
  "Пишете текст, персонаж его говорит": "Tú escribes, el personaje habla",
  "Озвучка любым голосом": "Locución con cualquier voz",
  "Из библиотеки или своим клоном": "De la biblioteca o con tu clon",
  "Фотосессия без студии": "Sesión de fotos sin estudio",
  "Пара своих фото, любой образ": "Un par de fotos, cualquier look",
  "{0} с регистрации по вашей ссылке или с первой покупки по промокоду. Всё это время процент идёт со всех оплат друга. Промокод работает только до первой покупки друга, а если друг пришёл по ссылке, промокод привязку уже не меняет.": "{0} desde el registro con tu enlace o desde la primera compra con tu código. Durante ese tiempo recibes un porcentaje de todos los pagos del amigo. El código solo funciona hasta su primera compra y, si llegó por tu enlace, el código ya no cambia la vinculación.",
  "Что получает друг?": "¿Qué recibe tu amigo?",
  "+{0} C сразу: они не выводятся и сгорают через {1}.": "+{0} C al instante: no se pueden retirar y caducan en {1}.",
  "Скидка {0}% на первый пакет Circle действует {1} после оформления подписки, потому что пакеты Circle продаются только с подпиской. Подарок один на аккаунт: по ссылке или по промокоду.": "El {0}% de descuento en el primer paquete de Circle vale durante {1} tras suscribirse, porque los paquetes de Circle solo se venden con suscripción. Un regalo por cuenta: por enlace o por código.",
  "Что считается оплатой?": "¿Qué cuenta como pago?",
  "Подписка и пакеты Circle, оплаченные звёздами или картой. Процент считается от суммы, которую друг заплатил, со скидкой. Бонусные монеты, награды за задания и возвраты не учитываются.": "Suscripciones y paquetes de Circle pagados con Stars o tarjeta. El porcentaje se calcula sobre lo que pagó el amigo, con descuento. No cuentan las monedas de bonificación, las recompensas por tareas ni los reembolsos.",
  "Какие бывают промокоды?": "¿Qué tipos de códigos hay?",
  "Ваш промокод партнёра даёт другу подарок и привязывает его к вам, работает только до его первой покупки. Промокоды STEOS публикует команда в канале и сообществе STEOS: они дают Circle со своим сроком и работают у всех, один раз на аккаунт.": "Tu código de socio da un regalo a tu amigo y lo vincula contigo; solo funciona hasta su primera compra. Los códigos de STEOS los publica el equipo en el canal y la comunidad de STEOS: dan Circle con su propio plazo y sirven a todos, una vez por cuenta.",
  "Когда приходят Circle?": "¿Cuándo llegan los Circle?",
  "Сразу после оплаты друга, прямо на баланс. На уровне {0} их можно вывести.": "Justo después del pago del amigo, directo a tu saldo. En el nivel {0} puedes retirarlos.",
  "Сразу после оплаты друга, прямо на баланс. На уровнях {0} они работают внутри STEOS, на уровне {1} их можно вывести.": "Justo después del pago del amigo, directo a tu saldo. En los niveles {0} funcionan dentro de STEOS; en {1} puedes retirarlos.",
  "Сразу после оплаты друга, прямо на баланс. На уровне {0} они работают внутри STEOS, на уровне {1} их можно вывести.": "Justo después del pago del amigo, directo a tu saldo. En el nivel {0} funcionan dentro de STEOS; en {1} puedes retirarlos.",
  "Считаются ли друзья с истёкшей привязкой?": "¿Cuentan los amigos con vínculo vencido?",
  "Да. Процент с их оплат больше не идёт, но в счёте уровня они остаются: уровень считается по всем покупателям за всё время.": "Sí. Ya no recibes porcentaje de sus pagos, pero siguen contando para el nivel: se calcula con todos los compradores de siempre.",
  "Кто может выводить?": "¿Quién puede retirar?",
  "Партнёры уровня {0} (от {1}) со статусом ИП, самозанятого или иностранного аналога, после входа через STEOS ID. Вывод только деньгами на счёт: здесь или на {2}.": "Socios del nivel {0} (desde {1}) con estatus de autónomo, empresario individual o equivalente extranjero, tras entrar con STEOS ID. El retiro es solo en dinero a una cuenta: aquí o en {2}.",
  "Амбассадоры (от {0}) со статусом ИП, самозанятого или иностранного аналога, после входа через STEOS ID. Вывод только деньгами на счёт: здесь или на {1}.": "Embajadores (desde {0}) con estatus de autónomo, empresario individual o equivalente extranjero, tras entrar con STEOS ID. El retiro es solo en dinero a una cuenta: aquí o en {1}.",
  "Можно ли вывести монеты, заработанные до входа?": "¿Puedo retirar las monedas ganadas antes de entrar?",
  "Да. Монеты Circle, заработанные на уровне {0} до входа через STEOS ID, ждут на балансе и станут доступны для вывода после входа.": "Sí. Los Circle ganados en el nivel {0} antes de entrar con STEOS ID esperan en tu saldo y podrás retirarlos tras entrar.",
  "Какие монеты тратятся первыми?": "¿Qué monedas se gastan primero?",
  "Можно пригласить самого себя?": "¿Puedo invitarme a mí mismo?",
  "Нет. Покупки с вашего аккаунта и с повторных аккаунтов не учитываются.": "No. No cuentan las compras desde tu cuenta ni desde cuentas duplicadas.",
  "Международный": "Internacional",
  "Self-employed, sole trader или компания вне РФ": "Autónomo, empresario o empresa fuera de Rusia",
  "Самозанятый в РФ": "Autónomo en Rusia",
  "Налог на профессиональный доход": "Impuesto sobre ingresos profesionales (NPD)",
  "ИП в РФ": "Empresario individual en Rusia",
  "Индивидуальный предприниматель": "Empresario individual",
  "Имя или компания": "Nombre o empresa",
  "Как в документах": "Como en tus documentos",
  "TIN или номер в вашей стране": "TIN o número fiscal de tu país",
  "ФИО": "Nombre completo",
  "Как в паспорте": "Como en el pasaporte",
  "ИНН": "INN",
  "12 цифр": "12 dígitos",
  "Название ИП": "Nombre del empresario",
  "Как в выписке": "Como en el extracto del registro",
  "ИНН или ОГРНИП": "INN u OGRNIP",
  "От 10 до 15 цифр": "De 10 a 15 dígitos",
  "НДС": "IVA",
  "Плательщик НДС": "Contribuyente de IVA",
  "Адрес": "Dirección",
  "КПП": "KPP",
  "ОГРН": "OGRN",
  "Основной офис STEOS": "Sede principal de STEOS",
  "Платёжный агент STEOS в России": "Agente de pagos de STEOS en Rusia",
  "Тут откроется выбор чата Telegram с этим текстом, ссылкой и промокодом": "Aquí se abrirá el selector de chats de Telegram con este texto, enlace y código",
  "Тут откроется выбор чата Telegram: баннер уйдёт с подписью и кнопкой «Открыть STEOS»": "Aquí se abrirá el selector de chats de Telegram: el banner irá con texto y el botón «Abrir STEOS»",
  "Ещё <b>{0} {1}</b> до уровня {2}": "<b>{0} {1}</b> más para {2}",
  "Максимальный уровень": "Nivel máximo",
  "До следующего уровня": "Hasta el siguiente nivel",
  "Получайте до&nbsp;{0}% <span>с&nbsp;покупок друзей</span>": "Gana hasta el&nbsp;{0}% <span>de las compras de tus amigos</span>",
  "Период": "Periodo",
  "Кого показать": "Mostrar",
  "Перешли": "Clics",
  "Зарегистрировались": "Registros",
  "Купили": "Compraron",
  "Пока нет данных": "Aún sin datos",
  "{0} к прошлому периоду": "{0} vs. periodo anterior",
  "за {0} {1}": "en {0} {1}",
  "Пока не считаем": "Aún no se cuenta",
  "нет начислений": "sin ingresos",
  "Пик <b>{0} C</b>": "Pico <b>{0} C</b>",
  "Начисления по месяцам": "Ingresos por mes",
  "Начисления по дням": "Ingresos por día",
  "Здесь появятся начисления": "Aquí aparecerán tus ingresos",
  "Подписка Про": "Suscripción Pro",
  "Купила Circle": "Compró Circle",
  "Купил Circle": "Compró Circle",
  "Покупатель": "Comprador",
  "по промокоду": "con código",
  "привязка истекла": "vínculo vencido",
  "Это весь список · {0}": "Es toda la lista · {0}",
  "Друг привязан к вам {0}: с регистрации по ссылке или с первой покупки по промокоду. Промокод работает только до первой покупки друга.": "El amigo queda vinculado a ti durante {0}: desde el registro con el enlace o desde la primera compra con el código. El código solo funciona hasta su primera compra.",
  "Покупатели с истёкшей привязкой остаются в счёте уровня.": "Los compradores con vínculo vencido siguen contando para el nivel.",
  "Пока никого": "Aún nadie",
  "Поделитесь ссылкой или промокодом, первые друзья появятся здесь": "Comparte tu enlace o código y aquí aparecerán tus primeros amigos",
  "Картинка": "Imagen",
  "Ссылка и промокод уже на картинке. Нажмите на шаблон, чтобы поправить подпись и опубликовать.": "El enlace y el código ya están en la imagen. Toca una plantilla para editar el texto y publicar.",
  "{0}, открыть и опубликовать": "{0}, abrir y publicar",
  "Для Reels, Shorts, TikTok и VK Клипов. Промокод и ссылка уже в кадре, бот пришлёт ролик в чат.": "Para Reels, Shorts, TikTok y VK Clips. El código y el enlace ya están en el vídeo; el bot te lo enviará al chat.",
  "{0}, открыть": "{0}, abrir",
  "Ссылка и промокод уже в тексте. Скопируйте его или отправьте в чат.": "El enlace y el código ya están en el texto. Cópialo o envíalo a un chat.",
  "Картинка уйдёт в чат с подписью и кнопкой «Открыть STEOS». Подойдёт для групп, каналов и личных сообщений.": "La imagen se enviará al chat con texto y el botón «Abrir STEOS». Sirve para grupos, canales y mensajes privados.",
  "Баннер «{0}» с вашим промокодом": "Banner «{0}» con tu código",
  "QR-постер: код ведёт на вашу ссылку, промокод {0}": "Póster QR: el código lleva a tu enlace, código {0}",
  "Кружки, фото и голос с ИИ": "Vídeos circulares, fotos y voz con IA",
  "+{0}&nbsp;C на старт по промокоду": "+{0}&nbsp;C para empezar con el código",
  "Начните по ссылке или промокоду": "Empieza con el enlace o el código",
  "Наведите камеру телефона": "Apunta la cámara del móvil",
  "A4 для печати: стойки, витрины, визитки. Код ведёт на вашу ссылку, а промокод под ним можно ввести и без камеры.": "A4 para imprimir: expositores, escaparates, tarjetas. El QR lleva a tu enlace y el código de abajo se puede introducir sin cámara.",
  "Цвет постера": "Color del póster",
  "Прислать PDF в чат": "Enviar PDF al chat",
  "Вывести": "Retirar",
  "Заявка на {0} C не подтверждена": "Solicitud de {0} C sin confirmar",
  "Вывод сейчас недоступен": "Retiro no disponible ahora",
  "Вывод недоступен": "No disponible",
  "Деньгами на ваш счёт за {0}": "Dinero a tu cuenta en {0}",
  "Вывод от {0} C": "Retiro desde {0} C",
  "Вывод заработает после входа через STEOS ID": "El retiro se activa tras entrar con STEOS ID",
  "Войдите через STEOS ID": "Entra con STEOS ID",
  "Вывод доступен на уровне {0}, от {1}": "El retiro se abre en {0}, desde {1}",
  "Нужен уровень {0}": "Requiere nivel {0}",
  "Вывод откроется на уровне {0}, от {1}. Пока Circle работают внутри STEOS": "El retiro se abrirá en {0}, desde {1}. Mientras, los Circle funcionan dentro de STEOS",
  "Не подключён": "No conectado",
  "Вход свяжет аккаунт бота с общим аккаунтом STEOS: баланс станет общим, а вывод заработает здесь и на сайте STEOS ID.": "Al entrar, tu cuenta del bot se vincula a tu cuenta común de STEOS: el saldo será compartido y el retiro funcionará aquí y en el sitio de STEOS ID.",
  "Выплачено": "Pagado",
  "В обработке": "En proceso",
  "Отклонено": "Rechazado",
  "Не удалось загрузить историю выводов": "No se pudo cargar el historial de retiros",
  "Выводов пока не было": "Aún no hay retiros",
  "за всё время": "en total",
  "Можно вывести": "Disponible para retirar",
  "Тестовая программа: настоящих выплат нет": "Programa de prueba: sin pagos reales",
  "Баланс и выводы есть и на {0}.": "El saldo y los retiros también están en {0}.",
  "Вопрос о выводе?": "¿Dudas sobre el retiro?",
  "Напишите в поддержку": "Escribe a soporte",
  "Поделитесь ссылкой или промокодом": "Comparte tu enlace o código",
  "Друг привязывается к вам на {0}": "Tu amigo queda vinculado a ti durante {0}",
  "Друг получает подарок": "Tu amigo recibe un regalo",
  "+{0} C сразу и −{1}% на первый пакет Circle после подписки": "+{0} C al instante y −{1}% en el primer paquete de Circle tras suscribirse",
  "Друг платит в STEOS": "Tu amigo paga en STEOS",
  "Подписка и пакеты Circle звёздами или картой": "Suscripción y paquetes de Circle con Stars o tarjeta",
  "Вам приходит процент": "Recibes un porcentaje",
  "{0}% с каждой оплаты, сразу на баланс": "{0}% de cada pago, directo a tu saldo",
  "Шаг {0}": "Paso {0}",
  "От {0}": "Desde {0}",
  "С первого дня": "Desde el primer día",
  "Если {0} {1} {2}": "Si {0} {1} {2}",
  "{0} C за {1}": "{0} C en {1}",
  "Хватит на {0} в месяц": "Alcanza para {0} al mes",
  "Кружок стоит {0} C": "Un vídeo circular cuesta {0} C",
  "Считаем по подписке {0}: {1} в месяц, это {2}&nbsp;C. Процент идёт с каждой оплаты друга {3} привязки.": "Calculado con la suscripción {0}: {1} al mes, son {2}&nbsp;C. El porcentaje llega de cada pago del amigo durante {3} de vinculación.",
  "Уровень считается вместе с вашими {0}.": "Tus compradores actuales también cuentan para el nivel: {0}.",
  "Калькулятор дохода": "Calculadora de ingresos",
  "Тариф друзей": "Plan de los amigos",
  "Сколько друзей купят подписку": "Cuántos amigos compran suscripción",
  "Вы получите": "Recibirás",
  "C в месяц": "C al mes",
  "Проценты, сроки и ограничения": "Porcentajes, plazos y límites",
  "Circle можно вывести": "Circle retirables",
  "Circle работают внутри STEOS": "Circle dentro de STEOS",
  "Привязка на {0}": "Vinculación por {0}",
  "Процент идёт со всех оплат друга: с регистрации по ссылке или с первой покупки по промокоду": "Porcentaje de todos los pagos del amigo: desde el registro con el enlace o desde la primera compra con el código",
  "Ссылка главнее промокода": "El enlace prevalece sobre el código",
  "Если друг пришёл по ссылке, промокод привязку уже не меняет": "Si el amigo llegó por enlace, el código ya no cambia la vinculación",
  "Промокод только до первой покупки": "Código solo hasta la primera compra",
  "После первой оплаты друга ваш промокод партнёра у него не работает": "Tras el primer pago del amigo, tu código de socio ya no le sirve",
  "{0} C сразу, сгорят через {1}. {2} на первый пакет Circle {3} после подписки": "{0} C al instante, caducan en {1}. {2} en el primer paquete de Circle durante {3} tras suscribirse",
  "Только уровень {0}": "Solo nivel {0}",
  "От {0} {1}, после входа через STEOS ID. Для ИП, самозанятых и их аналогов в других странах": "Desde {0} {1}, tras entrar con STEOS ID. Para autónomos, empresarios individuales y equivalentes en otros países",
  "Счёт на компанию STEOS": "Factura a una empresa de STEOS",
  "Плательщик появится, когда вывод откроется": "El pagador aparecerá cuando se abra el retiro",
  "В РФ: {0}, в рублях. Международный статус: {1}, в евро": "En Rusia: {0}, en rublos. Estatus internacional: {1}, en euros",
  "Выплата за {0}": "Pago en {0}",
  "После проверки счёта, от {0} C": "Tras revisar la factura, desde {0} C",
  "Коротко о главном": "Lo esencial en breve",
  "Здесь краткое изложение. Полный текст условий на {0}": "Esto es un resumen. Las condiciones completas están en {0}",
  "Понятно": "Entendido",
  "У вас {0}.": "Tienes {0}.",
  "Покупателей пока нет.": "Aún no hay compradores.",
  "Уровень считается по всем покупателям за всё время, с истёкшей привязкой тоже.": "El nivel se calcula con todos los compradores de siempre, también con vínculo vencido.",
  "Введите сумму": "Introduce un importe",
  "Можно вывести не больше {0} C": "Puedes retirar hasta {0} C",
  "Заполните реквизиты": "Completa los datos",
  "Загрузите счёт на оплату": "Sube una factura",
  "Счёт ещё проверяется": "La factura aún se está revisando",
  "Выплата в {0} · 1 C = {1} {0}": "Pago en {0} · 1 C = {1} {0}",
  "Вывести {0} C": "Retirar {0} C",
  "Счёт выставьте в {0}. Проверим его, и деньги придут за {1}.": "Emite la factura en {0}. La revisaremos y el dinero llegará en {1}.",
  "Счёт выставьте в евро. Проверим его, и деньги придут за {0}. Реквизиты сохранятся в STEOS ID.": "Emite la factura en euros. La revisaremos y el dinero llegará en {0}. Los datos se guardarán en STEOS ID.",
  "Счёт выставьте в рублях. Проверим его, и деньги придут за {0}. Реквизиты сохранятся в STEOS ID.": "Emite la factura en rublos. La revisaremos y el dinero llegará en {0}. Los datos se guardarán en STEOS ID.",
  "Скопировать {0}": "Copiar {0}",
  "юридический адрес": "dirección legal",
  "Скопировать название компании": "Copiar nombre de la empresa",
  "Скопировать все реквизиты": "Copiar todos los datos",
  "Реквизиты для счёта": "Datos para la factura",
  "Проверяем счёт…": "Revisando la factura…",
  "PDF, JPG или PNG, до 10 МБ": "PDF, JPG o PNG, hasta 10 MB",
  "Можно вывести {0} C": "{0} C disponibles",
  "Сумма, C": "Importe, C",
  "Сумма вывода, C": "Importe del retiro, C",
  "Всё": "Todo",
  "Придёт на счёт": "Recibirás",
  "Реквизиты": "Datos",
  "Счёт на оплату": "Factura",
  "Заявка на вывод принята": "Solicitud de retiro aceptada",
  "{0} придут за {1} после проверки счёта": "{0} llegarán en {1} tras revisar la factura",
  "Ролик принят в обработку": "El vídeo se está preparando",
  "Ролик в чате с ботом": "El vídeo está en el chat del bot",
  "Бот пришлёт его после подготовки. Доставка пока не подтверждена.": "El bot lo enviará cuando esté listo. La entrega aún no está confirmada.",
  "Сохраните его и выложите в Reels, Shorts, TikTok или VK Клипы": "Guárdalo y publícalo en Reels, Shorts, TikTok o VK Clips",
  "Промокод и ссылка уже в кадре. Бот пришлёт ролик в чат, оттуда его можно сохранить и выложить.": "El código y el enlace ya están en el vídeo. El bot lo enviará al chat; desde allí puedes guardarlo y publicarlo.",
  "Прислать в чат": "Enviar al chat",
  "Текст выделен: скопируйте его вручную": "El texto está seleccionado: cópialo a mano",
  "Баннер готов: отправить его в чат можно из Telegram": "Banner listo: puedes enviarlo a un chat desde Telegram",
  "PDF принят в очередь": "PDF en cola",
  "PDF в чате": "PDF en el chat",
  "Не удалось загрузить период. Попробуйте ещё раз": "No se pudo cargar el periodo. Inténtalo de nuevo",
  "Без начислений": "Sin ingresos",
  "Значение выделено: скопируйте его вручную": "Valor seleccionado: cópialo a mano",
  "Реквизиты выделены: скопируйте их вручную": "Datos seleccionados: cópialos a mano",
  "Нужен файл PDF, JPG или PNG": "Se necesita un PDF, JPG o PNG",
  "Файл {0}, можно до 10 МБ": "El archivo pesa {0}, máximo 10 MB",
  "Партнёрство не загрузилось": "Colaboración no se cargó",
  "Загружаем партнёрскую программу": "Cargando el programa de socios",
  "за неделю": "en la semana",
  "за месяц": "en el mes",
  "Для вывода войдите через STEOS ID": "Entra con STEOS ID para retirar",
  "Вывод недоступен на текущем уровне": "El retiro no está disponible en tu nivel",
  "Сумма больше доступной": "El importe supera lo disponible",
  "Сумма меньше минимальной": "El importe es inferior al mínimo",
  "Проверьте реквизиты и счёт": "Revisa los datos y la factura",
  "Счёт ещё не проверен. Загрузите его заново": "La factura aún no está verificada. Súbela de nuevo",
  "Ответ не получен. Проверьте ту же заявку: её данные и ключ сохранены": "Sin respuesta. Comprueba la misma solicitud: sus datos y clave están guardados",
  "Не удалось загрузить список друзей": "No se pudo cargar la lista de amigos",
  "Не удалось восстановить прежнюю заявку. Напишите в поддержку перед новой": "No se pudo recuperar la solicitud anterior. Escribe a soporte antes de hacer otra",
  "Партнёрская программа временно недоступна": "El programa de socios no está disponible por ahora",
  "Не удалось загрузить следующую страницу": "No se pudo cargar la página siguiente",
  "Не удалось подготовить баннер. Попробуйте ещё раз": "No se pudo preparar el banner. Inténtalo de nuevo",
  "Бот не может подготовить материал: откройте чат с ботом и попробуйте ещё раз": "El bot no puede prepararlo: abre el chat con el bot y vuelve a intentarlo",
  "Материал сейчас недоступен": "Material no disponible ahora",
  "Отправка не подтверждена. Нажмите ещё раз: повтор проверит прежний запрос": "Envío sin confirmar. Pulsa de nuevo: se comprobará la solicitud anterior",
  "Прежняя отправка не восстановлена. Напишите в поддержку": "No se recuperó el envío anterior. Escribe a soporte",
  "Прежняя отправка подтверждена. Нажмите ещё раз": "Envío anterior confirmado. Pulsa de nuevo",
  "Отправка не подтверждена": "Envío sin confirmar",
  "Счёт не прошёл проверку. Выберите PDF, JPG или PNG до 10 МБ": "La factura no pasó la revisión. Elige un PDF, JPG o PNG de hasta 10 MB",
  "Не удалось безопасно сохранить заявку. Отправка не выполнена": "No se pudo guardar la solicitud con seguridad. No se envió",
  "Тут откроется инструмент «{0}»": "Aquí se abrirá la herramienta «{0}»",
  "Геральт, Цири и ещё 2 400 голосов скажут всё, что напишете": "Geralt, Ciri y 2400 voces más dirán todo lo que escribas",
  "Снимите себя, и персонаж повторит ваши движения": "Grábate y el personaje repetirá tus movimientos",
  "Выберите образ, и через минуту готовы 3 кадра из одного селфи": "Elige un look y en un minuto tendrás 3 fotos de un solo selfie",
  "Сделать": "Crear",
  "2 400 голосов, 19 языков": "2400 voces, 19 idiomas",
  "Текст в речь голосом персонажа или своим клоном": "Texto a voz con la voz de un personaje o tu clon",
  "Ваш голос за две минуты": "Tu voz en dos minutos",
  "Запишите образец, и клон появится во всех инструментах с озвучкой": "Graba una muestra y el clon aparecerá en todas las herramientas con voz",
  "Движения": "Movimientos",
  "бесплатно": "gratis",
  "/сек": "/s",
  "готов": "listo",
  "Клон · готов": "Clon · listo",
  "студия: Мой голос": "Mi voz",
  "Сейчас в тренде": "Tendencia ahora",
  "Популярное за неделю": "Lo más popular de la semana",
  "Геральт скажет ваш текст": "Geralt dirá tu texto",
  "Вы в знаменитых сценах": "Tú en escenas famosas",
  "3 кадра в любом образе": "3 fotos con cualquier look",
  "Готовый сюжет с вами": "Una historia lista contigo",
  "Вы повторите любой танец": "Bailarás cualquier baile",
  "Ваш снимок в движении": "Tu foto en movimiento",
  "Фото скажет ваш текст": "La foto dirá tu texto",
  "Легенды замка": "Leyendas del castillo",
  "Город инков": "Ciudad inca",
  "Неоновый дождь": "Lluvia de neón",
  "Утренний бег": "Carrera matutina",
  "Танец теней": "Danza de sombras",
  "Дорога домой": "Camino a casa",
  "Ночной рейв": "Rave nocturna",
  "Снежный пик": "Pico nevado",
  "Тайны Хейвена": "Secretos de Haven",
  "Магия рун": "Magia rúnica",
  "Странные дела": "Cosas extrañas",
  "Ночной рынок": "Mercado nocturno",
  "Ретро-кадр": "Foto retro",
  "Утро в горах": "Mañana en la montaña",
  "Золотой час": "Hora dorada",
  "Студийный свет": "Luz de estudio",
  "Полароид": "Polaroid",
  "Киберпанк": "Cyberpunk",
  "Старый маяк": "El viejo faro",
  "Шторм в заливе": "Tormenta en la bahía",
  "Кинотрейлер": "Tráiler de cine",
  "Город в движении": "Ciudad en movimiento",
  "Интервью": "Entrevista",
  "Пустыня на закате": "Desierto al atardecer",
  "Подводный мир": "Mundo submarino",
  "Кружок «Привет»": "Círculo «Hola»",
  "Спокойной ночи": "Buenas noches",
  "Поздравляю": "Felicidades",
  "Скучаю": "Te extraño",
  "Новости дня": "Noticias del día",
  "Нос корабля": "La proa del barco",
  "Двое на носу корабля, руки раскинуты навстречу ветру": "Dos en la proa de un barco, con los brazos abiertos al viento",
  "Героиня": "Heroína",
  "роль: Герой": "Héroe",
  "Уклонение от пуль": "Esquivando balas",
  "Время замирает, вы прогибаетесь назад, и пули проходят мимо": "El tiempo se detiene, te inclinas hacia atrás y las balas pasan de largo",
  "Танец в закусочной": "Baile en el diner",
  "Пара танцует твист у стойки придорожной закусочной": "Una pareja baila twist en la barra de un diner de carretera",
  "Танцор": "Bailarín",
  "Танцовщица": "Bailarina",
  "Свидание под дождём": "Cita bajo la lluvia",
  "Ливень, старый дом и встреча, которую оба ждали годами": "Aguacero, una casa vieja y un encuentro que ambos esperaron años",
  "Он": "Él",
  "Она": "Ella",
  "Речь перед битвой": "Discurso antes de la batalla",
  "Вождь проезжает вдоль строя, и войско отвечает рёвом": "El líder recorre las filas y el ejército responde con un rugido",
  "Вождь": "Líder",
  "Знаменосец": "Abanderado",
  "Погоня по крышам": "Persecución por los tejados",
  "Прыжки между крышами ночного города, погоня не отстаёт": "Saltos entre tejados de la ciudad de noche, la persecución no se queda atrás",
  "Беглец": "Fugitivo",
  "Преследователь": "Perseguidor",
  "Ограбление казино": "Atraco al casino",
  "Команда в смокингах проходит через зал, сейф уже открыт": "Un equipo de esmoquin cruza la sala, la caja fuerte ya está abierta",
  "Главарь": "Jefe",
  "Напарник": "Compañero",
  "Напарница": "Compañera",
  "Прощание на вокзале": "Despedida en la estación",
  "Поезд трогается, двое держатся за руки до последнего": "El tren arranca, dos se toman de la mano hasta el último momento",
  "Пассажир": "Pasajero",
  "Провожающий": "Quien despide",
  "Дуэль на закате": "Duelo al atardecer",
  "Пустая улица, два стрелка и последние секунды тишины": "Una calle vacía, dos pistoleros y los últimos segundos de silencio",
  "Шериф": "Sheriff",
  "Злодей": "Villano",
  "Танец на лестнице": "Baile en la escalera",
  "Злодей в ярком костюме танцует на длинной уличной лестнице": "Un villano con traje llamativo baila en una larga escalera de la calle",
  "Выход в открытый космос": "Paseo espacial",
  "Астронавт парит над Землёй, трос уходит к станции": "Un astronauta flota sobre la Tierra, el cable va hasta la estación",
  "Астронавт": "Astronauta",
  "Рассвет над саванной": "Amanecer en la sabana",
  "Питомца поднимают над скалой, и вся саванна смотрит на него": "Alzan a la mascota sobre la roca y toda la sabana la mira",
  "Главная роль": "Papel principal",
  "Хранитель": "Guardián",
  "Полёт под луной": "Vuelo bajo la luna",
  "Велосипед отрывается от земли и летит на фоне луны": "La bicicleta despega del suelo y vuela frente a la luna",
  "Финальная поддержка": "El levantamiento final",
  "Разбег, прыжок и поддержка над головой под аплодисменты зала": "Carrera, salto y levantamiento sobre la cabeza entre aplausos",
  "Партнёрша": "Pareja",
  "Партнёр": "Socio",
  "Песня на холме": "Canción en la colina",
  "Альпийский луг и ветер: вы кружитесь с песней, а дети бегут к вам навстречу": "Un prado alpino y el viento: giras cantando y los niños corren hacia ti",
  "Бледная кожа": "Piel pálida",
  "Хвойный лес": "Bosque de coníferas",
  "Первый взгляд": "Primera mirada",
  "Туман над рекой": "Niebla sobre el río",
  "Полночь в школе": "Medianoche en la escuela",
  "Двое на поляне": "Dos en el claro",
  "Луч пробивается сквозь хвою, и двое замирают посреди лесной поляны": "Un rayo atraviesa los pinos y dos se quedan inmóviles en medio del claro",
  "Глаза цвета янтаря": "Ojos color ámbar",
  "Бал выпускников": "Baile de graduación",
  "Клятва": "El juramento",
  "Игра в грозу": "Partido en la tormenta",
  "Гром над лесной поляной, и каждый удар битой звучит как раскат": "Truenos sobre el claro y cada golpe de bate suena como un estruendo",
  "Отбивающий": "Bateador",
  "Подающая": "Lanzadora",
  "Ловец": "Receptor",
  "К вершине сосны": "A la copa del pino",
  "Он уносит её на спине к вершине сосны, внизу туман и весь лес": "Él la lleva a la espalda hasta la copa de un pino, abajo la niebla y todo el bosque",
  "Примерка брони": "Prueba de la armadura",
  "Броня защёлкивается на вас деталь за деталью, и шлем закрывает лицо": "La armadura se ajusta pieza a pieza y el casco te cubre la cara",
  "Полёт над городом": "Vuelo sobre la ciudad",
  "Разгон над ночным городом, вираж между башнями и посадка на крышу": "Aceleración sobre la ciudad de noche, giro entre torres y aterrizaje en un tejado",
  "Пилот брони": "Piloto de la armadura",
  "Ночь в мастерской": "Noche en el taller",
  "Искры сварки, чертежи прямо в воздухе и первый удачный запуск": "Chispas de soldadura, planos en el aire y el primer arranque con éxito",
  "Изобретатель": "Inventor",
  "Последний заряд": "La última carga",
  "Заряд брони на исходе, команда встаёт спина к спине, и всё решает последний залп": "La armadura está casi sin carga, el equipo se pone espalda con espalda y todo lo decide el último disparo",
  "Герой в броне": "Héroe con armadura",
  "Качели на паутине": "Balanceo en la telaraña",
  "Прыжок с карниза, паутина натягивается, и улица проносится под ногами": "Un salto desde la cornisa, la telaraña se tensa y la calle pasa bajo tus pies",
  "Герой в маске": "Héroe enmascarado",
  "Поцелуй под дождём": "Beso bajo la lluvia",
  "Ночной переулок и ливень: он висит вниз головой, она приподнимает край маски": "Un callejón de noche y lluvia: él cuelga boca abajo, ella levanta el borde de la máscara",
  "Крыша на закате": "Azotea al atardecer",
  "Двое сидят на краю крыши, внизу шумит город, солнце уходит за башни": "Dos se sientan al borde de la azotea, abajo la ciudad bulle y el sol se pone tras las torres",
  "Бой в поезде": "Pelea en el tren",
  "Схватка на крыше несущегося поезда, а потом герой останавливает вагон руками": "Una pelea sobre un tren a toda velocidad y luego el héroe detiene el vagón con las manos",
  "Пассажирка": "Pasajera",
  "Для маркетплейса": "Para marketplaces",
  "Праздники": "Festividades",
  "Поздравления, кружки и посты к праздникам: 1 апреля, Пасха, 8 марта": "Felicitaciones, círculos y publicaciones para las fiestas: 1 de abril, Pascua, 8 de marzo",
  "1 апреля": "1 de abril",
  "Пасха": "Pascua",
  "8 марта": "8 de marzo",
  "Мода": "Moda",
  "Аватарки": "Avatares",
  "Фильмы": "Películas",
  "Игры": "Juegos",
  "Путешествия": "Viajes",
  "Сумерки": "Crepúsculo",
  "Железный человек": "Iron Man",
  "Человек-паук": "Spider-Man",
  "Романтика": "Romance",
  "Погони": "Persecuciones",
  "Всей семьёй": "En familia",
  "Особая подборка": "Colección especial",
  "Особая подборка {0}, {1}": "Colección especial {0}, {1}",
  "Подборка {0}, {1}": "Colección {0}, {1}",
  "{0} в подборке": "{0} en la colección",
  "шаблон|шаблона|шаблонов": "plantilla|plantillas",
  "шаблона|шаблонов|шаблонов": "plantilla|plantillas",
  "сцена|сцены|сцен": "escena|escenas",
  "инструмент|инструмента|инструментов": "herramienta|herramientas",
  "инструмента|инструментов|инструментов": "herramienta|herramientas",
  "стиль|стиля|стилей": "estilo|estilos",
  "кадра|кадров|кадров": "foto|fotos",
  "ребёнок|ребёнка|детей": "niño|niños",
  "питомец|питомца|питомцев": "mascota|mascotas",
  "кружки": "círculos",
  "голос": "voz",
  "текст": "texto",
  "для бизнеса": "negocios",
  "Кружок из видео": "Videomensaje desde un vídeo",
  "Фото в новом стиле": "Foto con nuevo estilo",
  "Фото по описанию": "Foto a partir de una descripción",
  "Семейный портрет": "Retrato familiar",
  "Видео в новом стиле": "Vídeo con nuevo estilo",
  "Видео по описанию": "Vídeo a partir de una descripción",
  "Видео другим голосом": "Vídeo con otra voz",
  "Объёмное фото": "Foto 3D",
  "Анимация из серии": "Animación de una serie",
  "Видео из поездки": "Vídeo de un viaje",
  "Фильм из фотографий": "Película con fotos",
  "Изменить видео": "Editar vídeo",
  "текст или запись": "texto o grabación",
  "видео до 1 минуты": "vídeo de hasta 1 minuto",
  "1 фото и текст": "1 foto y texto",
  "запись или аудиофайл": "grabación o archivo de audio",
  "5 фото лица": "5 fotos de la cara",
  "1 селфи": "1 selfie",
  "описание словами": "una descripción",
  "фото или описание": "foto o descripción",
  "старое фото": "una foto antigua",
  "чёрно-белое фото": "una foto en blanco y negro",
  "фото близких": "fotos de tus seres queridos",
  "от 2 до 9 фото": "de 2 a 9 fotos",
  "тема поста": "tema de la publicación",
  "1 фото или видео": "1 foto o vídeo",
  "ваше фото": "tu foto",
  "фото тех, кто сыграет": "fotos de quienes actúan",
  "1 видео": "1 vídeo",
  "видео и новый текст": "vídeo y texto nuevo",
  "видео с речью": "vídeo con voz",
  "текст поздравления": "texto de felicitación",
  "от 3 фото": "desde 3 fotos",
  "фото из поездки": "fotos del viaje",
  "семейные фото": "fotos familiares",
  "сценарий": "guion",
  "запись голоса": "grabación de voz",
  "песня": "canción",
  "файл или ссылка": "archivo o enlace",
  "название товара": "nombre del producto",
  "от 1 до 5 фото товара": "de 1 a 5 fotos del producto",
  "фото товара": "fotos del producto",
  "1 видео с вами": "1 vídeo contigo",
  "ваше видео": "tu vídeo",
  "картинка": "imagen",
  "идея словами": "una idea en palabras",
  "ваш промпт": "tu prompt",
  "нужно: 1 фото": "1 foto",
  "нужно: Текст": "Texto",
  "нужно: Тема": "Tema",
  "нужно: Запись": "Grabación",
  "формат: Reels": "Reels",
  "формат: фото": "fotos",
  "формат: видео": "vídeos",
  "формат: кружков": "círculos",
  "формат: шаблонов": "plantillas",
  "любое, где хорошо видно лицо": "cualquiera en la que se vea bien la cara",
  "лицо крупно и при хорошем свете": "cara en primer plano y con buena luz",
  "селфи, лицо крупно": "selfie, cara en primer plano",
  "снимок оживёт в ролике": "la foto cobra vida en un vídeo",
  "что скажет герой": "lo que dirá el personaje",
  "или фото, из которых сделаем слайды": "o fotos con las que haremos diapositivas",
  "Сколько стоит одна генерация": "Cuánto cuesta una generación",
  "Фото стоит {0} C, фотосессия {1} C за 3 кадра, видео {2} C за 5 секунд. Помощники для текста, например описание товара, стоят {3} C. Цена всегда видна на кнопке «Создать» до списания.": "Una foto cuesta {0} C, una sesión de fotos {1} C por 3 fotos y un vídeo {2} C por 5 segundos. Los asistentes de texto, como la descripción de un producto, cuestan {3} C. El precio siempre aparece en el botón «Crear» antes del cobro.",
  "Что такое C и как пополнить баланс": "Qué es C y cómo recargar el saldo",
  "C это монеты Circle, ими платят за создание. Пакеты и подписка покупаются на вкладке «Баланс», там же виден остаток.": "C son las monedas Circle con las que pagas por crear. Los paquetes y la suscripción se compran en la pestaña «Saldo», donde también ves lo que te queda.",
  "Какие файлы можно загружать": "Qué archivos puedo subir",
  "Видео до 1 минуты и 15 МБ, фото в JPG или PNG, аудио в MP3, WAV или M4A. Ограничения показываются в самом инструменте.": "Vídeos de hasta 1 minuto y 15 MB, fotos en JPG o PNG, audio en MP3, WAV o M4A. Cada herramienta muestra sus límites.",
  "Как сделать дешевле": "Cómo hacerlo más barato",
  "Если Circle на работу не хватает, кнопка внизу экрана откроет лист «Не хватает Circle»: в нём есть «Сделать дешевле». Скидка {0}%, на результате появится водяной знак.": "Si no tienes suficientes Circle, el botón de abajo abre «No hay suficientes Circle» con la opción «Hacerlo más barato». Tienes un {0}% de descuento y el resultado llevará marca de agua.",
  "Где найти готовые результаты": "Dónde encontrar los resultados",
  "В разделе «История» в меню «Ещё». Там же можно скачать файл повторно или отправить в чат.": "En «Historial», dentro del menú «Más». Allí puedes volver a descargar el archivo o enviarlo al chat.",
  "Можно ли использовать свой голос": "Puedo usar mi propia voz",
  "Да. Клонируйте голос на вкладке «Клон», и он появится в списке голосов во всех инструментах с озвучкой.": "Sí. Clona tu voz en la pestaña «Clon» y aparecerá en la lista de voces de todas las herramientas con voz.",
  "Фотосессия из {0} в стиле шаблона": "Sesión de {0} con el estilo de la plantilla",
  "По желанию: {0}": "Opcional: {0}",
  "Тут откроется шаблон «{0}»": "Aquí se abrirá la plantilla «{0}»",
  "Только до": "Solo antes",
  "Только после": "Solo después",
  "До: {0} %": "Antes: {0} %",
  "подборка": "colección",
  "Все форматы": "Todos los formatos",
  "Состав": "Reparto",
  "Вкладки каталога": "Pestañas del catálogo",
  "Найти подборку": "Buscar colección",
  "Найти шаблон": "Buscar plantilla",
  "Поиск среди {0}": "Buscar entre {0}",
  "По запросу «{0}» подборок нет. Поищите среди всех шаблонов": "No hay colecciones para «{0}». Busca entre todas las plantillas",
  "По запросу «{0}» в подборке «{1}» ничего нет. Поищите во всех шаблонах": "Nada para «{0}» en «{1}». Busca en todas las plantillas",
  "По запросу «{0}» в «Рекомендуем» ничего нет. Поищите во всех шаблонах": "Nada para «{0}» en «Para ti». Busca en todas las plantillas",
  "В подборке «{0}» нет сцен «{1}»": "No hay escenas «{1}» en «{0}»",
  "Посмотрите все сцены подборки": "Mira todas las escenas de la colección",
  "В подборке «{0}» нет {1}": "No hay {1} en «{0}»",
  "Посмотрите во всех форматах": "Mira en todos los formatos",
  "В «Рекомендуем» нет {0}": "No hay {0} en «Para ti»",
  "Пока ничего нет": "Aún no hay nada",
  "Шаблоны этого формата появятся совсем скоро": "Pronto habrá plantillas en este formato",
  "По запросу «{0}» среди {1} ничего нет. Поищите во всех форматах": "No hay {1} para «{0}». Busca en todos los formatos",
  "Искать во всех форматах": "Buscar en todos los formatos",
  "По запросу «{0}» среди шаблонов ничего нет. Попробуйте другое слово": "No hay plantillas para «{0}». Prueba con otra palabra",
  "Загружаем ещё": "Cargando más",
  "Это все шаблоны": "Estas son todas las plantillas",
  "Тренды": "Tendencias",
  "Вкладки страницы": "Pestañas de la página",
  "Найти сцену": "Buscar escena",
  "Найти в подборке": "Buscar en la colección",
  "Искать во всех сценах": "Buscar en todas las escenas",
  "По запросу «{0}» подборок нет. Поищите среди всех сцен": "No hay colecciones para «{0}». Busca entre todas las escenas",
  "По запросу «{0}» в подборке «{1}» ничего нет. Поищите во всех сценах": "Nada para «{0}» en «{1}». Busca en todas las escenas",
  "По запросу «{0}» в «Трендах» ничего нет. Поищите во всех сценах": "Nada para «{0}» en «Tendencias». Busca en todas las escenas",
  "По запросу «{0}» в «Рекомендуем» ничего нет. Поищите во всех сценах": "Nada para «{0}» en «Para ti». Busca en todas las escenas",
  "В «Трендах» нет сцен «{0}»": "No hay escenas «{0}» en «Tendencias»",
  "В «Рекомендуем» нет сцен «{0}»": "No hay escenas «{0}» en «Para ti»",
  "Посмотрите все сцены этой вкладки": "Mira todas las escenas de esta pestaña",
  "В подборке «{0}» ничего по запросу «{1}». Поищите во всех шаблонах": "Nada en «{0}» para «{1}». Busca en todas las plantillas",
  "В этой подборке пока нет таких шаблонов. Посмотрите её целиком или выберите другую вкладку": "Esta colección aún no tiene plantillas así. Mírala entera o elige otra pestaña",
  "Поиск в подборке «{0}»: {1}": "Buscar en «{0}»: {1}",
  "Вкладки подборки": "Pestañas de la colección",
  "Нужно: {0}": "Necesitas: {0}",
  "Нужно": "Necesitas",
  "По запросу «{0}» нет ни инструментов, ни шаблонов. Попробуйте другое слово или посмотрите все инструменты": "No hay herramientas ni plantillas para «{0}». Prueba otra palabra o mira todas las herramientas",
  "По запросу «{0}» в разделе «{1}» ничего нет. Поищите во всех инструментах": "Nada para «{0}» en «{1}». Busca en todas las herramientas",
  "Искать во всех": "Buscar en todo",
  "По запросу «{0}» инструментов нет. Попробуйте другое слово": "No hay herramientas para «{0}». Prueba con otra palabra",
  "Найти инструмент": "Buscar herramienta",
  "Не удалось открыть инструмент. Обновите каталог и попробуйте снова.": "No se pudo abrir la herramienta. Actualiza el catálogo e inténtalo de nuevo.",
  "Не удалось открыть инструмент за 30 секунд. Обновите запрос или вернитесь назад.": "La herramienta no se abrió en 30 segundos. Inténtalo de nuevo o vuelve atrás.",
  "Карточка товара": "Ficha de producto",
  "Рилс готов": "Reel listo",
  "Кавер не создан": "Cover no creado",
  "Фотосессия не создана": "Sesión de fotos no creada",
  "Рилс не создан": "Reel no creado",
  "Карточка не создана": "Ficha no creada",
  "Слайды не созданы": "Diapositivas no creadas",
  "Запись не обработана": "Grabación no procesada",
  "Коллаж не создан": "Collage no creado",
  "· остаток {0} C": "· quedan {0} C",
  "Вернули {0} C": "Devolvimos {0} C",
  "Списано {0} C со скидкой, {1} водяной знак": "Se cobraron {0} C con descuento, {1} marca de agua",
  "Списано {0} C": "Se cobraron {0} C",
  "Рисованному стилю камера не нужна": "Un estilo dibujado no necesita cámara",
  "У этой камеры объектив встроенный": "Esta cámara tiene objetivo integrado",
  "У этой камеры резкость не настраивается": "Esta cámara no permite ajustar el enfoque",
  "У этого объектива диафрагма постоянная": "Este objetivo tiene apertura fija",
  "Встроенный": "Integrado",
  "Как у камеры": "Como la cámara",
  "до {0} МБ": "hasta {0} MB",
  "По запросу {0} нет ни инструментов, ни шаблонов. Попробуйте другое слово или посмотрите все инструменты": "No hay herramientas ni plantillas para {0}. Prueba otra palabra o mira todas las herramientas",
  "По запросу {0} в разделе {1} ничего нет. Поищите во всех инструментах": "Nada para {0} en {1}. Busca en todas las herramientas",
  "По запросу {0} инструментов нет. Попробуйте другое слово": "No hay herramientas para {0}. Prueba con otra palabra",
  "в «Трендах»": "en «Tendencias»",
  "в «Рекомендуем»": "en «Para ti»",
  "в подборке {0}": "en {0}",
  "По запросу {0} {1} ничего нет. Поищите во всех сценах": "Nada para {0} {1}. Busca en todas las escenas",
  "В подборке {0} ничего по запросу {1}. Поищите во всех шаблонах": "Nada en {0} para {1}. Busca en todas las plantillas",
  "сцен {0}": "escenas {0}",
  "В подборке {0} нет {1}": "No hay {1} en {0}",
  "В подборке {0} нет таких шаблонов": "{0} no tiene plantillas así",
  "Посмотрите её целиком или выберите другую вкладку": "Mírala entera o elige otra pestaña",
  "По запросу {0} в этом формате ничего нет. Поищите во всех форматах": "Nada para {0} en este formato. Busca en todos los formatos",
  "По запросу {0} среди шаблонов ничего нет. Попробуйте другое слово": "No hay plantillas para {0}. Prueba con otra palabra",
  "Здесь нет шаблонов": "Aquí no hay plantillas",
  "Заказ принят": "Pedido recibido",
  "Бот пришлёт результат в чат, в отдельную тему.": "El bot enviará el resultado al chat, en un tema aparte.",
  "Измените запрос и попробуйте снова. Circle за проверенный заказ не возвращаются.": "Cambia la solicitud e inténtalo de nuevo. Los Circle de un pedido revisado no se devuelven.",
  "Сбой на нашей стороне. Circle вернулись на баланс.": "Hubo un fallo por nuestra parte. Los Circle han vuelto a tu saldo.",
  "Инструмент ещё подключается: заказ стоит в очереди и начнётся сам, бот пришлёт результат в чат.": "La herramienta aún se está conectando: el pedido está en cola y empezará solo; el bot enviará el resultado al chat.",
  "Сначала отметьте согласие ниже": "Primero marca el consentimiento abajo",
  "Главное фото: {0}": "Foto principal: {0}",
  "Загружаем превью…": "Cargando vista previa…",
  "Фото не подошло": "La foto no sirve",
  "Проверить загрузку": "Comprobar la subida",
  "Опишите, что хотите увидеть": "Describe lo que quieres ver",
  "Не помещается: до {0} знаков": "No cabe: hasta {0} caracteres",
  "{0} во весь экран": "{0} a pantalla completa",
  "Загрузить картинку": "Subir imagen",
  "Ваша": "Tuya",
  "Убрать картинку": "Quitar imagen",
  "Этот инструмент пока недоступен": "Esta herramienta aún no está disponible",
  "Выберите другой инструмент или вернитесь к шаблонам.": "Elige otra herramienta o vuelve a las plantillas.",
  "Вернуться": "Volver",
  "Образ": "Look",
  "Ваши селфи": "Tus selfies",
  "Три разных кадра: лицо крупно, при хорошем свете": "Tres fotos distintas: cara en primer plano, con buena luz",
  "Подтверждаю согласие людей на фото": "Confirmo el consentimiento de las personas de las fotos",
  "От одного до пяти ракурсов, первый — главный": "De uno a cinco ángulos, el primero es el principal",
  "Категория": "Categoría",
  "Набор сцен": "Set de escenas",
  "Загрузите фото: нужно {0}": "Sube fotos: se necesitan {0}",
  "Выберите: {0}": "Elige: {0}",
  "Не удалось загрузить экран.": "No se pudo cargar la pantalla.",
  "Сцен: {0}": "Escenas: {0}",
  "Заказ создан, следите за ним в «Истории».": "Pedido creado, síguelo en «Historial».",
  "Старые": "Más antiguas",
  "Длинные": "Más largos",
  "Стиль уже задаёт свет и цвет. Выберите другой, если хотите поменять": "El estilo ya define la luz y el color. Elige otro si quieres cambiarlos",
  "{0} открывается только до f/{1}": "{0} solo abre hasta f/{1}",
  "Объектив не задаёт светосилу": "El objetivo no define la luminosidad",
  "Этот объектив открывается только до f/{0}": "Este objetivo solo abre hasta f/{0}",
  "Назад к настройкам": "Volver a los ajustes",
  "Группа": "Grupo",
  "Нашли {0}": "Encontrados: {0}",
  "Ничего не нашлось. Попробуйте другое слово или сбросьте группу.": "No se encontró nada. Prueba otra palabra o quita el grupo.",
  "Выбор сразу вернёт к настройкам. Цена не меняется": "Al elegir vuelves a los ajustes. El precio no cambia",
  "Сравнить: было и стало": "Comparar: antes y después",
  "Берём стиль: цвет, свет, обработку. Саму картинку и лица с неё не переносим": "Tomamos el estilo: color, luz y edición. No copiamos la imagen ni las caras",
  "Берём сцену: фон, свет и подачу. Саму картинку и лица с неё не переносим": "Tomamos la escena: fondo, luz y puesta en escena. No copiamos la imagen ni las caras",
  "Берём образ: одежду, позу, фон и свет. В кадре будете вы, лица с картинки не переносим": "Tomamos el look: ropa, pose, fondo y luz. En la foto saldrás tú, no copiamos las caras",
  "Картинка не подошла: не открывается, попробуйте JPG или PNG": "La imagen no sirve: no se abre, prueba con JPG o PNG",
  "Картинка не подошла: больше {0} МБ": "La imagen no sirve: pesa más de {0} MB",
  "Картинка не подошла: слишком маленькая, нужна от {0} px": "La imagen no sirve: demasiado pequeña, mínimo {0} px",
  "Картинка не подошла: на ней защищённое или запрещённое содержимое": "La imagen no sirve: tiene contenido protegido o prohibido",
  "Загрузить картинку-референс": "Subir imagen de referencia",
  "Озвучка текста": "Texto a voz",
  "Запишите от 2 секунд речи, и бот заговорит вашим голосом": "Graba 2 segundos de voz y el bot hablará con tu voz",
  "Готовые голоса стоят на вкладке «Мои» в разделе «Озвучка»": "Las voces listas están en la pestaña «Mías» de Voces",
  "Под этим именем голос стоит в вашем списке. Описание видите только вы": "Con este nombre aparecerá la voz en tu lista. Solo tú ves la descripción",
  "Голос появится на вкладке «Мои»": "La voz aparecerá en la pestaña «Mías»",
  "Имя в списке голосов": "Nombre en la lista de voces",
  "Уже в «Озвучке»": "Ya está en Voces",
  "Голос стоит на вкладке «Мои» с меткой «Мой голос»": "La voz está en la pestaña «Mías» con la etiqueta «Mía»",
  "Карточка голоса": "Ficha de la voz",
  "Нажмите на голос в списке, чтобы переименовать или удалить": "Toca una voz de la lista para renombrarla o eliminarla",
  "Так голос выглядит в списке": "Así se verá la voz en la lista",
  "Голос уже стоит на вкладке «Мои». Послушайте, как он звучит": "La voz ya está en la pestaña «Mías». Escucha cómo suena",
  "Идёт проверка и обучение, обычно 1–3 минуты. Голос появится на вкладке «Мои» сам": "Verificación y entrenamiento en curso, suele tardar 1–3 minutos. La voz aparecerá sola en la pestaña «Mías»",
  "Голос пропадёт с вкладки «Мои». Вернуть его не получится.": "La voz desaparecerá de la pestaña «Mías». No se podrá recuperar.",
  "Обычно 1–3 минуты. Можно закрыть приложение, голос появится в списке": "Suele tardar 1–3 minutos. Puedes cerrar la app: la voz aparecerá en la lista",
  "Можно закрыть приложение": "Puedes cerrar la app",
  "Запишите речь или загрузите файлы: от 0:02 до 1:30. Подойдут MP3, WAV, M4A, OGG и WEBM, до 10 файлов по 20 МБ": "Graba tu voz o sube archivos: de 0:02 a 1:30 en total. MP3, WAV, M4A, OGG y WEBM, hasta 10 archivos de 20 MB",
  "Создано {n} клонов из {n}. Удалите один, чтобы добавить новый": "Creados {n} de {n} clones. Elimina uno para añadir otro",
  "Без подписки можно создать {n} клона. С подпиской их будет {0}": "Sin suscripción puedes crear {n} clones. Con ella, hasta {0}",
  "До {0} клонов": "Hasta {0} clones",
  "Три клона бесплатно": "Tres clones gratis",
  "Запишите ещё один, другим тоном или настроением": "Graba otra con otro tono o estado de ánimo",
  "С подпиской можно создать до {0}": "Con suscripción puedes crear hasta {0}",
  "Привет! Это запись для моего голоса. Я говорю спокойно и в обычном темпе, как в разговоре с другом. Чем естественнее получится сейчас, тем точнее будет звучать клон.": "¡Hola! Esta es una grabación para mi voz. Hablo con calma y a ritmo normal, como si charlara con un amigo. Cuanto más natural suene ahora, más fiel será el clon.",
  "Знаете, что самое странное в готовке по видео? Смотришь, как человек за минуту режет лук, и думаешь: это же просто. А потом лук почему-то везде, кроме сковородки.": "¿Sabes qué es lo más raro de cocinar con vídeos? Ves a alguien picar una cebolla en un minuto y piensas: qué fácil. Y luego la cebolla acaba en todas partes menos en la sartén.",
  "Вчера наконец разобрал коробки после переезда. Нашёл старый плеер, три зарядки от телефонов, которых уже нет, и тетрадь с планами на лето. Плеер до сих пор работает.": "Ayer por fin deshice las cajas de la mudanza. Encontré un reproductor viejo, tres cargadores de móviles que ya no tengo y una libreta con planes para el verano. El reproductor todavía funciona.",
  "Погода сегодня странная: утром светило солнце, к обеду пошёл дождь, а к вечеру обещают снег. Самое время заварить что-нибудь горячее и никуда не торопиться.": "Hoy el tiempo está raro: por la mañana hacía sol, al mediodía empezó a llover y para la noche anuncian nieve. El momento perfecto para prepararse algo caliente y no tener prisa.",
  "Раз, два, три, проверка. Меня хорошо слышно? Сейчас я прочитаю несколько фраз разным тоном: сначала спокойно, потом чуть громче, а в конце совсем тихо, почти шёпотом.": "Uno, dos, tres, probando. ¿Se me oye bien? Ahora leeré unas frases con distinto tono: primero con calma, luego un poco más alto y al final muy bajito, casi en un susurro.",
  "Мой кот считает, что клавиатура создана для сна, а монитор нужен, чтобы закрывать его хвостом. Поэтому если в записи что-то зашуршит, знайте: это была командная работа.": "Mi gato cree que el teclado está hecho para dormir y que el monitor sirve para taparlo con la cola. Así que si en la grabación se oye algún roce, que sepas que fue trabajo en equipo.",
  "Есть простое правило: если что-то не получается с третьей попытки, надо встать, налить чаю и вернуться через пять минут. Обычно после этого всё получается само.": "Hay una regla sencilla: si algo no sale al tercer intento, levántate, sírvete un té y vuelve en cinco minutos. Normalmente después todo sale solo.",
  "Тихо, слышите? Где-то рядом шаги. Сейчас аккуратно выглянем за угол, и если там никого нет, перебежим к двери. Только не шумите, пожалуйста, я серьёзно.": "Silencio, ¿lo oyes? Hay pasos cerca. Ahora asomémonos con cuidado a la esquina y, si no hay nadie, corremos hasta la puerta. Pero no hagas ruido, por favor, lo digo en serio.",
  "Проверено": "Verificada",
  "Создание новых голосов пока недоступно": "Aún no se pueden crear voces nuevas",
  "От 2 секунд речи: запись в браузере или готовые файлы": "2 segundos de voz: graba aquí o sube archivos",
  "Внутренняя ошибка, попробуйте позже": "Error interno, inténtalo más tarde",
  "образцов: {n}": "muestras: {n}",
  "Образец короче 2 секунд": "La muestra dura menos de 2 segundos",
  "Образец длиннее 1,5 минуты": "La muestra dura más de 1,5 minutos",
  "Слишком шумная запись — попробуйте в тихом месте": "La grabación tiene mucho ruido: prueba en un lugar tranquilo",
  "В записи слышно несколько голосов": "Se oyen varias voces en la grabación",
  "Проверка не пройдена: голос не совпадает с образцами": "Verificación fallida: la voz no coincide con las muestras",
  "Голос не прошёл правила площадки": "La voz no cumple las normas de la plataforma",
  "Проверка не пройдена: запишите образец без музыки и других людей": "Verificación fallida: graba una muestra sin música ni otras personas",
  "Нужно от 2 секунд до 1,5 минуты речи в сумме": "Se necesitan de 2 segundos a 1,5 minutos de voz en total",
  "Результат обработки уточняется, загляните чуть позже": "Se está confirmando el resultado, vuelve un poco más tarde",
  "Удалить голос «{n}»?": "¿Eliminar la voz «{n}»?",
  "Навсегда, вместе с образцами": "Para siempre, con sus muestras",
  "Например, спокойный, низкий": "Por ejemplo, tranquila, grave",
  "Образец": "Muestra",
  "Запись или файлы, от 2 секунд": "Grabación o archivos, desde 2 s",
  "Имя, описание и согласие": "Nombre, descripción y consentimiento",
  "Проверка и обучение": "Verificación y entrenamiento",
  "Модель STEOS · 1–3 минуты": "Modelo STEOS · 1–3 min",
  "Тихое место без эха": "Un lugar tranquilo y sin eco",
  "Фоновый шум и музыка попадут в голос": "El ruido de fondo y la música pasarán a la voz",
  "Хороший микрофон": "Un buen micrófono",
  "Гарнитура или настольный микрофон лучше встроенного": "Unos auriculares con micro o uno de mesa son mejores que el integrado",
  "То же оборудование": "El mismo equipo",
  "Не меняйте микрофон между записями": "No cambies de micrófono entre grabaciones",
  "Под ним голос стоит в списке выбора": "Con él aparece la voz en la lista",
  "Шумоподавление": "Reducción de ruido",
  "Включайте, только если в записи слышен шум": "Actívalo solo si se oye ruido en la grabación",
  "Согласие обязательно": "El consentimiento es obligatorio",
  "Клонировать можно свой голос или с согласия владельца": "Puedes clonar tu propia voz o una con el consentimiento de su dueño",
  "Проверка образца": "Verificación de la muestra",
  "Один говорящий, без музыки и шума": "Una sola persona, sin música ni ruido",
  "Обучение": "Entrenamiento",
  "Модель STEOS, обычно 1–3 минуты": "Modelo STEOS, suele tardar 1–3 minutos",
  "Голос появится в списке сам": "La voz aparecerá sola en la lista",
  "Проверьте запись": "Revisa la grabación",
  "Один голос, без музыки и шума на фоне": "Una sola voz, sin música ni ruido de fondo",
  "Длина образца": "Duración de la muestra",
  "Нужно не меньше 2 секунд чистой речи": "Se necesitan al menos 2 segundos de voz limpia",
  "Образцы сохранены": "Muestras guardadas",
  "Можно попробовать снова с теми же файлами": "Puedes volver a intentarlo con los mismos archivos",
  "Не получилось — попробуйте снова": "No ha funcionado, inténtalo de nuevo",
  "Шаг {a} из {b}": "Paso {a} de {b}",
  "Персональный": "Personal",
  "Дальше": "Siguiente",
  "Продолжить": "Continuar",
  "К списку голосов": "A la lista de voces",
  "Результат уточняется": "Confirmando",
  "Попробовать снова": "Reintentar",
  "Голос готов": "La voz está lista",
  "Опишите голос": "Describe la voz",
  "Например, Мой голос": "Por ejemplo, Mi voz",
  "Это мой голос или у меня есть согласие его владельца. Я не буду использовать клон для обмана, оскорблений и запрещённого контента": "Es mi voz o tengo el consentimiento de su dueño. No usaré el clon para engañar, insultar ni crear contenido prohibido",
  "Загружаем {a} из {b}": "Subiendo {a} de {b}",
  "Обрабатываем голос": "Procesando la voz",
  "Не получилось создать голос": "No se pudo crear la voz",
  "Результат обработки ещё уточняется. Повтор пока недоступен.": "El resultado aún se está confirmando. Todavía no se puede reintentar.",
  "Образцы сохранены — можно попробовать снова с теми же файлами": "Las muestras están guardadas: puedes reintentarlo con los mismos archivos",
  "Загруженные файлы": "Archivos subidos",
  "Читаем аудио…": "Leyendo el audio…",
  "Записать ещё": "Grabar más",
  "Ждём разрешение…": "Esperando permiso…",
  "Разрешите доступ в настройках браузера или загрузите файл": "Permite el acceso en los ajustes del navegador o sube un archivo",
  "Другой текст": "Otro texto",
  "Прочитайте вслух": "Lee en voz alta",
  "Микрофон по умолчанию": "Micrófono predeterminado",
  "Минимум": "Mínimo",
  "Хорошо": "Bien",
  "Отлично": "Excelente",
  "Набрано {a} из {b}": "{a} de {b} acumulados",
  "из {t}": "de {t}",
  "всё готово": "todo listo",
  "Файлов с ошибкой: {n}": "Archivos con error: {n}",
  "до «{n}» ещё {t}": "faltan {t} para «{n}»",
  "Ещё {t} до минимума": "Faltan {t} para el mínimo",
  "Нужно не меньше 2 секунд": "Se necesitan al menos 2 segundos",
  "Загрузка образцов": "Subida de muestras",
  "Образцы приняты сервером": "El servidor ha recibido las muestras",
  "Проверка голоса": "Verificación de la voz",
  "Пройдена": "Superada",
  "Не запрашивалась": "No solicitada",
  "Результат проверки пока недоступен": "El resultado de la verificación aún no está disponible",
  "Обработка голоса": "Procesamiento de la voz",
  "Не удалось обработать": "No se pudo procesar",
  "Выполняется на сервере": "En curso en el servidor",
  "Очистка шума": "Limpieza de ruido",
  "Пропущено": "Omitido",
  "Модель STEOS · один говорящий, без музыки": "Modelo STEOS · una persona, sin música",
  "Обучение голоса": "Entrenamiento de la voz",
  "Файл больше 20 МБ": "El archivo supera los 20 MB",
  "Запись {n}": "Grabación {n}",
  "Не удалось прочитать аудио": "No se pudo leer el audio",
  "Неподдерживаемый формат": "Formato no compatible",
  "Результат прошлого создания ещё уточняется. Вернитесь к прежнему запросу, чтобы не создать второй клон.": "El resultado de la creación anterior aún se está confirmando. Vuelve a esa solicitud para no crear un segundo clon.",
  "Проверить прошлое создание": "Comprobar la anterior",
  "Остановить": "Detener",
  "Ждём доступ": "Esperando acceso",
  "Ещё раз": "Otra vez",
  "Начать запись": "Empezar a grabar",
  "Нажмите на голос в списке, чтобы открыть его карточку: прослушать, переименовать или удалить.": "Toca una voz de la lista para abrir su ficha: escucharla, renombrarla o eliminarla.",
  "Озвучек": "Locuciones",
  "Знаков": "Caracteres",
  "Образцов": "Muestras",
  "Доступна": "Disponible",
  "Недоступна": "No disponible",
  "После обучения": "Tras el entrenamiento",
  "Голос обучен на ваших записях: образцов {n}, всего {d}": "Entrenada con tus grabaciones: {n} muestras, {d} en total",
  "Происхождение: ваши записи. Подробнее": "Origen: tus grabaciones. Más información",
  "Происхождение": "Origen",
  "Ваши записи": "Tus grabaciones",
  "Проверка": "Verificación",
  "Не пройдена": "No superada",
  "Идёт": "En curso",
  "Переозвучка аудио": "Nueva voz para audio",
  "Создан": "Creada",
  "Доступ": "Acceso",
  "Только вы": "Solo tú",
  "Голос пока недоступен для выбора. Обновите список.": "Aún no se puede elegir esta voz. Actualiza la lista.",
  "Голос ещё учится, обычно 1–3 минуты": "La voz aún se está entrenando, suele tardar 1–3 minutos",
  "Коротко о голосе": "En pocas palabras",
  "О голосе": "Sobre la voz",
  "Голос не создан": "La voz no se ha creado",
  "Обработка дольше обычного": "Está tardando más de lo normal",
  "Сервер ещё обрабатывает голос. Можно закрыть приложение и вернуться позже.": "El servidor sigue procesando la voz. Puedes cerrar la app y volver más tarde.",
  "Аватар {n} останется без голоса, в кружках зазвучит голос по умолчанию.": "El avatar {n} se quedará sin voz y en los círculos sonará la voz predeterminada.",
  "Аватары {n} останутся без голоса, в кружках зазвучит голос по умолчанию.": "Los avatares {n} se quedarán sin voz y en los círculos sonará la voz predeterminada.",
  "Записать первый голос": "Graba tu primera voz",
  "клон|клона|клонов": "clon|clones",
  "в месяц": "al mes",
  "{n} C в месяц": "{n} C al mes",
  "{n} своих голосов": "{n} voces propias",
  "Оформить": "Suscribirse",
  "Подписка активна": "Suscripción activa",
  "Подписка «{n}»": "Suscripción «{n}»",
  "{n} голосов ваши": "{n} voces son tuyas",
  "Доступно — своих голосов": "Voces propias disponibles",
  "{n} голосов мало?": "¿{n} voces no bastan?",
  "Возьмите {n}": "Consigue {n}",
  "Нужно больше голосов?": "¿Necesitas más voces?",
  "До {n} с подпиской": "Hasta {n} con suscripción",
  "Посмотрите доступные подписки": "Mira las suscripciones disponibles",
  "Занято {a} из {b}. Записывайте голоса под разные задачи и настроения": "{a} de {b} en uso. Graba voces para distintas tareas y estados de ánimo",
  "Без подписки можно создать {a} {w}. С любой подпиской их будет {b}": "Sin suscripción puedes crear {a} {w}. Con cualquier suscripción, hasta {b}",
  "Без подписки: {n}. Лимит зависит от выбранной подписки.": "Sin suscripción: {n}. El límite depende de la suscripción.",
  "Занято {a} из {b}": "{a} de {b} en uso",
  "Без подписки · {n}": "Sin suscripción · {n}",
  "С подпиской · {n}": "Con suscripción · {n}",
  "Смотреть все подписки": "Ver todas las suscripciones",
  "Повторить сохранение": "Volver a guardar",
  "Сохраняем изменения…": "Guardando cambios…",
  "Управление голосами временно недоступно": "La gestión de voces no está disponible temporalmente",
  "клон: Мой голос": "Mi voz",
  "Свои голоса временно недоступны. Попробуйте обновить список позже.": "Las voces propias no están disponibles temporalmente. Actualiza la lista más tarde.",
  "Сервис голосов временно недоступен. Попробуйте ещё раз позже.": "El servicio de voces no está disponible temporalmente. Inténtalo más tarde.",
  "Не удалось подтвердить лимит голосов. Обновите список позже.": "No se pudo confirmar el límite de voces. Actualiza la lista más tarde.",
  "Не удалось подтвердить аккаунт. Попробуйте ещё раз позже.": "No se pudo verificar la cuenta. Inténtalo más tarde.",
  "Имя голоса должно содержать от 2 до 32 символов.": "El nombre de la voz debe tener entre 2 y 32 caracteres.",
  "Описание должно содержать не больше 120 символов.": "La descripción no puede superar los 120 caracteres.",
  "Добавьте от 1 до 10 подходящих образцов.": "Añade de 1 a 10 muestras adecuadas.",
  "Превью этого голоса пока недоступно.": "La vista previa de esta voz aún no está disponible.",
  "Не удалось загрузить превью. Попробуйте позже.": "No se pudo cargar la vista previa. Inténtalo más tarde.",
  "Слишком шумная запись. Попробуйте записать голос в тихом месте.": "La grabación tiene mucho ruido. Prueba a grabar en un lugar tranquilo.",
  "В записи слышно несколько голосов. Добавьте речь одного человека.": "Se oyen varias voces. Añade la voz de una sola persona.",
  "Голос не прошёл правила площадки.": "La voz no cumple las normas de la plataforma.",
  "Сервис не смог обработать голос. Проверьте статус перед повтором.": "El servicio no pudo procesar la voz. Revisa el estado antes de reintentar.",
  "Согласие изменилось или недоступно. Обновите список и подтвердите актуальную версию перед повтором.": "El consentimiento ha cambiado o no está disponible. Actualiza la lista y confirma la versión actual antes de reintentar.",
  "Загрузка отклонена. Нажмите кнопку ещё раз, чтобы загрузить образец заново.": "Carga rechazada. Pulsa el botón otra vez para volver a subir la muestra.",
  "Загрузка ещё не подтверждена. Нажмите кнопку ещё раз: сначала проверим прежнюю загрузку.": "La carga aún no está confirmada. Pulsa el botón otra vez: primero comprobaremos la carga anterior.",
  "Выберите аудиофайл MP3, WAV, M4A, OGG или WebM.": "Elige un archivo de audio MP3, WAV, M4A, OGG o WebM.",
  "Не удалось прочитать аудио. Попробуйте ещё раз или загрузите файл.": "No se pudo leer el audio. Inténtalo de nuevo o sube un archivo.",
  "Пример звучания": "Muestra de audio",
  "Пример звучания пока недоступен": "La muestra de audio aún no está disponible",
  "Превью голоса": "Vista previa",
  "Прослушать пример": "Escuchar muestra",
  "Скидка {0}% на первый пакет Circle действует {1} {2} после оформления подписки": "{0}% de descuento en el primer paquete de Circle, válido {1} {2} después de suscribirte",
  "Вы уже пришли по ссылке партнёра": "Ya llegaste por el enlace de un socio",
  "Промокод партнёра уже применён": "Ya se aplicó un código de socio",
  "Тут откроется тема чата, куда бот прислал {0}": "Aquí se abrirá el tema del chat con tu resultado: {0}",
  "можно вывести": "retirable",
  "только в STEOS": "solo en STEOS",
  "Не короче {0} знаков": "Mínimo {0} caracteres",
  "Введите почту и пароль": "Introduce el correo y la contraseña",
  "от {0} знаков": "mín. {0} caracteres",
  "После входа Circle станут общими для бота и аккаунта STEOS. Баланс и вывод есть и на {0}.": "Al iniciar sesión, tus Circle serán comunes para el bot y tu cuenta STEOS. El saldo y los retiros también están en {0}.",
  "Вход или новый аккаунт": "Iniciar sesión o cuenta nueva",
  "Придумайте пароль": "Crea una contraseña",
  "Ваш пароль": "Tu contraseña",
  "Принимаю {0} и {1} STEOS": "Acepto las {0} y la {1} de STEOS",
  "согласие: условия": "condiciones",
  "согласие: политику конфиденциальности": "política de privacidad",
  "Пришлём ссылку на почту": "Te enviaremos un enlace por correo",
  "Откройте ссылку из письма и задайте новый пароль на {0}. Потом войдите здесь с новым паролем.": "Abre el enlace del correo y crea una contraseña nueva en {0}. Después inicia sesión aquí con ella.",
  "Ссылка для нового пароля ушла на {0}": "Enviamos el enlace para la nueva contraseña a {0}",
  "Письма нет? Проверьте папку «Спам».": "¿No llega? Revisa la carpeta de spam.",
  "Аккаунт создан и подключён": "Cuenta creada y conectada",
  "Баланс бота теперь общий с аккаунтом STEOS.": "El saldo del bot ahora se comparte con tu cuenta STEOS.",
  "Подтвердите почту по ссылке из письма.": "Confirma tu correo con el enlace del mensaje.",
  "Вывод работает здесь и на {0}.": "Los retiros funcionan aquí y en {0}.",
  "Открыть {0}": "Abrir {0}",
  "Ссылка ушла на {0}. Откройте её, затем проверьте подключение здесь.": "Enviamos un enlace a {0}. Ábrelo y luego comprueba la conexión aquí.",
  "Проверить подключение": "Comprobar conexión",
  "Почти готово": "Casi listo",
  "Почта ещё не подтверждена": "El correo aún no está confirmado",
  "Не удалось проверить. Попробуйте позже": "No se pudo comprobar. Inténtalo más tarde",
  "Озвучиваю тексты голосом героя": "Textos con la voz de un héroe",
  "Любой голос из библиотеки или свой": "Cualquier voz de la biblioteca o la tuya",
  "Озвучиваю тексты голосами героев в STEOS. Попробуйте по моей ссылке, промокод {0}": "Pongo voces de héroes a textos en STEOS. Pruébalo con mi enlace, código promocional {0}",
  "Пишу текст, персонаж говорит": "Escribo y el personaje habla",
  "Делаю кружки с персонажами в STEOS: пишу текст, а персонаж его говорит. Промокод {0}": "Hago videos circulares con personajes en STEOS: escribo el texto y el personaje lo dice. Código promocional {0}",
  "Свои фото в любом образе": "Tus fotos con cualquier estilo",
  "Фотосессия в любом образе по паре моих фото, без студии. STEOS, промокод {0}": "Una sesión de fotos con cualquier estilo a partir de un par de fotos mías, sin estudio. STEOS, código promocional {0}",
  "Вы в кадре, монтаж и музыка сами": "Tú en pantalla, montaje y música automáticos",
  "Снимаюсь в рилсах одной кнопкой в STEOS: сюжет, монтаж и музыка уже в шаблоне. Промокод {0}": "Salgo en reels con un toque en STEOS: la historia, el montaje y la música ya están en la plantilla. Código promocional {0}",
  "Персонаж оживает": "El personaje cobra vida",
  "Говорит вашим текстом": "Dice tu texto",
  "Персонаж говорит моим текстом и своим голосом. Попробуйте STEOS, промокод {0}": "El personaje dice mi texto con su propia voz. Prueba STEOS, código promocional {0}",
  "Клон голоса за минуту": "Clon de voz en un minuto",
  "Запишите от 2 секунд, дальше говорит клон": "Graba 2 segundos y luego habla el clon",
  "Клон моего голоса за минуту в STEOS: теперь он озвучивает всё сам. Промокод {0}": "Un clon de mi voz en un minuto con STEOS: ahora lo narra todo por mí. Código promocional {0}",
  "Старому фото цвет и резкость": "Color y nitidez para fotos antiguas",
  "Восстановление за минуту": "Restauración en un minuto",
  "Возвращаю старым фото цвет и резкость в STEOS. Промокод {0}": "Devuelvo el color y la nitidez a fotos antiguas con STEOS. Código promocional {0}",
  "По ссылке или промокоду": "Con enlace o código promocional",
  "Дарю +{0} C и скидку {1}% на первый пакет в STEOS по моему промокоду {2}": "Te regalo +{0} C y un {1}% de descuento en el primer paquete de STEOS con mi código promocional {2}",
  "Кавер на любую песню": "Un cover de cualquier canción",
  "Рок, джаз, lo-fi любым голосом": "Rock, jazz, lo-fi con cualquier voz",
  "Кавер на любую песню любым голосом в STEOS. Промокод {0}": "Un cover de cualquier canción con cualquier voz en STEOS. Código promocional {0}",
  "Мой аватар в любом образе": "Mi avatar con cualquier estilo",
  "Свой аватар из 10 фото": "Tu avatar a partir de 10 fotos",
  "Мой аватар в любом образе: собран из 10 фото в STEOS. Промокод {0}": "Mi avatar con cualquier estilo, creado con 10 fotos en STEOS. Código promocional {0}",
  "Это я, только говорю вашим текстом": "Soy yo, pero diciendo tu texto",
  "сторис: Мой голос": "Mi voz",
  "на баланс сразу": "al saldo al instante",
  "на первый пакет Circle": "en el primer paquete de Circle",
  "Сторис открыта в Telegram": "Historia abierta en Telegram",
  "Сторис готова": "Historia lista",
  "Осталось нажать «Опубликовать» в редакторе Telegram": "Solo queda publicarla en el editor de Telegram",
  "Тут откроется редактор сторис Telegram с этой картинкой и подписью": "Aquí se abrirá el editor de historias de Telegram con esta imagen y texto",
  "Подпись к сторис": "Texto de la historia",
  "Кнопка-ссылка на сторис в Telegram есть только с Premium. Промокод на картинке видят все.": "El botón con enlace en las historias de Telegram solo existe con Premium. El código promocional de la imagen lo ve todo el mundo.",
  "Опубликовать в сторис": "Publicar en historias",
  "Попробовать STEOS": "Probar STEOS",
  "Не удалось подготовить сторис. Попробуйте ещё раз": "No se pudo preparar la historia. Inténtalo de nuevo",
  "Сторис отправляет Telegram: откройте мини-приложение в Telegram": "Las historias las publica Telegram: abre la Mini App en Telegram",
  "Ссылка и промокод уже на картинке": "El enlace y el código ya están en la imagen",
  "Попробуйте STEOS по моей ссылке. Промокод {0}": "Prueba STEOS con mi enlace. Código promocional {0}",
  "Попробуйте STEOS по моей ссылке: +{0} C и скидка {1}% на первый пакет. Промокод {2}": "Prueba STEOS con mi enlace: +{0} C y un {1}% de descuento en el primer paquete. Código promocional {2}",
  "Ссылка": "Enlace",
  "Скопировать ссылку": "Copiar enlace",
  "Друзьям {0} и {1} на первый пакет": "Tus amigos reciben {0} y {1} en el primer paquete",
  "Промокод выделен: скопируйте вручную": "Código seleccionado: cópialo a mano",
  "Ссылка выделена: скопируйте вручную": "Enlace seleccionado: cópialo a mano",
  "Ссылка скопирована": "Enlace copiado",
  "Ссылка выделена: скопируйте её вручную": "Enlace seleccionado: cópialo a mano",
  "Ссылка выделена": "Enlace seleccionado",
  "Вы пришли по приглашению": "Te han invitado",
  "{0} C на баланс": "{0} C a tu saldo",
  "Сгорят через {0} {1}": "Caducan en {0} {1}",
  "{0} на первый пакет Circle": "{0} en el primer paquete de Circle",
  "{0} {1} после оформления подписки": "{0} {1} después de suscribirte",
  "Пакеты Circle можно купить с любой подпиской. Скидка начнёт действовать, как только вы её оформите.": "Los paquetes de Circle se compran con cualquier suscripción. El descuento empieza en cuanto te suscribas.",
  "Выбрать тариф": "Elegir plan",
  "QR-код ссылки приглашения, промокод {0}": "Código QR del enlace de invitación, código promocional {0}",
  "Друг наведёт камеру и откроет бота": "Tu amigo apunta la cámara y abre el bot",
  "Цвет карточки": "Color de la tarjeta",
  "Скачать картинку": "Descargar imagen",
  "Аврора": "Aurora",
  "Закат": "Atardecer",
  "Океан": "Océano",
  "Графит": "Grafito",
  "Партнёры": "Socios",
  "Нашёл бота, где любой персонаж скажет в кружке твой текст. Там же фото, видео и озвучка любым голосом, всё прямо в Telegram.": "Encontré un bot donde cualquier personaje dice tu texto en un videomensaje. También hace fotos, vídeos y locuciones con cualquier voz, todo dentro de Telegram.",
  "Делюсь находкой: STEOS, бот в Telegram, где я делаю кружки с персонажами, озвучку и фото. Пишете текст, выбираете голос, и через минуту готово.": "Comparto un hallazgo: STEOS, un bot de Telegram donde hago videomensajes con personajes, locuciones y fotos. Escribes un texto, eliges una voz y en un minuto está listo.",
  "Восстанавливаю наши старые семейные фото в STEOS: за минуту возвращает цвет и резкость. Пришлите мне снимки, которые хотите обновить, или попробуйте сами.": "Estoy restaurando nuestras fotos familiares antiguas en STEOS: en un minuto recuperan el color y la nitidez. Envíame las que quieras renovar o pruébalo tú.",
  "Кто хотел кружок голосом любимого героя? В STEOS пишешь текст, и персонаж из игры или сериала его произносит. Это бот в Telegram.": "¿Quién quería un videomensaje con la voz de su héroe favorito? En STEOS escribes un texto y un personaje de un juego o una serie lo dice. Es un bot de Telegram.",
  "Фото товара, карточки с преимуществами и описания для маркетплейсов делаю в STEOS за пару минут, без студии и дизайнера. Может, и вам пригодится.": "Hago fotos de producto, tarjetas con ventajas y descripciones para marketplaces en STEOS en un par de minutos, sin estudio ni diseñador. Quizá también os sirva.",
  "Озвучиваю ролики своим клоном голоса, снимаюсь в рилсах по готовым шаблонам и записываю каверы. Всё в одном боте STEOS в Telegram.": "Pongo voz a mis vídeos con mi clon de voz, protagonizo reels con plantillas listas y grabo covers. Todo en un solo bot de STEOS en Telegram.",
  "По моей ссылке +{0} C на старт.": "Con mi enlace tienes +{0} C para empezar.",
  "По моей ссылке +{0} C и −{1}% на первый пакет.": "Con mi enlace: +{0} C y −{1}% en el primer paquete.",
  "Попробуй сам.": "Pruébalo.",
  "Попробуйте сами.": "Pruébalo tú mismo.",
  "Актёры": "Actores",
  "Персонажи и актёры": "Personajes y actores",
  "По запросу «{q}» голосов нет. Попробуйте другое слово или загляните в подборки": "No hay voces para «{q}». Prueba otra palabra o mira las colecciones",
  "Здесь пока нет голосов. Загляните в другие вкладки или подборки": "Aún no hay voces aquí. Mira las otras pestañas o colecciones",
  "Голос вернётся на экран создания": "La voz vuelve a la pantalla de creación",
  "После выбора пишите текст для озвучки в чат бота": "Después, envía el texto a locutar al chat del bot",
  "От Я до А": "De la Z a la A",
  "Сортировка и фильтры": "Orden y filtros",
  "Сбросить": "Restablecer",
  "Чаще всего выбирают": "Los más elegidos",
  "Сначала свежие": "Primero los nuevos",
  "Сначала давние": "Primero los antiguos",
  "Сначала недорогие": "Primero los más baratos",
  "Сначала короткие ролики": "Primero los vídeos cortos",
  "По названию": "Por nombre",
  "По названию, с конца алфавита": "Por nombre, desde el final del alfabeto",
  "Вертикальные ролики": "Vídeos verticales",
  "Картинки и посты": "Imágenes y publicaciones",
  "Горизонтальные ролики": "Vídeos horizontales",
  "Видеосообщения Telegram": "Videomensajes de Telegram",
  "Один человек в кадре": "Una persona en el plano",
  "Трое и больше": "Tres o más",
  "С ребёнком": "Con un niño",
  "С питомцем": "Con una mascota",
  "Двое человек в кадре": "Dos personas en el plano",
  "О разделе": "Acerca de",
  "Превращает текст в речь: голос из каталога или ваш клон, настройки интонации и скорости.": "Convierte texto en voz: una voz del catálogo o tu clon, con ajustes de entonación y velocidad.",
  "Копия вашего голоса по записи: ею можно озвучивать любые тексты.": "Una copia de tu voz a partir de una grabación: úsala para dar voz a cualquier texto.",
  "AI-студия: ролики, фото, кружки и другие шаблоны с вами, близкими и персонажами.": "Estudio de IA: vídeos, fotos, círculos y otras plantillas contigo, tus seres queridos y personajes.",
  "Кредиты (C) на счёте и пополнение. Кредиты списываются за озвучку и заказы студии.": "Créditos (C) en tu cuenta y recargas. Los créditos se gastan en locuciones y pedidos del estudio.",
  "Задания и награды: выполняйте задания и получайте кредиты.": "Tareas y recompensas: completa tareas y gana créditos.",
  "Все ваши озвучки и заказы студии: послушать, скачать или повторить.": "Todas tus locuciones y pedidos del estudio: escuchar, descargar o repetir.",
  "Ваш профиль и данные аккаунта.": "Tu perfil y los datos de tu cuenta.",
  "Настройки приложения: язык, валюта и уведомления.": "Ajustes de la app: idioma, moneda y notificaciones.",
  "Ответы на частые вопросы и связь с поддержкой.": "Respuestas a preguntas frecuentes y contacto con soporte.",
  "Партнёрская программа: приглашайте друзей и получайте процент с их пополнений.": "Programa de socios: invita a amigos y recibe un porcentaje de sus recargas.",
  "Озвучка больших текстов и сценариев по ролям.": "Locución de textos largos y guiones por roles.",
  "Вы или один близкий": "Tú o un ser querido",
  "Вы и близкий": "Tú y un ser querido",
  "Товары и места": "Productos y lugares",
  "Фото товара, блюда или места": "Foto de un producto, plato o lugar",
  "В избранном": "En favoritos",
  "Голоса и персонажи, которые вы отметили сердцем": "Voces y personajes que marcaste con un corazón",
  "Нажмите — выбрать голос": "Toca para elegir una voz",
  "Удерживайте — карточка голоса": "Mantén pulsado para ver la ficha",
  "Карточка голоса или персонажа": "Ficha de voz o personaje",
  "Нажмите на голос, чтобы выбрать его": "Toca una voz para elegirla",
  "Удерживайте, чтобы открыть карточку голоса": "Mantén pulsado para abrir la ficha de la voz",
  "Удаление голоса": "Eliminar la voz",
  "Подсказка": "Consejo",
  "Пример звучания пока недоступен. Попробуйте позже.": "La muestra aún no está disponible. Inténtalo más tarde.",
  "Языков: {0}": "Idiomas: {0}",
  "Ещё языков: {0}": "Más idiomas: {0}",
  "Ход примера": "Progreso de la muestra",
  "Голос говорит на {0} языках": "La voz habla {0} idiomas",
  "Все голоса мультиязычные и озвучат текст на любом языке системы.": "Todas las voces son multilingües y leen el texto en cualquier idioma del sistema.",
  "Голоса подборки": "Voces de la colección",
  "Удерживайте голос, чтобы открыть его": "Mantén pulsada una voz para abrirla",
  "Назад к голосу": "Volver a la voz",
  "Оригинал голоса говорил на {0} языке": "La voz original hablaba {0}",
  "Происхождение: {0}. Подробнее": "Origen: {0}. Detalles",
  "Новый": "Nueva",
  "Официальный": "Oficial",
  "Актёр": "Actor",
  "Удерживайте, чтобы послушать": "Mantén pulsado para escuchar",
  "Удерживайте строку голоса или нажмите её правой кнопкой мыши, чтобы открыть карточку голоса. Персонаж открывается обычным нажатием.": "Mantén pulsada la fila de una voz o haz clic derecho para abrir su ficha. Un personaje se abre con un toque normal.",
  "Подборка · Голосов: {0}": "Colección · Voces: {0}",
  "Доступные голоса появятся в каталоге. Здесь можно будет прослушать пример и выбрать голос для бота.": "Las voces disponibles aparecerán en el catálogo. Aquí podrás escuchar una muestra y elegir una voz para el bot.",
  "Зажмите голос": "Mantén pulsada una voz",
  "Удерживайте строку голоса, чтобы открыть его карточку: прослушать и посмотреть подборки. Короткое нажатие выбирает голос.": "Mantén pulsada la fila de una voz para abrir su ficha: escucharla y ver sus colecciones. Un toque corto elige la voz.",
  "Нажмите на аватарку": "Toca el avatar",
  "Круглая аватарка в строке проигрывает пример голоса. Нажмите ещё раз, чтобы остановить. Нажатие на саму строку выбирает голос.": "El avatar redondo de la fila reproduce una muestra de la voz. Tócalo de nuevo para detenerla. Tocar la fila elige la voz.",
  "Сохраняйте в избранное": "Guarda en favoritos",
  "Нажмите сердце в карточке голоса или персонажа — они соберутся в подборке «Избранное», первой в «Подборках» и на «Рекомендуем». Нажмите ещё раз, чтобы убрать.": "Toca el corazón en la ficha de una voz o personaje: se reunirán en la colección «Favoritos», la primera en «Colecciones» y en «Recomendados». Toca de nuevo para quitar.",
  "Запишите свой голос": "Graba tu voz",
  "30 секунд речи или пара файлов, и через две минуты ваш голос появится во всех инструментах с озвучкой. Нажмите «Записать» и читайте текст с экрана.": "30 segundos de voz o un par de archivos, y en dos minutos tu voz aparecerá en todas las herramientas con locución. Toca «Grabar» y lee el texto de la pantalla.",
  "Читать полностью": "Leer más",
  "Голос STEOS": "Voz de STEOS",
  "Назад к персонажу": "Volver al personaje",
  "Назад к списку": "Volver a la lista",
  "Актёр STEOS": "Actor de STEOS",
  "Персонаж STEOS": "Personaje de STEOS",
  "Об актёре": "Sobre el actor",
  "О персонаже": "Sobre el personaje",
  "Голоса актёра": "Voces del actor",
  "Голоса персонажа": "Voces del personaje",
  "шапка: Мой голос": "Mi voz",
  "Пример голоса «{0}»": "Muestra de la voz «{0}»",
  "Ещё языки": "Más idiomas",
  "Юзеры": "Usuarios",
  "Лайки": "Me gusta",
  "Пол": "Género",
  "В каталоге с": "En el catálogo desde",
  "Автор": "Autor",
  "Откуда": "De",
  "Характер": "Carácter",
  "Голосов": "Voces",
  "Мужской": "Masculina",
  "Женский": "Femenina",
  "Детский": "Infantil",
  "Не указан": "No indicado",
  "Голос персонажа": "Voz del personaje",
  "Выберите поддерживаемый аудиофайл до {0} МБ.": "Elige un archivo de audio compatible de hasta {0} MB.",
  "пол: Детский": "Infantil",
  "Состав подборки": "Contenido de la colección",
  "Закрыть выбор голоса": "Cerrar la selección de voz",
  "Не удалось открыть запись для прослушивания.": "No se pudo abrir la grabación para escucharla.",
  "Использовать готовую запись": "Usar una grabación ya hecha",
  "Подтвердите права на материалы, чтобы взять запись.": "Confirma tus derechos sobre los materiales para usar la grabación.",
  "Работа из доната": "Trabajo de una donación",
  "Модель синтеза": "Modelo de síntesis",
  "Новая модель": "Modelo nuevo",
  "Прежняя модель": "Modelo anterior",
  "Удерживайте — карточка голоса и модель синтеза": "Mantén pulsado: ficha de la voz y modelo de síntesis",
  "Модель для озвучки в чате": "Modelo para la locución en el chat",
  "Новая модель: эмоции и живая интонация, вопросы, много языков, клоны голоса": "Modelo nuevo: emociones y entonación natural, preguntas, muchos idiomas, clones de voz",
  "Прежняя модель: только пять языков, без эмоций и вопросительной интонации, без клонов": "Modelo anterior: solo cinco idiomas, sin emociones ni entonación interrogativa, sin clones",
  "Активная модель: STEOS Voice": "Modelo activo: STEOS Voice",
  "Активная модель:": "Modelo activo:",
  "Новая модель: 19 языков, естественное звучание с живыми интонациями — без металла и роботизированности, качественное клонирование голоса": "Modelo nuevo: 19 idiomas, sonido natural con entonación viva, sin timbre metálico ni robótico, clonación de voz de calidad",
  "Прежняя модель: только 5 языков, без эмоций и вопросительной интонации, без клонов голоса": "Modelo anterior: solo 5 idiomas, sin emociones ni entonación interrogativa, sin clones de voz",
  "На модели STEOS Voice {0} все голоса мультиязычные и озвучат текст на любом из этих языков.": "En el modelo STEOS Voice {0} todas las voces son multilingües y locutarán el texto en cualquiera de estos idiomas.",
  "На модели STEOS Voice {0} все голоса мультиязычные и озвучат текст на любом из {1}.": "En el modelo STEOS Voice {0} todas las voces son multilingües y locutarán el texto en cualquiera de {1}.",
  "этих языков": "estos idiomas",
  "Языки озвучки": "Idiomas de locución",
  "Любой голос на модели STEOS Voice {0} озвучит текст на каждом из этих языков": "Cualquier voz del modelo STEOS Voice {0} locutará el texto en cada uno de estos idiomas",
  "Все голоса": "Todas las voces",
  "Озвучка текста и переозвучка": "Texto a voz y cambio de voz",
  "Переозвучка записи": "Cambio de voz en grabación",
  "Меняют голос в вашей записи": "Cambian la voz de tu grabación",
  "Выберите голос для переозвучки записи": "Elige una voz para cambiar la voz de tu grabación",
  "Голос выбран — вернитесь в чат и нажмите «Продолжить переозвучку»": "Voz elegida: vuelve al chat y pulsa «Continuar el cambio de voz»"
}
